/* tslint:disable */
import globalAxios from 'axios';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, createRequestFunction, serializeDataIfNeeded, setApiKeyToObject, setSearchParams, toPathString, } from './common';
export const ModelBillingCloseoutOrderType = {
    BillingCloseoutOrderTypeRollOff: 'roll-off',
    BillingCloseoutOrderTypeSiteService: 'site-service',
    BillingCloseoutOrderTypeCommercial: 'commercial',
};
export const ModelBillingCloseoutReviewStatus = {
    BillingCloseoutReviewStatusProcessing: 'PROCESSING',
    BillingCloseoutReviewStatusPartial: 'PARTIAL',
    BillingCloseoutReviewStatusPending: 'PENDING',
    BillingCloseoutReviewStatusApproved: 'APPROVED',
    BillingCloseoutReviewStatusRejected: 'REJECTED',
    BillingCloseoutReviewStatusError: 'ERROR',
    BillingCloseoutReviewStatusNeedsReply: 'NEEDS_REPLY',
    BillingCloseoutReviewStatusNoMatch: 'NO_MATCH',
    BillingCloseoutReviewStatusNoAction: 'NO_ACTION',
    BillingCloseoutReviewStatusZendeskClosed: 'ZENDESK_CLOSED',
    BillingCloseoutReviewStatusAutoClosed: 'AUTO_CLOSED',
};
export const ModelBillingFrequency = {
    BillingFrequencyOneTime: 'ONE_TIME',
    BillingFrequencyHourly: 'HOURLY',
    BillingFrequencyWeekly: 'WEEKLY',
    BillingFrequencyBiWeekly: 'BI_WEEKLY',
    BillingFrequencyMonthly: 'MONTHLY',
    BillingFrequencyQuarterly: 'QUARTERLY',
    BillingFrequencyTwentyEightDays: '28_DAYS',
};
export const ModelBillingPeriodAutopayProcessorEnum = {
    Stripe: 'STRIPE',
    Rainforest: 'RAINFOREST',
    CustomerPaymentMethod: 'CUSTOMER_PAYMENT_METHOD',
};
export const ModelBillingType = {
    BillingTypeCreditCard: 'CREDIT_CARD',
    BillingTypeCash: 'CASH',
    BillingTypeACH: 'ACH',
    BillingTypeCheck: 'CHECK',
    BillingTypeWire: 'WIRE',
    BillingTypeRevenueShare: 'REVENUE_SHARE',
    BillingTypeAccountCredit: 'ACCOUNT_CREDIT',
};
export const ModelDumpTicketDateEvidenceSourceEnum = {
    ScaleTransaction: 'SCALE_TRANSACTION',
    OtherPrintedDate: 'OTHER_PRINTED_DATE',
    Unreadable: 'UNREADABLE',
};
export const ModelOrderRoStatus = {
    OrderRoStatusNeedsReview: 'NEEDS_REVIEW',
    OrderRoStatusUnassignedDelivery: 'UNASSIGNED_DELIVERY',
    OrderRoStatusAssignedDelivery: 'ASSIGNED_DELIVERY',
    OrderRoStatusEnrouteDelivery: 'ENROUTE_DELIVERY',
    OrderRoStatusDelivered: 'DELIVERED',
    OrderRoStatusUnassignedPickup: 'UNASSIGNED_PICKUP',
    OrderRoStatusAssignedPickup: 'ASSIGNED_PICKUP',
    OrderRoStatusEnroutePickup: 'ENROUTE_PICKUP',
    OrderRoStatusPickedUp: 'PICKED_UP',
    OrderRoStatusUnassignedDump: 'UNASSIGNED_DUMP',
    OrderRoStatusAssignedDump: 'ASSIGNED_DUMP',
    OrderRoStatusEnterTicket: 'ENTER_TICKET',
    OrderRoStatusDumped: 'DUMPED',
    OrderRoStatusCompleted: 'COMPLETED',
    OrderRoStatusCancelled: 'CANCELLED',
};
export const ModelSubscriptionAutopayProcessorEnum = {
    Stripe: 'STRIPE',
    Rainforest: 'RAINFOREST',
    CustomerPaymentMethod: 'CUSTOMER_PAYMENT_METHOD',
};
export const ModelTaskGroupEventStatus = {
    TaskGroupEventStatusSuccess: 'SUCCESS',
    TaskGroupEventStatusIssue: 'ISSUE',
    TaskGroupEventStatusFailed: 'FAILED',
};
export const ModelTaskGroupEventType = {
    TaskGroupEventTypeDelivery: 'DELIVERY',
    TaskGroupEventTypePickup: 'PICKUP',
    TaskGroupEventTypeService: 'SERVICE',
    TaskGroupEventTypeEnRoute: 'EN_ROUTE',
};
export const ModelTaskRefType = {
    TaskRefTypePtLoo: 'ORDER_PT_LOO',
    TaskRefTypeComm: 'ORDER_COMMERCIAL',
    TaskRefTypeEqParamOption: 'EQ_PARAM_OPTION',
    TaskRefTypeRo: 'ORDER_RO',
};
export const ModelTaskStatus = {
    TaskStatusPending: 'PENDING',
    TaskStatusEnRoute: 'EN_ROUTE',
    TaskStatusInProgress: 'IN_PROGRESS',
    TaskStatusServicing: 'SERVICING',
    TaskStatusComplete: 'COMPLETE',
    TaskStatusCompleteWithIssues: 'COMPLETE_WITH_ISSUES',
    TaskStatusFailed: 'FAILED',
    TaskStatusCancelled: 'CANCELLED',
};
export const ModelTaskType = {
    DeliveryTask: 'DELIVERY',
    PickupTask: 'PICKUP',
    ServiceTask: 'SERVICE',
    DumpTask: 'DUMP',
    RelocateTask: 'RELOCATE',
};
export const OperationsServiceDomainModelWorkReqReqTypeEnum = {
    Delivery: 'DELIVERY',
    Pickup: 'PICKUP',
    Swap: 'SWAP',
    DumpAndReturn: 'DUMP_AND_RETURN',
};
export const OperationsServiceDomainModelWorkReqStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED',
};
export const PubliccheckoutServiceLine = {
    ServiceLineRollOff: 'ROLL_OFF',
    ServiceLineCommercial: 'COMMERCIAL',
    ServiceLinePtLoo: 'PT_LOO',
};
export const SubscriptionAdminSubscriptionCreateRequestAutopayProcessorEnum = {
    Stripe: 'STRIPE',
    Rainforest: 'RAINFOREST',
    CustomerPaymentMethod: 'CUSTOMER_PAYMENT_METHOD',
};
/**
 * AskLucApi - axios parameter creator
 */
export const AskLucApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns every AI conversation owned by the authenticated user, ordered by most recently updated.
         * @summary List Ask Luc conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsGet: async (options = {}) => {
            const localVarPath = `/operations/v1/ask-luc/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a conversation and all of its messages. Only the conversation owner can delete.
         * @summary Delete an Ask Luc conversation
         * @param {string} id Conversation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1AskLucConversationsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/ask-luc/conversations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the conversation record along with its full message history. System conversations (created by headless agents) are readable by any admin.
         * @summary Get an Ask Luc conversation with messages
         * @param {string} id Conversation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1AskLucConversationsIdGet', 'id', id);
            const localVarPath = `/operations/v1/ask-luc/conversations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posts a user message to the conversation and streams the assistant\'s response as Server-Sent Events (Content-Type: text/event-stream). The body content-type is application/json. Attachments are capped at 3 per message and ~10MB each raw (15MB base64).
         * @summary Send a message to an Ask Luc conversation (SSE stream)
         * @param {string} id Conversation ID
         * @param {ModelAskLucSendMessageRequest} body User message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdMessagesPost: async (id, body, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1AskLucConversationsIdMessagesPost', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('operationsV1AskLucConversationsIdMessagesPost', 'body', body);
            const localVarPath = `/operations/v1/ask-luc/conversations/{id}/messages`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/event-stream';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Renames a conversation. Only the owner can update.
         * @summary Update an Ask Luc conversation title
         * @param {string} id Conversation ID
         * @param {ModelAskLucUpdateConversationRequest} body New title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdPut: async (id, body, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1AskLucConversationsIdPut', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('operationsV1AskLucConversationsIdPut', 'body', body);
            const localVarPath = `/operations/v1/ask-luc/conversations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a fresh AI conversation owned by the authenticated user. The title is auto-generated from the first user message.
         * @summary Create a new Ask Luc conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsPost: async (options = {}) => {
            const localVarPath = `/operations/v1/ask-luc/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a multipart/form-data upload with an \"audio\" file field, forwards it to OpenAI\'s Whisper API (gpt-4o-transcribe), and returns the transcribed English text. Max file size is 25MB.
         * @summary Transcribe an audio file to text
         * @param {File} audio Audio file to transcribe (max 25MB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucTranscribePost: async (audio, options = {}) => {
            // verify required parameter 'audio' is not null or undefined
            assertParamExists('operationsV1AskLucTranscribePost', 'audio', audio);
            const localVarPath = `/operations/v1/ask-luc/transcribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (audio !== undefined) {
                localVarFormParams.append('audio', audio);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AskLucApi - functional programming interface
 */
export const AskLucApiFp = function (configuration) {
    const localVarAxiosParamCreator = AskLucApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns every AI conversation owned by the authenticated user, ordered by most recently updated.
         * @summary List Ask Luc conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AskLucConversationsGet(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AskLucConversationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskLucApi.operationsV1AskLucConversationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently deletes a conversation and all of its messages. Only the conversation owner can delete.
         * @summary Delete an Ask Luc conversation
         * @param {string} id Conversation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AskLucConversationsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AskLucConversationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskLucApi.operationsV1AskLucConversationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the conversation record along with its full message history. System conversations (created by headless agents) are readable by any admin.
         * @summary Get an Ask Luc conversation with messages
         * @param {string} id Conversation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AskLucConversationsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AskLucConversationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskLucApi.operationsV1AskLucConversationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Posts a user message to the conversation and streams the assistant\'s response as Server-Sent Events (Content-Type: text/event-stream). The body content-type is application/json. Attachments are capped at 3 per message and ~10MB each raw (15MB base64).
         * @summary Send a message to an Ask Luc conversation (SSE stream)
         * @param {string} id Conversation ID
         * @param {ModelAskLucSendMessageRequest} body User message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AskLucConversationsIdMessagesPost(id, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AskLucConversationsIdMessagesPost(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskLucApi.operationsV1AskLucConversationsIdMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Renames a conversation. Only the owner can update.
         * @summary Update an Ask Luc conversation title
         * @param {string} id Conversation ID
         * @param {ModelAskLucUpdateConversationRequest} body New title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AskLucConversationsIdPut(id, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AskLucConversationsIdPut(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskLucApi.operationsV1AskLucConversationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a fresh AI conversation owned by the authenticated user. The title is auto-generated from the first user message.
         * @summary Create a new Ask Luc conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AskLucConversationsPost(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AskLucConversationsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskLucApi.operationsV1AskLucConversationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts a multipart/form-data upload with an \"audio\" file field, forwards it to OpenAI\'s Whisper API (gpt-4o-transcribe), and returns the transcribed English text. Max file size is 25MB.
         * @summary Transcribe an audio file to text
         * @param {File} audio Audio file to transcribe (max 25MB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AskLucTranscribePost(audio, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AskLucTranscribePost(audio, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskLucApi.operationsV1AskLucTranscribePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AskLucApi - factory interface
 */
export const AskLucApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AskLucApiFp(configuration);
    return {
        /**
         * Returns every AI conversation owned by the authenticated user, ordered by most recently updated.
         * @summary List Ask Luc conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsGet(options) {
            return localVarFp.operationsV1AskLucConversationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a conversation and all of its messages. Only the conversation owner can delete.
         * @summary Delete an Ask Luc conversation
         * @param {AskLucApiOperationsV1AskLucConversationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1AskLucConversationsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns the conversation record along with its full message history. System conversations (created by headless agents) are readable by any admin.
         * @summary Get an Ask Luc conversation with messages
         * @param {AskLucApiOperationsV1AskLucConversationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdGet(requestParameters, options) {
            return localVarFp
                .operationsV1AskLucConversationsIdGet(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Posts a user message to the conversation and streams the assistant\'s response as Server-Sent Events (Content-Type: text/event-stream). The body content-type is application/json. Attachments are capped at 3 per message and ~10MB each raw (15MB base64).
         * @summary Send a message to an Ask Luc conversation (SSE stream)
         * @param {AskLucApiOperationsV1AskLucConversationsIdMessagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdMessagesPost(requestParameters, options) {
            return localVarFp
                .operationsV1AskLucConversationsIdMessagesPost(requestParameters.id, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Renames a conversation. Only the owner can update.
         * @summary Update an Ask Luc conversation title
         * @param {AskLucApiOperationsV1AskLucConversationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1AskLucConversationsIdPut(requestParameters.id, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a fresh AI conversation owned by the authenticated user. The title is auto-generated from the first user message.
         * @summary Create a new Ask Luc conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucConversationsPost(options) {
            return localVarFp.operationsV1AskLucConversationsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a multipart/form-data upload with an \"audio\" file field, forwards it to OpenAI\'s Whisper API (gpt-4o-transcribe), and returns the transcribed English text. Max file size is 25MB.
         * @summary Transcribe an audio file to text
         * @param {AskLucApiOperationsV1AskLucTranscribePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AskLucTranscribePost(requestParameters, options) {
            return localVarFp
                .operationsV1AskLucTranscribePost(requestParameters.audio, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AskLucApi - object-oriented interface
 */
export class AskLucApi extends BaseAPI {
    /**
     * Returns every AI conversation owned by the authenticated user, ordered by most recently updated.
     * @summary List Ask Luc conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AskLucConversationsGet(options) {
        return AskLucApiFp(this.configuration)
            .operationsV1AskLucConversationsGet(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Permanently deletes a conversation and all of its messages. Only the conversation owner can delete.
     * @summary Delete an Ask Luc conversation
     * @param {AskLucApiOperationsV1AskLucConversationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AskLucConversationsIdDelete(requestParameters, options) {
        return AskLucApiFp(this.configuration)
            .operationsV1AskLucConversationsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the conversation record along with its full message history. System conversations (created by headless agents) are readable by any admin.
     * @summary Get an Ask Luc conversation with messages
     * @param {AskLucApiOperationsV1AskLucConversationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AskLucConversationsIdGet(requestParameters, options) {
        return AskLucApiFp(this.configuration)
            .operationsV1AskLucConversationsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Posts a user message to the conversation and streams the assistant\'s response as Server-Sent Events (Content-Type: text/event-stream). The body content-type is application/json. Attachments are capped at 3 per message and ~10MB each raw (15MB base64).
     * @summary Send a message to an Ask Luc conversation (SSE stream)
     * @param {AskLucApiOperationsV1AskLucConversationsIdMessagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AskLucConversationsIdMessagesPost(requestParameters, options) {
        return AskLucApiFp(this.configuration)
            .operationsV1AskLucConversationsIdMessagesPost(requestParameters.id, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Renames a conversation. Only the owner can update.
     * @summary Update an Ask Luc conversation title
     * @param {AskLucApiOperationsV1AskLucConversationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AskLucConversationsIdPut(requestParameters, options) {
        return AskLucApiFp(this.configuration)
            .operationsV1AskLucConversationsIdPut(requestParameters.id, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a fresh AI conversation owned by the authenticated user. The title is auto-generated from the first user message.
     * @summary Create a new Ask Luc conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AskLucConversationsPost(options) {
        return AskLucApiFp(this.configuration)
            .operationsV1AskLucConversationsPost(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Accepts a multipart/form-data upload with an \"audio\" file field, forwards it to OpenAI\'s Whisper API (gpt-4o-transcribe), and returns the transcribed English text. Max file size is 25MB.
     * @summary Transcribe an audio file to text
     * @param {AskLucApiOperationsV1AskLucTranscribePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AskLucTranscribePost(requestParameters, options) {
        return AskLucApiFp(this.configuration)
            .operationsV1AskLucTranscribePost(requestParameters.audio, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuditLogsApi - axios parameter creator
 */
export const AuditLogsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a list of audit logs with optional filtering and sorting
         * @summary List audit logs
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [sortBy] Sort by field
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {string} [id] Filter by ID
         * @param {string} [actionType] Filter by action type
         * @param {string} [tableName] Filter by table name
         * @param {string} [profileId] Filter by profile ID
         * @param {string} [search] Search in old_data and new_data columns (case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AuditLogsGet: async (limit, offset, sortBy, sortDir, id, actionType, tableName, profileId, search, options = {}) => {
            const localVarPath = `/operations/v1/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }
            if (tableName !== undefined) {
                localVarQueryParameter['tableName'] = tableName;
            }
            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuditLogsApi - functional programming interface
 */
export const AuditLogsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuditLogsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a list of audit logs with optional filtering and sorting
         * @summary List audit logs
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [sortBy] Sort by field
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {string} [id] Filter by ID
         * @param {string} [actionType] Filter by action type
         * @param {string} [tableName] Filter by table name
         * @param {string} [profileId] Filter by profile ID
         * @param {string} [search] Search in old_data and new_data columns (case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1AuditLogsGet(limit, offset, sortBy, sortDir, id, actionType, tableName, profileId, search, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1AuditLogsGet(limit, offset, sortBy, sortDir, id, actionType, tableName, profileId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogsApi.operationsV1AuditLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AuditLogsApi - factory interface
 */
export const AuditLogsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuditLogsApiFp(configuration);
    return {
        /**
         * Get a list of audit logs with optional filtering and sorting
         * @summary List audit logs
         * @param {AuditLogsApiOperationsV1AuditLogsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1AuditLogsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1AuditLogsGet(requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, requestParameters.id, requestParameters.actionType, requestParameters.tableName, requestParameters.profileId, requestParameters.search, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuditLogsApi - object-oriented interface
 */
export class AuditLogsApi extends BaseAPI {
    /**
     * Get a list of audit logs with optional filtering and sorting
     * @summary List audit logs
     * @param {AuditLogsApiOperationsV1AuditLogsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1AuditLogsGet(requestParameters = {}, options) {
        return AuditLogsApiFp(this.configuration)
            .operationsV1AuditLogsGet(requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, requestParameters.id, requestParameters.actionType, requestParameters.tableName, requestParameters.profileId, requestParameters.search, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BillingCloseoutApi - axios parameter creator
 */
export const BillingCloseoutApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns billing closeout reviews with optional status filter and pagination.
         * @summary List billing closeout reviews
         * @param {string} [status] Filter by status (PROCESSING, PARTIAL, PENDING, NEEDS_REPLY, NO_MATCH, ERROR, APPROVED, REJECTED, NO_ACTION, ZENDESK_CLOSED)
         * @param {string} [zendeskTicketId] Filter to all reviews linked to this Zendesk ticket ID (ignores status filter)
         * @param {number} [limit] Number of items to return (default 20)
         * @param {number} [offset] Number of items to skip (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutGet: async (status, zendeskTicketId, limit, offset, options = {}) => {
            const localVarPath = `/operations/v1/billing-closeout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (zendeskTicketId !== undefined) {
                localVarQueryParameter['zendeskTicketId'] = zendeskTicketId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new PENDING review linked to the same Zendesk ticket(s) as {id}, pre-filled with the shared invoice metadata, for an order the AI missed on a multi-order invoice.
         * @summary Add a review for another order on this ticket
         * @param {string} id Source Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdAddSiblingPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdAddSiblingPost', 'id', id);
            const localVarPath = `/operations/v1/billing-closeout/{id}/add-sibling`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets ai_feedback (+ ai_feedback_by/at) — the reviewer\'s explanation of why the AI\'s classification/outcome was wrong (or right). An empty string clears any existing feedback.
         * @summary Leave free-text feedback on a billing closeout review\'s AI output
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutAIFeedbackRequest} body AI feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdAiFeedbackPut: async (id, body, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdAiFeedbackPut', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdAiFeedbackPut', 'body', body);
            const localVarPath = `/operations/v1/billing-closeout/{id}/ai-feedback`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets human_classification (+ confirmed_by/at) — the ground-truth signal vs the AI\'s ai_classification.
         * @summary Confirm or correct a billing closeout review\'s classification
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutClassificationRequest} body Classification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdClassificationPut: async (id, body, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdClassificationPut', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdClassificationPut', 'body', body);
            const localVarPath = `/operations/v1/billing-closeout/{id}/classification`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a disposition (NO_ACTION/ORDER_CLOSED_OUT/BILLING_HANDLED/PAYABLE_ACCEPTED/PAYABLE_DISPUTED), enforces the safeguard, records it, and solves the linked Zendesk ticket.
         * @summary Mark a billing closeout review done with a disposition
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutMarkDoneRequest} body Disposition payload (set keepTicketOpen to leave the Zendesk ticket unsolved)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdDonePost: async (id, body, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdDonePost', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdDonePost', 'body', body);
            const localVarPath = `/operations/v1/billing-closeout/{id}/done`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a single billing closeout review along with its associated Zendesk tickets.
         * @summary Get a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdGet', 'id', id);
            const localVarPath = `/operations/v1/billing-closeout/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the caller\'s presence row. Called when the review detail page unmounts. Presence also self-expires via TTL.
         * @summary Clear reviewer presence on a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdHeartbeatDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdHeartbeatDelete', 'id', id);
            const localVarPath = `/operations/v1/billing-closeout/{id}/heartbeat`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upserts the caller\'s presence (advisory, self-expiring). Called on open and on an interval by the review detail page.
         * @summary Record reviewer presence on a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdHeartbeatPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdHeartbeatPost', 'id', id);
            const localVarPath = `/operations/v1/billing-closeout/{id}/heartbeat`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the matched order/subscription. If the review was in PENDING or PARTIAL, it transitions back to NO_MATCH.
         * @summary Clear the match on a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdMatchDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdMatchDelete', 'id', id);
            const localVarPath = `/operations/v1/billing-closeout/{id}/match`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the matched order/subscription on the review. If the review was in NEEDS_REPLY, NO_MATCH or ERROR status, it transitions to PENDING so the reviewer can close it out. Either orderID or subscriptionID must be provided.
         * @summary Match a billing closeout review to an order or subscription
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutMatchRequest} match Match request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdMatchPut: async (id, match, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdMatchPut', 'id', id);
            // verify required parameter 'match' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdMatchPut', 'match', match);
            const localVarPath = `/operations/v1/billing-closeout/{id}/match`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(match, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-enqueues a review that is in NO_MATCH or ERROR status for another extraction attempt.
         * @summary Retry a failed billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdRetryPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdRetryPost', 'id', id);
            const localVarPath = `/operations/v1/billing-closeout/{id}/retry`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the linked Zendesk ticket\'s subject + full comment thread (plain text) live from Zendesk. Read-only.
         * @summary Get a Zendesk ticket\'s comment thread for a billing closeout review
         * @param {string} id Review ID
         * @param {string} ticketId Zendesk Ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet: async (id, ticketId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet', 'id', id);
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet', 'ticketId', ticketId);
            const localVarPath = `/operations/v1/billing-closeout/{id}/tickets/{ticketId}/comments`
                .replace('{id}', encodeURIComponent(String(id)))
                .replace('{ticketId}', encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Emits the oldest un-processed new Zendesk tickets from the billing view to fill the queue to 50 open tickets. Returns 409 if a batch is still processing.
         * @summary Top up the billing closeout queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutTopUpPost: async (options = {}) => {
            const localVarPath = `/operations/v1/billing-closeout/top-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns open-ticket count, in-flight processing count, target, need, and whether the top-up button should be enabled.
         * @summary Billing closeout queue top-up status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutTopUpStatusGet: async (options = {}) => {
            const localVarPath = `/operations/v1/billing-closeout/top-up-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receives Zendesk webhook events for new billing closeout tickets. Authenticated via HMAC-SHA256 signature in the X-Zendesk-Webhook-Signature header (not Bearer). Always returns 200 to prevent Zendesk retries — errors are logged internally.
         * @summary Zendesk webhook for billing closeout
         * @param {string} xZendeskWebhookSignature base64(HMAC-SHA256(timestamp || body))
         * @param {string} xZendeskWebhookSignatureTimestamp ISO 8601 timestamp used in the HMAC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WebhooksZendeskBillingPost: async (xZendeskWebhookSignature, xZendeskWebhookSignatureTimestamp, options = {}) => {
            // verify required parameter 'xZendeskWebhookSignature' is not null or undefined
            assertParamExists('operationsV1WebhooksZendeskBillingPost', 'xZendeskWebhookSignature', xZendeskWebhookSignature);
            // verify required parameter 'xZendeskWebhookSignatureTimestamp' is not null or undefined
            assertParamExists('operationsV1WebhooksZendeskBillingPost', 'xZendeskWebhookSignatureTimestamp', xZendeskWebhookSignatureTimestamp);
            const localVarPath = `/operations/v1/webhooks/zendesk-billing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xZendeskWebhookSignature != null) {
                localVarHeaderParameter['X-Zendesk-Webhook-Signature'] = String(xZendeskWebhookSignature);
            }
            if (xZendeskWebhookSignatureTimestamp != null) {
                localVarHeaderParameter['X-Zendesk-Webhook-Signature-Timestamp'] = String(xZendeskWebhookSignatureTimestamp);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BillingCloseoutApi - functional programming interface
 */
export const BillingCloseoutApiFp = function (configuration) {
    const localVarAxiosParamCreator = BillingCloseoutApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns billing closeout reviews with optional status filter and pagination.
         * @summary List billing closeout reviews
         * @param {string} [status] Filter by status (PROCESSING, PARTIAL, PENDING, NEEDS_REPLY, NO_MATCH, ERROR, APPROVED, REJECTED, NO_ACTION, ZENDESK_CLOSED)
         * @param {string} [zendeskTicketId] Filter to all reviews linked to this Zendesk ticket ID (ignores status filter)
         * @param {number} [limit] Number of items to return (default 20)
         * @param {number} [offset] Number of items to skip (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutGet(status, zendeskTicketId, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutGet(status, zendeskTicketId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new PENDING review linked to the same Zendesk ticket(s) as {id}, pre-filled with the shared invoice metadata, for an order the AI missed on a multi-order invoice.
         * @summary Add a review for another order on this ticket
         * @param {string} id Source Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdAddSiblingPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdAddSiblingPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdAddSiblingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets ai_feedback (+ ai_feedback_by/at) — the reviewer\'s explanation of why the AI\'s classification/outcome was wrong (or right). An empty string clears any existing feedback.
         * @summary Leave free-text feedback on a billing closeout review\'s AI output
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutAIFeedbackRequest} body AI feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdAiFeedbackPut(id, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdAiFeedbackPut(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdAiFeedbackPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets human_classification (+ confirmed_by/at) — the ground-truth signal vs the AI\'s ai_classification.
         * @summary Confirm or correct a billing closeout review\'s classification
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutClassificationRequest} body Classification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdClassificationPut(id, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdClassificationPut(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdClassificationPut']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies a disposition (NO_ACTION/ORDER_CLOSED_OUT/BILLING_HANDLED/PAYABLE_ACCEPTED/PAYABLE_DISPUTED), enforces the safeguard, records it, and solves the linked Zendesk ticket.
         * @summary Mark a billing closeout review done with a disposition
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutMarkDoneRequest} body Disposition payload (set keepTicketOpen to leave the Zendesk ticket unsolved)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdDonePost(id, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdDonePost(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdDonePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a single billing closeout review along with its associated Zendesk tickets.
         * @summary Get a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the caller\'s presence row. Called when the review detail page unmounts. Presence also self-expires via TTL.
         * @summary Clear reviewer presence on a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdHeartbeatDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdHeartbeatDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdHeartbeatDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upserts the caller\'s presence (advisory, self-expiring). Called on open and on an interval by the review detail page.
         * @summary Record reviewer presence on a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdHeartbeatPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdHeartbeatPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdHeartbeatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the matched order/subscription. If the review was in PENDING or PARTIAL, it transitions back to NO_MATCH.
         * @summary Clear the match on a billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdMatchDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdMatchDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdMatchDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets the matched order/subscription on the review. If the review was in NEEDS_REPLY, NO_MATCH or ERROR status, it transitions to PENDING so the reviewer can close it out. Either orderID or subscriptionID must be provided.
         * @summary Match a billing closeout review to an order or subscription
         * @param {string} id Review ID
         * @param {ModelBillingCloseoutMatchRequest} match Match request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdMatchPut(id, match, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdMatchPut(id, match, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdMatchPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-enqueues a review that is in NO_MATCH or ERROR status for another extraction attempt.
         * @summary Retry a failed billing closeout review
         * @param {string} id Review ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdRetryPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdRetryPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdRetryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the linked Zendesk ticket\'s subject + full comment thread (plain text) live from Zendesk. Read-only.
         * @summary Get a Zendesk ticket\'s comment thread for a billing closeout review
         * @param {string} id Review ID
         * @param {string} ticketId Zendesk Ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet(id, ticketId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet(id, ticketId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Emits the oldest un-processed new Zendesk tickets from the billing view to fill the queue to 50 open tickets. Returns 409 if a batch is still processing.
         * @summary Top up the billing closeout queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutTopUpPost(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutTopUpPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutTopUpPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns open-ticket count, in-flight processing count, target, need, and whether the top-up button should be enabled.
         * @summary Billing closeout queue top-up status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingCloseoutTopUpStatusGet(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingCloseoutTopUpStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1BillingCloseoutTopUpStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receives Zendesk webhook events for new billing closeout tickets. Authenticated via HMAC-SHA256 signature in the X-Zendesk-Webhook-Signature header (not Bearer). Always returns 200 to prevent Zendesk retries — errors are logged internally.
         * @summary Zendesk webhook for billing closeout
         * @param {string} xZendeskWebhookSignature base64(HMAC-SHA256(timestamp || body))
         * @param {string} xZendeskWebhookSignatureTimestamp ISO 8601 timestamp used in the HMAC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1WebhooksZendeskBillingPost(xZendeskWebhookSignature, xZendeskWebhookSignatureTimestamp, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1WebhooksZendeskBillingPost(xZendeskWebhookSignature, xZendeskWebhookSignatureTimestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingCloseoutApi.operationsV1WebhooksZendeskBillingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BillingCloseoutApi - factory interface
 */
export const BillingCloseoutApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BillingCloseoutApiFp(configuration);
    return {
        /**
         * Returns billing closeout reviews with optional status filter and pagination.
         * @summary List billing closeout reviews
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1BillingCloseoutGet(requestParameters.status, requestParameters.zendeskTicketId, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a new PENDING review linked to the same Zendesk ticket(s) as {id}, pre-filled with the shared invoice metadata, for an order the AI missed on a multi-order invoice.
         * @summary Add a review for another order on this ticket
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdAddSiblingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdAddSiblingPost(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdAddSiblingPost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets ai_feedback (+ ai_feedback_by/at) — the reviewer\'s explanation of why the AI\'s classification/outcome was wrong (or right). An empty string clears any existing feedback.
         * @summary Leave free-text feedback on a billing closeout review\'s AI output
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdAiFeedbackPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdAiFeedbackPut(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdAiFeedbackPut(requestParameters.id, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets human_classification (+ confirmed_by/at) — the ground-truth signal vs the AI\'s ai_classification.
         * @summary Confirm or correct a billing closeout review\'s classification
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdClassificationPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdClassificationPut(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdClassificationPut(requestParameters.id, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Applies a disposition (NO_ACTION/ORDER_CLOSED_OUT/BILLING_HANDLED/PAYABLE_ACCEPTED/PAYABLE_DISPUTED), enforces the safeguard, records it, and solves the linked Zendesk ticket.
         * @summary Mark a billing closeout review done with a disposition
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdDonePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdDonePost(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdDonePost(requestParameters.id, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a single billing closeout review along with its associated Zendesk tickets.
         * @summary Get a billing closeout review
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdGet(requestParameters, options) {
            return localVarFp.operationsV1BillingCloseoutIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the caller\'s presence row. Called when the review detail page unmounts. Presence also self-expires via TTL.
         * @summary Clear reviewer presence on a billing closeout review
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdHeartbeatDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdHeartbeatDelete(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdHeartbeatDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Upserts the caller\'s presence (advisory, self-expiring). Called on open and on an interval by the review detail page.
         * @summary Record reviewer presence on a billing closeout review
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdHeartbeatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdHeartbeatPost(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdHeartbeatPost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Removes the matched order/subscription. If the review was in PENDING or PARTIAL, it transitions back to NO_MATCH.
         * @summary Clear the match on a billing closeout review
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdMatchDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdMatchDelete(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdMatchDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets the matched order/subscription on the review. If the review was in NEEDS_REPLY, NO_MATCH or ERROR status, it transitions to PENDING so the reviewer can close it out. Either orderID or subscriptionID must be provided.
         * @summary Match a billing closeout review to an order or subscription
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdMatchPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdMatchPut(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdMatchPut(requestParameters.id, requestParameters.match, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Re-enqueues a review that is in NO_MATCH or ERROR status for another extraction attempt.
         * @summary Retry a failed billing closeout review
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdRetryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdRetryPost(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdRetryPost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetches the linked Zendesk ticket\'s subject + full comment thread (plain text) live from Zendesk. Read-only.
         * @summary Get a Zendesk ticket\'s comment thread for a billing closeout review
         * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdTicketsTicketIdCommentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet(requestParameters, options) {
            return localVarFp
                .operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet(requestParameters.id, requestParameters.ticketId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Emits the oldest un-processed new Zendesk tickets from the billing view to fill the queue to 50 open tickets. Returns 409 if a batch is still processing.
         * @summary Top up the billing closeout queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutTopUpPost(options) {
            return localVarFp.operationsV1BillingCloseoutTopUpPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns open-ticket count, in-flight processing count, target, need, and whether the top-up button should be enabled.
         * @summary Billing closeout queue top-up status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingCloseoutTopUpStatusGet(options) {
            return localVarFp.operationsV1BillingCloseoutTopUpStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Receives Zendesk webhook events for new billing closeout tickets. Authenticated via HMAC-SHA256 signature in the X-Zendesk-Webhook-Signature header (not Bearer). Always returns 200 to prevent Zendesk retries — errors are logged internally.
         * @summary Zendesk webhook for billing closeout
         * @param {BillingCloseoutApiOperationsV1WebhooksZendeskBillingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WebhooksZendeskBillingPost(requestParameters, options) {
            return localVarFp
                .operationsV1WebhooksZendeskBillingPost(requestParameters.xZendeskWebhookSignature, requestParameters.xZendeskWebhookSignatureTimestamp, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillingCloseoutApi - object-oriented interface
 */
export class BillingCloseoutApi extends BaseAPI {
    /**
     * Returns billing closeout reviews with optional status filter and pagination.
     * @summary List billing closeout reviews
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutGet(requestParameters = {}, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutGet(requestParameters.status, requestParameters.zendeskTicketId, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new PENDING review linked to the same Zendesk ticket(s) as {id}, pre-filled with the shared invoice metadata, for an order the AI missed on a multi-order invoice.
     * @summary Add a review for another order on this ticket
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdAddSiblingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdAddSiblingPost(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdAddSiblingPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets ai_feedback (+ ai_feedback_by/at) — the reviewer\'s explanation of why the AI\'s classification/outcome was wrong (or right). An empty string clears any existing feedback.
     * @summary Leave free-text feedback on a billing closeout review\'s AI output
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdAiFeedbackPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdAiFeedbackPut(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdAiFeedbackPut(requestParameters.id, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets human_classification (+ confirmed_by/at) — the ground-truth signal vs the AI\'s ai_classification.
     * @summary Confirm or correct a billing closeout review\'s classification
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdClassificationPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdClassificationPut(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdClassificationPut(requestParameters.id, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Applies a disposition (NO_ACTION/ORDER_CLOSED_OUT/BILLING_HANDLED/PAYABLE_ACCEPTED/PAYABLE_DISPUTED), enforces the safeguard, records it, and solves the linked Zendesk ticket.
     * @summary Mark a billing closeout review done with a disposition
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdDonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdDonePost(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdDonePost(requestParameters.id, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a single billing closeout review along with its associated Zendesk tickets.
     * @summary Get a billing closeout review
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdGet(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the caller\'s presence row. Called when the review detail page unmounts. Presence also self-expires via TTL.
     * @summary Clear reviewer presence on a billing closeout review
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdHeartbeatDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdHeartbeatDelete(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdHeartbeatDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upserts the caller\'s presence (advisory, self-expiring). Called on open and on an interval by the review detail page.
     * @summary Record reviewer presence on a billing closeout review
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdHeartbeatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdHeartbeatPost(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdHeartbeatPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes the matched order/subscription. If the review was in PENDING or PARTIAL, it transitions back to NO_MATCH.
     * @summary Clear the match on a billing closeout review
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdMatchDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdMatchDelete(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdMatchDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets the matched order/subscription on the review. If the review was in NEEDS_REPLY, NO_MATCH or ERROR status, it transitions to PENDING so the reviewer can close it out. Either orderID or subscriptionID must be provided.
     * @summary Match a billing closeout review to an order or subscription
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdMatchPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdMatchPut(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdMatchPut(requestParameters.id, requestParameters.match, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Re-enqueues a review that is in NO_MATCH or ERROR status for another extraction attempt.
     * @summary Retry a failed billing closeout review
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdRetryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdRetryPost(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdRetryPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetches the linked Zendesk ticket\'s subject + full comment thread (plain text) live from Zendesk. Read-only.
     * @summary Get a Zendesk ticket\'s comment thread for a billing closeout review
     * @param {BillingCloseoutApiOperationsV1BillingCloseoutIdTicketsTicketIdCommentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutIdTicketsTicketIdCommentsGet(requestParameters.id, requestParameters.ticketId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Emits the oldest un-processed new Zendesk tickets from the billing view to fill the queue to 50 open tickets. Returns 409 if a batch is still processing.
     * @summary Top up the billing closeout queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutTopUpPost(options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutTopUpPost(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns open-ticket count, in-flight processing count, target, need, and whether the top-up button should be enabled.
     * @summary Billing closeout queue top-up status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingCloseoutTopUpStatusGet(options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1BillingCloseoutTopUpStatusGet(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Receives Zendesk webhook events for new billing closeout tickets. Authenticated via HMAC-SHA256 signature in the X-Zendesk-Webhook-Signature header (not Bearer). Always returns 200 to prevent Zendesk retries — errors are logged internally.
     * @summary Zendesk webhook for billing closeout
     * @param {BillingCloseoutApiOperationsV1WebhooksZendeskBillingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1WebhooksZendeskBillingPost(requestParameters, options) {
        return BillingCloseoutApiFp(this.configuration)
            .operationsV1WebhooksZendeskBillingPost(requestParameters.xZendeskWebhookSignature, requestParameters.xZendeskWebhookSignatureTimestamp, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BillingPeriodsApi - axios parameter creator
 */
export const BillingPeriodsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Count of billing periods for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by billing-period start). serviceLine selects the order-type join (COMMERCIAL today). Powers SourScore\'s billing-accuracy denominator (serviceLine=COMMERCIAL, status=INVOICED, a vendorID).
         * @summary Count billing periods for a service line
         * @param {string} serviceLine Service line (COMMERCIAL)
         * @param {string} [vendorID] Servicing vendor ID (uuid) to scope to
         * @param {string} [status] Billing period status filter (e.g. INVOICED)
         * @param {string} [fromDate] Window start (RFC3339 or yyyy-MM-dd)
         * @param {string} [toDate] Window end (RFC3339 or yyyy-MM-dd)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsCountGet: async (serviceLine, vendorID, status, fromDate, toDate, options = {}) => {
            // verify required parameter 'serviceLine' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsCountGet', 'serviceLine', serviceLine);
            const localVarPath = `/operations/v1/billing-periods/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (serviceLine !== undefined) {
                localVarQueryParameter['serviceLine'] = serviceLine;
            }
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all billing periods including future ones if includeFuture is true
         * @summary List billing periods
         * @param {string} [fromDate] Filter by start date (YYYY-MM-DD format)
         * @param {string} [toDate] Filter by end date (YYYY-MM-DD format)
         * @param {boolean} [includeFuture] Include future billing periods
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [id] Filter by billing period ID (comma separated)
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1BillingPeriodsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsGet: async (fromDate, toDate, includeFuture, subscriptionID, id, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/billing-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (includeFuture !== undefined) {
                localVarQueryParameter['includeFuture'] = includeFuture;
            }
            if (subscriptionID !== undefined) {
                localVarQueryParameter['subscriptionID'] = subscriptionID;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = '*/*';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a billing period by ID
         * @summary Delete a billing period
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/billing-periods/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a billing period by its ID
         * @summary Get billing period by ID
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdGet', 'id', id);
            const localVarPath = `/operations/v1/billing-periods/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing billing period
         * @summary Update a billing period
         * @param {string} id Billing Period ID
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdPut: async (id, billingPeriod, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdPut', 'id', id);
            // verify required parameter 'billingPeriod' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsIdPut', 'billingPeriod', billingPeriod);
            const localVarPath = `/operations/v1/billing-periods/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(billingPeriod, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new billing period
         * @summary Create a new billing period
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsPost: async (billingPeriod, options = {}) => {
            // verify required parameter 'billingPeriod' is not null or undefined
            assertParamExists('operationsV1BillingPeriodsPost', 'billingPeriod', billingPeriod);
            const localVarPath = `/operations/v1/billing-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(billingPeriod, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BillingPeriodsApi - functional programming interface
 */
export const BillingPeriodsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BillingPeriodsApiAxiosParamCreator(configuration);
    return {
        /**
         * Count of billing periods for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by billing-period start). serviceLine selects the order-type join (COMMERCIAL today). Powers SourScore\'s billing-accuracy denominator (serviceLine=COMMERCIAL, status=INVOICED, a vendorID).
         * @summary Count billing periods for a service line
         * @param {string} serviceLine Service line (COMMERCIAL)
         * @param {string} [vendorID] Servicing vendor ID (uuid) to scope to
         * @param {string} [status] Billing period status filter (e.g. INVOICED)
         * @param {string} [fromDate] Window start (RFC3339 or yyyy-MM-dd)
         * @param {string} [toDate] Window end (RFC3339 or yyyy-MM-dd)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsCountGet(serviceLine, vendorID, status, fromDate, toDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsCountGet(serviceLine, vendorID, status, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all billing periods including future ones if includeFuture is true
         * @summary List billing periods
         * @param {string} [fromDate] Filter by start date (YYYY-MM-DD format)
         * @param {string} [toDate] Filter by end date (YYYY-MM-DD format)
         * @param {boolean} [includeFuture] Include future billing periods
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [id] Filter by billing period ID (comma separated)
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1BillingPeriodsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsGet(fromDate, toDate, includeFuture, subscriptionID, id, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsGet(fromDate, toDate, includeFuture, subscriptionID, id, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a billing period by ID
         * @summary Delete a billing period
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a billing period by its ID
         * @summary Get billing period by ID
         * @param {string} id Billing Period ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing billing period
         * @summary Update a billing period
         * @param {string} id Billing Period ID
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsIdPut(id, billingPeriod, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsIdPut(id, billingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new billing period
         * @summary Create a new billing period
         * @param {ModelBillingPeriod} billingPeriod Billing Period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1BillingPeriodsPost(billingPeriod, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1BillingPeriodsPost(billingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingPeriodsApi.operationsV1BillingPeriodsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BillingPeriodsApi - factory interface
 */
export const BillingPeriodsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BillingPeriodsApiFp(configuration);
    return {
        /**
         * Count of billing periods for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by billing-period start). serviceLine selects the order-type join (COMMERCIAL today). Powers SourScore\'s billing-accuracy denominator (serviceLine=COMMERCIAL, status=INVOICED, a vendorID).
         * @summary Count billing periods for a service line
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsCountGet(requestParameters, options) {
            return localVarFp
                .operationsV1BillingPeriodsCountGet(requestParameters.serviceLine, requestParameters.vendorID, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * List all billing periods including future ones if includeFuture is true
         * @summary List billing periods
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1BillingPeriodsGet(requestParameters.fromDate, requestParameters.toDate, requestParameters.includeFuture, requestParameters.subscriptionID, requestParameters.id, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a billing period by ID
         * @summary Delete a billing period
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1BillingPeriodsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a billing period by its ID
         * @summary Get billing period by ID
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdGet(requestParameters, options) {
            return localVarFp.operationsV1BillingPeriodsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing billing period
         * @summary Update a billing period
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1BillingPeriodsIdPut(requestParameters.id, requestParameters.billingPeriod, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new billing period
         * @summary Create a new billing period
         * @param {BillingPeriodsApiOperationsV1BillingPeriodsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1BillingPeriodsPost(requestParameters, options) {
            return localVarFp
                .operationsV1BillingPeriodsPost(requestParameters.billingPeriod, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillingPeriodsApi - object-oriented interface
 */
export class BillingPeriodsApi extends BaseAPI {
    /**
     * Count of billing periods for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by billing-period start). serviceLine selects the order-type join (COMMERCIAL today). Powers SourScore\'s billing-accuracy denominator (serviceLine=COMMERCIAL, status=INVOICED, a vendorID).
     * @summary Count billing periods for a service line
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingPeriodsCountGet(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsCountGet(requestParameters.serviceLine, requestParameters.vendorID, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * List all billing periods including future ones if includeFuture is true
     * @summary List billing periods
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingPeriodsGet(requestParameters = {}, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsGet(requestParameters.fromDate, requestParameters.toDate, requestParameters.includeFuture, requestParameters.subscriptionID, requestParameters.id, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a billing period by ID
     * @summary Delete a billing period
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingPeriodsIdDelete(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a billing period by its ID
     * @summary Get billing period by ID
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingPeriodsIdGet(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing billing period
     * @summary Update a billing period
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingPeriodsIdPut(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsIdPut(requestParameters.id, requestParameters.billingPeriod, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new billing period
     * @summary Create a new billing period
     * @param {BillingPeriodsApiOperationsV1BillingPeriodsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1BillingPeriodsPost(requestParameters, options) {
        return BillingPeriodsApiFp(this.configuration)
            .operationsV1BillingPeriodsPost(requestParameters.billingPeriod, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1BillingPeriodsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * CommercialLiftApi - axios parameter creator
 */
export const CommercialLiftApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Number of commercial lifts the vendor serviced over an optional window (SourScore denominator), derived from ord_comm service frequency.
         * @summary Derived commercial lift count for a vendor
         * @param {string} vendorID Servicing vendor ID (uuid)
         * @param {string} [windowStart] Window start (RFC3339 or yyyy-MM-dd); omit for lifetime
         * @param {string} [windowEnd] Window end (RFC3339 or yyyy-MM-dd); omit for now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1CommercialLiftCountGet: async (vendorID, windowStart, windowEnd, options = {}) => {
            // verify required parameter 'vendorID' is not null or undefined
            assertParamExists('operationsV1CommercialLiftCountGet', 'vendorID', vendorID);
            const localVarPath = `/operations/v1/commercial-lift-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (windowStart !== undefined) {
                localVarQueryParameter['windowStart'] = windowStart;
            }
            if (windowEnd !== undefined) {
                localVarQueryParameter['windowEnd'] = windowEnd;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CommercialLiftApi - functional programming interface
 */
export const CommercialLiftApiFp = function (configuration) {
    const localVarAxiosParamCreator = CommercialLiftApiAxiosParamCreator(configuration);
    return {
        /**
         * Number of commercial lifts the vendor serviced over an optional window (SourScore denominator), derived from ord_comm service frequency.
         * @summary Derived commercial lift count for a vendor
         * @param {string} vendorID Servicing vendor ID (uuid)
         * @param {string} [windowStart] Window start (RFC3339 or yyyy-MM-dd); omit for lifetime
         * @param {string} [windowEnd] Window end (RFC3339 or yyyy-MM-dd); omit for now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1CommercialLiftCountGet(vendorID, windowStart, windowEnd, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1CommercialLiftCountGet(vendorID, windowStart, windowEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommercialLiftApi.operationsV1CommercialLiftCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CommercialLiftApi - factory interface
 */
export const CommercialLiftApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CommercialLiftApiFp(configuration);
    return {
        /**
         * Number of commercial lifts the vendor serviced over an optional window (SourScore denominator), derived from ord_comm service frequency.
         * @summary Derived commercial lift count for a vendor
         * @param {CommercialLiftApiOperationsV1CommercialLiftCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1CommercialLiftCountGet(requestParameters, options) {
            return localVarFp
                .operationsV1CommercialLiftCountGet(requestParameters.vendorID, requestParameters.windowStart, requestParameters.windowEnd, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CommercialLiftApi - object-oriented interface
 */
export class CommercialLiftApi extends BaseAPI {
    /**
     * Number of commercial lifts the vendor serviced over an optional window (SourScore denominator), derived from ord_comm service frequency.
     * @summary Derived commercial lift count for a vendor
     * @param {CommercialLiftApiOperationsV1CommercialLiftCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1CommercialLiftCountGet(requestParameters, options) {
        return CommercialLiftApiFp(this.configuration)
            .operationsV1CommercialLiftCountGet(requestParameters.vendorID, requestParameters.windowStart, requestParameters.windowEnd, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CustomerMergeApi - axios parameter creator
 */
export const CustomerMergeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Reassigns selected (or all, when deleteFromCustomer=true) subscriptions
         * @summary Migrate subscriptions from one customer to another
         * @param {CustomermergeMergeCustomerRequest} body Merge request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1CustomerMergePost: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('operationsV1CustomerMergePost', 'body', body);
            const localVarPath = `/operations/v1/customer-merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CustomerMergeApi - functional programming interface
 */
export const CustomerMergeApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomerMergeApiAxiosParamCreator(configuration);
    return {
        /**
         * Reassigns selected (or all, when deleteFromCustomer=true) subscriptions
         * @summary Migrate subscriptions from one customer to another
         * @param {CustomermergeMergeCustomerRequest} body Merge request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1CustomerMergePost(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1CustomerMergePost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerMergeApi.operationsV1CustomerMergePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CustomerMergeApi - factory interface
 */
export const CustomerMergeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomerMergeApiFp(configuration);
    return {
        /**
         * Reassigns selected (or all, when deleteFromCustomer=true) subscriptions
         * @summary Migrate subscriptions from one customer to another
         * @param {CustomerMergeApiOperationsV1CustomerMergePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1CustomerMergePost(requestParameters, options) {
            return localVarFp.operationsV1CustomerMergePost(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomerMergeApi - object-oriented interface
 */
export class CustomerMergeApi extends BaseAPI {
    /**
     * Reassigns selected (or all, when deleteFromCustomer=true) subscriptions
     * @summary Migrate subscriptions from one customer to another
     * @param {CustomerMergeApiOperationsV1CustomerMergePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1CustomerMergePost(requestParameters, options) {
        return CustomerMergeApiFp(this.configuration)
            .operationsV1CustomerMergePost(requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocRefsApi - axios parameter creator
 */
export const DocRefsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {string} [id] Filter by doc ref ID
         * @param {string} [docsDocID] Filter by documents doc ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [reftype] Filter by ref type
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, docsDocID, refID, createdAt, lastUpdatedAt)
         * @param {OperationsV1DocRefsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsGet: async (id, docsDocID, refID, reftype, haulerID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/doc-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (docsDocID !== undefined) {
                localVarQueryParameter['docsDocID'] = docsDocID;
            }
            if (refID !== undefined) {
                localVarQueryParameter['refID'] = refID;
            }
            if (reftype !== undefined) {
                localVarQueryParameter['reftype'] = reftype;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocRefsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/doc-refs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocRefsIdGet', 'id', id);
            const localVarPath = `/operations/v1/doc-refs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {string} id Doc Ref ID
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdPut: async (id, docRef, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocRefsIdPut', 'id', id);
            // verify required parameter 'docRef' is not null or undefined
            assertParamExists('operationsV1DocRefsIdPut', 'docRef', docRef);
            const localVarPath = `/operations/v1/doc-refs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(docRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsPost: async (docRef, options = {}) => {
            // verify required parameter 'docRef' is not null or undefined
            assertParamExists('operationsV1DocRefsPost', 'docRef', docRef);
            const localVarPath = `/operations/v1/doc-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(docRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocRefsApi - functional programming interface
 */
export const DocRefsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocRefsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {string} [id] Filter by doc ref ID
         * @param {string} [docsDocID] Filter by documents doc ID
         * @param {string} [refID] Filter by ref ID
         * @param {string} [reftype] Filter by ref type
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, docsDocID, refID, createdAt, lastUpdatedAt)
         * @param {OperationsV1DocRefsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsGet(id, docsDocID, refID, reftype, haulerID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsGet(id, docsDocID, refID, reftype, haulerID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {string} id Doc Ref ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {string} id Doc Ref ID
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsIdPut(id, docRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsIdPut(id, docRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {OperationsServiceDomainModelDocRefs} docRef Doc Ref object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocRefsPost(docRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocRefsPost(docRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocRefsApi.operationsV1DocRefsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocRefsApi - factory interface
 */
export const DocRefsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocRefsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
         * @summary List all doc refs
         * @param {DocRefsApiOperationsV1DocRefsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1DocRefsGet(requestParameters.id, requestParameters.docsDocID, requestParameters.refID, requestParameters.reftype, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a doc ref from the system using its unique identifier
         * @summary Delete a doc ref
         * @param {DocRefsApiOperationsV1DocRefsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1DocRefsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single doc ref using its unique identifier
         * @summary Get a doc ref by ID
         * @param {DocRefsApiOperationsV1DocRefsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdGet(requestParameters, options) {
            return localVarFp.operationsV1DocRefsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing doc ref with the provided details
         * @summary Update a doc ref
         * @param {DocRefsApiOperationsV1DocRefsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1DocRefsIdPut(requestParameters.id, requestParameters.docRef, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new doc ref with the provided details
         * @summary Create a new doc ref
         * @param {DocRefsApiOperationsV1DocRefsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocRefsPost(requestParameters, options) {
            return localVarFp.operationsV1DocRefsPost(requestParameters.docRef, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocRefsApi - object-oriented interface
 */
export class DocRefsApi extends BaseAPI {
    /**
     * Retrieve a list of all doc refs with options to filter, sort, and paginate the results
     * @summary List all doc refs
     * @param {DocRefsApiOperationsV1DocRefsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocRefsGet(requestParameters = {}, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsGet(requestParameters.id, requestParameters.docsDocID, requestParameters.refID, requestParameters.reftype, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a doc ref from the system using its unique identifier
     * @summary Delete a doc ref
     * @param {DocRefsApiOperationsV1DocRefsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocRefsIdDelete(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single doc ref using its unique identifier
     * @summary Get a doc ref by ID
     * @param {DocRefsApiOperationsV1DocRefsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocRefsIdGet(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing doc ref with the provided details
     * @summary Update a doc ref
     * @param {DocRefsApiOperationsV1DocRefsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocRefsIdPut(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsIdPut(requestParameters.id, requestParameters.docRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new doc ref with the provided details
     * @summary Create a new doc ref
     * @param {DocRefsApiOperationsV1DocRefsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocRefsPost(requestParameters, options) {
        return DocRefsApiFp(this.configuration)
            .operationsV1DocRefsPost(requestParameters.docRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1DocRefsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * DocsApi - axios parameter creator
 */
export const DocsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {string} [checksum] Filter by content checksum (SHA256, base64)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsGet: async (refID, refType, checksum, limit, offset, sortBy, sortDir, options = {}) => {
            const localVarPath = `/operations/v1/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (refID !== undefined) {
                localVarQueryParameter['refID'] = refID;
            }
            if (refType !== undefined) {
                localVarQueryParameter['refType'] = refType;
            }
            if (checksum !== undefined) {
                localVarQueryParameter['checksum'] = checksum;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/docs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocsIdGet', 'id', id);
            const localVarPath = `/operations/v1/docs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {string} id Doc ID
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdPut: async (id, doc, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocsIdPut', 'id', id);
            // verify required parameter 'doc' is not null or undefined
            assertParamExists('operationsV1DocsIdPut', 'doc', doc);
            const localVarPath = `/operations/v1/docs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(doc, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the persisted structured result for an owned operations roll-off document, or extract and persist it when missing
         * @summary Read a roll-off dump ticket
         * @param {string} id Doc ID
         * @param {boolean} [force] Force a new extraction and replace the persisted result on success
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdReadDumpTicketPost: async (id, force, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1DocsIdReadDumpTicketPost', 'id', id);
            const localVarPath = `/operations/v1/docs/{id}/read-dump-ticket`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsPost: async (doc, options = {}) => {
            // verify required parameter 'doc' is not null or undefined
            assertParamExists('operationsV1DocsPost', 'doc', doc);
            const localVarPath = `/operations/v1/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(doc, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocsApi - functional programming interface
 */
export const DocsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {string} [refID] Filter by ref ID
         * @param {string} [refType] Filter by ref type
         * @param {string} [checksum] Filter by content checksum (SHA256, base64)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsGet(refID, refType, checksum, limit, offset, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsGet(refID, refType, checksum, limit, offset, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {string} id Doc ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {string} id Doc ID
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsIdPut(id, doc, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsIdPut(id, doc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the persisted structured result for an owned operations roll-off document, or extract and persist it when missing
         * @summary Read a roll-off dump ticket
         * @param {string} id Doc ID
         * @param {boolean} [force] Force a new extraction and replace the persisted result on success
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsIdReadDumpTicketPost(id, force, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsIdReadDumpTicketPost(id, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsIdReadDumpTicketPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {ModelDocument} doc Doc object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1DocsPost(doc, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1DocsPost(doc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocsApi.operationsV1DocsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocsApi - factory interface
 */
export const DocsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocsApiFp(configuration);
    return {
        /**
         * Get a list of documents with optional filtering and pagination
         * @summary List documents
         * @param {DocsApiOperationsV1DocsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1DocsGet(requestParameters.refID, requestParameters.refType, requestParameters.checksum, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a doc from the system using its unique identifier
         * @summary Delete a doc
         * @param {DocsApiOperationsV1DocsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1DocsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single doc using its unique identifier
         * @summary Get a doc by ID
         * @param {DocsApiOperationsV1DocsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdGet(requestParameters, options) {
            return localVarFp.operationsV1DocsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing doc with the provided details
         * @summary Update a doc
         * @param {DocsApiOperationsV1DocsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1DocsIdPut(requestParameters.id, requestParameters.doc, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Return the persisted structured result for an owned operations roll-off document, or extract and persist it when missing
         * @summary Read a roll-off dump ticket
         * @param {DocsApiOperationsV1DocsIdReadDumpTicketPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsIdReadDumpTicketPost(requestParameters, options) {
            return localVarFp
                .operationsV1DocsIdReadDumpTicketPost(requestParameters.id, requestParameters.force, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new doc with the provided details
         * @summary Create a new doc
         * @param {DocsApiOperationsV1DocsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1DocsPost(requestParameters, options) {
            return localVarFp.operationsV1DocsPost(requestParameters.doc, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocsApi - object-oriented interface
 */
export class DocsApi extends BaseAPI {
    /**
     * Get a list of documents with optional filtering and pagination
     * @summary List documents
     * @param {DocsApiOperationsV1DocsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocsGet(requestParameters = {}, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsGet(requestParameters.refID, requestParameters.refType, requestParameters.checksum, requestParameters.limit, requestParameters.offset, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a doc from the system using its unique identifier
     * @summary Delete a doc
     * @param {DocsApiOperationsV1DocsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocsIdDelete(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single doc using its unique identifier
     * @summary Get a doc by ID
     * @param {DocsApiOperationsV1DocsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocsIdGet(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing doc with the provided details
     * @summary Update a doc
     * @param {DocsApiOperationsV1DocsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocsIdPut(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsIdPut(requestParameters.id, requestParameters.doc, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return the persisted structured result for an owned operations roll-off document, or extract and persist it when missing
     * @summary Read a roll-off dump ticket
     * @param {DocsApiOperationsV1DocsIdReadDumpTicketPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocsIdReadDumpTicketPost(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsIdReadDumpTicketPost(requestParameters.id, requestParameters.force, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new doc with the provided details
     * @summary Create a new doc
     * @param {DocsApiOperationsV1DocsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1DocsPost(requestParameters, options) {
        return DocsApiFp(this.configuration)
            .operationsV1DocsPost(requestParameters.doc, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EquipmentParamOptionsApi - axios parameter creator
 */
export const EquipmentParamOptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all equipment parameter options with optional filtering, sorting, and pagination
         * @summary List all equipment parameter options
         * @param {string} [id] Filter by equipment parameter option IDs (one or more, comma-separated)
         * @param {string} [equipmentParamId] Filter by equipment parameter ID
         * @param {string} [value] Filter by value
         * @param {string} [label] Filter by label
         * @param {string} [equipmentParamKey] Filter by equipment parameter key, i.e size will return all options for the size parameter
         * @param {string} [sortBy] Sort by field (id, equipmentParamId, value, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamOptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsGet: async (id, equipmentParamId, value, label, equipmentParamKey, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/equipment-param-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (equipmentParamId !== undefined) {
                localVarQueryParameter['equipmentParamId'] = equipmentParamId;
            }
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }
            if (equipmentParamKey !== undefined) {
                localVarQueryParameter['equipmentParamKey'] = equipmentParamKey;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
         * @summary Delete an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/equipment-param-options/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single equipment parameter option by its ID. Returns options that belong to the current hauler (hauler-specific custom options) or globally accessible options (with haulerID = 00000000-0000-0000-0000-000000000000). This allows haulers to access both their own custom equipment type options and the shared global options. Returns 404 if not found.
         * @summary Get an equipment parameter option by ID
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdGet', 'id', id);
            const localVarPath = `/operations/v1/equipment-param-options/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
         * @summary Update an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdPut: async (id, equipmentParamOption, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdPut', 'id', id);
            // verify required parameter 'equipmentParamOption' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsIdPut', 'equipmentParamOption', equipmentParamOption);
            const localVarPath = `/operations/v1/equipment-param-options/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParamOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
         * @summary Create a new equipment parameter option
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsPost: async (equipmentParamOption, options = {}) => {
            // verify required parameter 'equipmentParamOption' is not null or undefined
            assertParamExists('operationsV1EquipmentParamOptionsPost', 'equipmentParamOption', equipmentParamOption);
            const localVarPath = `/operations/v1/equipment-param-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParamOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EquipmentParamOptionsApi - functional programming interface
 */
export const EquipmentParamOptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EquipmentParamOptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all equipment parameter options with optional filtering, sorting, and pagination
         * @summary List all equipment parameter options
         * @param {string} [id] Filter by equipment parameter option IDs (one or more, comma-separated)
         * @param {string} [equipmentParamId] Filter by equipment parameter ID
         * @param {string} [value] Filter by value
         * @param {string} [label] Filter by label
         * @param {string} [equipmentParamKey] Filter by equipment parameter key, i.e size will return all options for the size parameter
         * @param {string} [sortBy] Sort by field (id, equipmentParamId, value, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamOptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsGet(id, equipmentParamId, value, label, equipmentParamKey, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsGet(id, equipmentParamId, value, label, equipmentParamKey, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
         * @summary Delete an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdDelete']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single equipment parameter option by its ID. Returns options that belong to the current hauler (hauler-specific custom options) or globally accessible options (with haulerID = 00000000-0000-0000-0000-000000000000). This allows haulers to access both their own custom equipment type options and the shared global options. Returns 404 if not found.
         * @summary Get an equipment parameter option by ID
         * @param {string} id Equipment Parameter Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
         * @summary Update an equipment parameter option
         * @param {string} id Equipment Parameter Option ID
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsIdPut(id, equipmentParamOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsIdPut(id, equipmentParamOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
         * @summary Create a new equipment parameter option
         * @param {ModelEquipmentParamOption} equipmentParamOption Equipment Parameter Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamOptionsPost(equipmentParamOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamOptionsPost(equipmentParamOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamOptionsApi.operationsV1EquipmentParamOptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EquipmentParamOptionsApi - factory interface
 */
export const EquipmentParamOptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EquipmentParamOptionsApiFp(configuration);
    return {
        /**
         * Get all equipment parameter options with optional filtering, sorting, and pagination
         * @summary List all equipment parameter options
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsGet(requestParameters.id, requestParameters.equipmentParamId, requestParameters.value, requestParameters.label, requestParameters.equipmentParamKey, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
         * @summary Delete an equipment parameter option
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single equipment parameter option by its ID. Returns options that belong to the current hauler (hauler-specific custom options) or globally accessible options (with haulerID = 00000000-0000-0000-0000-000000000000). This allows haulers to access both their own custom equipment type options and the shared global options. Returns 404 if not found.
         * @summary Get an equipment parameter option by ID
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdGet(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsIdGet(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
         * @summary Update an equipment parameter option
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsIdPut(requestParameters.id, requestParameters.equipmentParamOption, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
         * @summary Create a new equipment parameter option
         * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamOptionsPost(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamOptionsPost(requestParameters.equipmentParamOption, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EquipmentParamOptionsApi - object-oriented interface
 */
export class EquipmentParamOptionsApi extends BaseAPI {
    /**
     * Get all equipment parameter options with optional filtering, sorting, and pagination
     * @summary List all equipment parameter options
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamOptionsGet(requestParameters = {}, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsGet(requestParameters.id, requestParameters.equipmentParamId, requestParameters.value, requestParameters.label, requestParameters.equipmentParamKey, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an existing equipment parameter option by its ID. Returns 404 if not found.
     * @summary Delete an equipment parameter option
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamOptionsIdDelete(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single equipment parameter option by its ID. Returns options that belong to the current hauler (hauler-specific custom options) or globally accessible options (with haulerID = 00000000-0000-0000-0000-000000000000). This allows haulers to access both their own custom equipment type options and the shared global options. Returns 404 if not found.
     * @summary Get an equipment parameter option by ID
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamOptionsIdGet(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing equipment parameter option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists.
     * @summary Update an equipment parameter option
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamOptionsIdPut(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsIdPut(requestParameters.id, requestParameters.equipmentParamOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new equipment parameter option with the provided data. Returns 409 if an option with the same value already exists.
     * @summary Create a new equipment parameter option
     * @param {EquipmentParamOptionsApiOperationsV1EquipmentParamOptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamOptionsPost(requestParameters, options) {
        return EquipmentParamOptionsApiFp(this.configuration)
            .operationsV1EquipmentParamOptionsPost(requestParameters.equipmentParamOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1EquipmentParamOptionsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * EquipmentParamsApi - axios parameter creator
 */
export const EquipmentParamsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
         * @summary List all equipment parameters
         * @param {string} [id] Filter by equipment parameter ID
         * @param {string} [equipmentTypeId] Filter by equipment type ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [key] Filter by equipment parameter key
         * @param {string} [label] Filter by equipment parameter label
         * @param {string} [sortBy] Sort by field (id, equipmentTypeId, haulerID, key, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsGet: async (id, equipmentTypeId, haulerID, key, label, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/equipment-params`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (equipmentTypeId !== undefined) {
                localVarQueryParameter['equipmentTypeId'] = equipmentTypeId;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an equipment parameter by its ID
         * @summary Delete an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/equipment-params/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single equipment parameter by its ID
         * @summary Get a single equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdGet', 'id', id);
            const localVarPath = `/operations/v1/equipment-params/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing equipment parameter with the provided data
         * @summary Update an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdPut: async (id, equipmentParam, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdPut', 'id', id);
            // verify required parameter 'equipmentParam' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsIdPut', 'equipmentParam', equipmentParam);
            const localVarPath = `/operations/v1/equipment-params/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new equipment parameter with the provided data
         * @summary Create a new equipment parameter
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsPost: async (equipmentParam, options = {}) => {
            // verify required parameter 'equipmentParam' is not null or undefined
            assertParamExists('operationsV1EquipmentParamsPost', 'equipmentParam', equipmentParam);
            const localVarPath = `/operations/v1/equipment-params`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EquipmentParamsApi - functional programming interface
 */
export const EquipmentParamsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EquipmentParamsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
         * @summary List all equipment parameters
         * @param {string} [id] Filter by equipment parameter ID
         * @param {string} [equipmentTypeId] Filter by equipment type ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [key] Filter by equipment parameter key
         * @param {string} [label] Filter by equipment parameter label
         * @param {string} [sortBy] Sort by field (id, equipmentTypeId, haulerID, key, label, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentParamsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsGet(id, equipmentTypeId, haulerID, key, label, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsGet(id, equipmentTypeId, haulerID, key, label, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an equipment parameter by its ID
         * @summary Delete an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single equipment parameter by its ID
         * @summary Get a single equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing equipment parameter with the provided data
         * @summary Update an equipment parameter
         * @param {string} id Equipment Parameter ID
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsIdPut(id, equipmentParam, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsIdPut(id, equipmentParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new equipment parameter with the provided data
         * @summary Create a new equipment parameter
         * @param {ModelEquipmentParam} equipmentParam Equipment Parameter object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentParamsPost(equipmentParam, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentParamsPost(equipmentParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentParamsApi.operationsV1EquipmentParamsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EquipmentParamsApi - factory interface
 */
export const EquipmentParamsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EquipmentParamsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
         * @summary List all equipment parameters
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1EquipmentParamsGet(requestParameters.id, requestParameters.equipmentTypeId, requestParameters.haulerID, requestParameters.key, requestParameters.label, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an equipment parameter by its ID
         * @summary Delete an equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single equipment parameter by its ID
         * @summary Get a single equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdGet(requestParameters, options) {
            return localVarFp.operationsV1EquipmentParamsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing equipment parameter with the provided data
         * @summary Update an equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamsIdPut(requestParameters.id, requestParameters.equipmentParam, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new equipment parameter with the provided data
         * @summary Create a new equipment parameter
         * @param {EquipmentParamsApiOperationsV1EquipmentParamsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentParamsPost(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentParamsPost(requestParameters.equipmentParam, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EquipmentParamsApi - object-oriented interface
 */
export class EquipmentParamsApi extends BaseAPI {
    /**
     * Retrieve a list of all equipment parameters with options to filter, sort, and paginate the results
     * @summary List all equipment parameters
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamsGet(requestParameters = {}, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsGet(requestParameters.id, requestParameters.equipmentTypeId, requestParameters.haulerID, requestParameters.key, requestParameters.label, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an equipment parameter by its ID
     * @summary Delete an equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamsIdDelete(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single equipment parameter by its ID
     * @summary Get a single equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamsIdGet(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing equipment parameter with the provided data
     * @summary Update an equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamsIdPut(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsIdPut(requestParameters.id, requestParameters.equipmentParam, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new equipment parameter with the provided data
     * @summary Create a new equipment parameter
     * @param {EquipmentParamsApiOperationsV1EquipmentParamsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentParamsPost(requestParameters, options) {
        return EquipmentParamsApiFp(this.configuration)
            .operationsV1EquipmentParamsPost(requestParameters.equipmentParam, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1EquipmentParamsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * EquipmentTypesApi - axios parameter creator
 */
export const EquipmentTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
         * @summary List all equipment types
         * @param {string} [id] Filter by equipment type ID
         * @param {string} [key] Filter by key
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentTypesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {boolean} [shouldIncludeDefault] Include default-hauler equipment types alongside the requesting hauler\&#39;s
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesGet: async (id, key, haulerID, sortBy, sortDir, offset, limit, shouldIncludeDefault, options = {}) => {
            const localVarPath = `/operations/v1/equipment-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (shouldIncludeDefault !== undefined) {
                localVarQueryParameter['shouldIncludeDefault'] = shouldIncludeDefault;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an equipment type from the system using its unique identifier
         * @summary Delete an equipment type
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdDelete', 'id', id);
            const localVarPath = `/operations/v1/equipment-types/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single equipment type using its unique identifier
         * @summary Get an equipment type by ID
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdGet', 'id', id);
            const localVarPath = `/operations/v1/equipment-types/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing equipment type with the provided details
         * @summary Update an equipment type
         * @param {string} id Equipment Type ID
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdPut: async (id, equipmentType, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdPut', 'id', id);
            // verify required parameter 'equipmentType' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesIdPut', 'equipmentType', equipmentType);
            const localVarPath = `/operations/v1/equipment-types/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new equipment type with the provided details
         * @summary Create a new equipment type
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesPost: async (equipmentType, options = {}) => {
            // verify required parameter 'equipmentType' is not null or undefined
            assertParamExists('operationsV1EquipmentTypesPost', 'equipmentType', equipmentType);
            const localVarPath = `/operations/v1/equipment-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EquipmentTypesApi - functional programming interface
 */
export const EquipmentTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = EquipmentTypesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
         * @summary List all equipment types
         * @param {string} [id] Filter by equipment type ID
         * @param {string} [key] Filter by key
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EquipmentTypesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {boolean} [shouldIncludeDefault] Include default-hauler equipment types alongside the requesting hauler\&#39;s
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesGet(id, key, haulerID, sortBy, sortDir, offset, limit, shouldIncludeDefault, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesGet(id, key, haulerID, sortBy, sortDir, offset, limit, shouldIncludeDefault, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove an equipment type from the system using its unique identifier
         * @summary Delete an equipment type
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single equipment type using its unique identifier
         * @summary Get an equipment type by ID
         * @param {string} id Equipment Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing equipment type with the provided details
         * @summary Update an equipment type
         * @param {string} id Equipment Type ID
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesIdPut(id, equipmentType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesIdPut(id, equipmentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new equipment type with the provided details
         * @summary Create a new equipment type
         * @param {ModelEquipmentType} equipmentType Equipment Type object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EquipmentTypesPost(equipmentType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EquipmentTypesPost(equipmentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentTypesApi.operationsV1EquipmentTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EquipmentTypesApi - factory interface
 */
export const EquipmentTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EquipmentTypesApiFp(configuration);
    return {
        /**
         * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
         * @summary List all equipment types
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1EquipmentTypesGet(requestParameters.id, requestParameters.key, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, requestParameters.shouldIncludeDefault, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove an equipment type from the system using its unique identifier
         * @summary Delete an equipment type
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdDelete(requestParameters, options) {
            return localVarFp.operationsV1EquipmentTypesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single equipment type using its unique identifier
         * @summary Get an equipment type by ID
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdGet(requestParameters, options) {
            return localVarFp.operationsV1EquipmentTypesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing equipment type with the provided details
         * @summary Update an equipment type
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentTypesIdPut(requestParameters.id, requestParameters.equipmentType, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new equipment type with the provided details
         * @summary Create a new equipment type
         * @param {EquipmentTypesApiOperationsV1EquipmentTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EquipmentTypesPost(requestParameters, options) {
            return localVarFp
                .operationsV1EquipmentTypesPost(requestParameters.equipmentType, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EquipmentTypesApi - object-oriented interface
 */
export class EquipmentTypesApi extends BaseAPI {
    /**
     * Retrieve a list of all equipment types with options to filter, sort, and paginate the results
     * @summary List all equipment types
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentTypesGet(requestParameters = {}, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesGet(requestParameters.id, requestParameters.key, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, requestParameters.shouldIncludeDefault, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove an equipment type from the system using its unique identifier
     * @summary Delete an equipment type
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentTypesIdDelete(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single equipment type using its unique identifier
     * @summary Get an equipment type by ID
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentTypesIdGet(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing equipment type with the provided details
     * @summary Update an equipment type
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentTypesIdPut(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesIdPut(requestParameters.id, requestParameters.equipmentType, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new equipment type with the provided details
     * @summary Create a new equipment type
     * @param {EquipmentTypesApiOperationsV1EquipmentTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EquipmentTypesPost(requestParameters, options) {
        return EquipmentTypesApiFp(this.configuration)
            .operationsV1EquipmentTypesPost(requestParameters.equipmentType, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1EquipmentTypesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * EventsApi - axios parameter creator
 */
export const EventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create several events in one request. Either every event is created or none are. The events then update the tasks they reference, those tasks\' groups and roll-off orders.
         * @summary Create events in bulk
         * @param {Array<OperationsServiceDomainModelEvent>} events Event objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsBulkPost: async (events, options = {}) => {
            // verify required parameter 'events' is not null or undefined
            assertParamExists('operationsV1EventsBulkPost', 'events', events);
            const localVarPath = `/operations/v1/events/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(events, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all events with options to filter, sort, and paginate the results
         * @summary List all events
         * @param {string} [id] Filter by event ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [type] Filter by event type (one or more, comma-separated)
         * @param {string} [status] Filter by event status (one or more, comma-separated)
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [orderID] Filter by order ID
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [taskRefID] Filter by associated task reference IDs (one or more, comma-separated)
         * @param {string} [sortBy] Sort by field (id, haulerID, type, status, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EventsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsGet: async (id, haulerID, type, status, subscriptionID, orderID, customerID, taskRefID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (subscriptionID !== undefined) {
                localVarQueryParameter['subscriptionID'] = subscriptionID;
            }
            if (orderID !== undefined) {
                localVarQueryParameter['orderID'] = orderID;
            }
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            if (taskRefID !== undefined) {
                localVarQueryParameter['taskRefID'] = taskRefID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an event from the system using its unique identifier
         * @summary Delete an event
         * @param {string} id Event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EventsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/events/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single event using its unique identifier
         * @summary Get an event by ID
         * @param {string} id Event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EventsIdGet', 'id', id);
            const localVarPath = `/operations/v1/events/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing event with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an event
         * @param {string} id Event ID
         * @param {OperationsServiceDomainModelEvent} event Event object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsIdPut: async (id, event, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1EventsIdPut', 'id', id);
            // verify required parameter 'event' is not null or undefined
            assertParamExists('operationsV1EventsIdPut', 'event', event);
            const localVarPath = `/operations/v1/events/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(event, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new event with the provided details
         * @summary Create a new event
         * @param {OperationsServiceDomainModelEvent} event Event object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsPost: async (event, options = {}) => {
            // verify required parameter 'event' is not null or undefined
            assertParamExists('operationsV1EventsPost', 'event', event);
            const localVarPath = `/operations/v1/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(event, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventsApi - functional programming interface
 */
export const EventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create several events in one request. Either every event is created or none are. The events then update the tasks they reference, those tasks\' groups and roll-off orders.
         * @summary Create events in bulk
         * @param {Array<OperationsServiceDomainModelEvent>} events Event objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EventsBulkPost(events, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EventsBulkPost(events, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.operationsV1EventsBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all events with options to filter, sort, and paginate the results
         * @summary List all events
         * @param {string} [id] Filter by event ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [type] Filter by event type (one or more, comma-separated)
         * @param {string} [status] Filter by event status (one or more, comma-separated)
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [orderID] Filter by order ID
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [taskRefID] Filter by associated task reference IDs (one or more, comma-separated)
         * @param {string} [sortBy] Sort by field (id, haulerID, type, status, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1EventsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EventsGet(id, haulerID, type, status, subscriptionID, orderID, customerID, taskRefID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EventsGet(id, haulerID, type, status, subscriptionID, orderID, customerID, taskRefID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.operationsV1EventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove an event from the system using its unique identifier
         * @summary Delete an event
         * @param {string} id Event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EventsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EventsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.operationsV1EventsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single event using its unique identifier
         * @summary Get an event by ID
         * @param {string} id Event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EventsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EventsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.operationsV1EventsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing event with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an event
         * @param {string} id Event ID
         * @param {OperationsServiceDomainModelEvent} event Event object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EventsIdPut(id, event, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EventsIdPut(id, event, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.operationsV1EventsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new event with the provided details
         * @summary Create a new event
         * @param {OperationsServiceDomainModelEvent} event Event object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1EventsPost(event, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1EventsPost(event, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.operationsV1EventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EventsApi - factory interface
 */
export const EventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventsApiFp(configuration);
    return {
        /**
         * Create several events in one request. Either every event is created or none are. The events then update the tasks they reference, those tasks\' groups and roll-off orders.
         * @summary Create events in bulk
         * @param {EventsApiOperationsV1EventsBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsBulkPost(requestParameters, options) {
            return localVarFp.operationsV1EventsBulkPost(requestParameters.events, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all events with options to filter, sort, and paginate the results
         * @summary List all events
         * @param {EventsApiOperationsV1EventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1EventsGet(requestParameters.id, requestParameters.haulerID, requestParameters.type, requestParameters.status, requestParameters.subscriptionID, requestParameters.orderID, requestParameters.customerID, requestParameters.taskRefID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove an event from the system using its unique identifier
         * @summary Delete an event
         * @param {EventsApiOperationsV1EventsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1EventsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single event using its unique identifier
         * @summary Get an event by ID
         * @param {EventsApiOperationsV1EventsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsIdGet(requestParameters, options) {
            return localVarFp.operationsV1EventsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing event with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an event
         * @param {EventsApiOperationsV1EventsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1EventsIdPut(requestParameters.id, requestParameters.event, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new event with the provided details
         * @summary Create a new event
         * @param {EventsApiOperationsV1EventsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1EventsPost(requestParameters, options) {
            return localVarFp.operationsV1EventsPost(requestParameters.event, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventsApi - object-oriented interface
 */
export class EventsApi extends BaseAPI {
    /**
     * Create several events in one request. Either every event is created or none are. The events then update the tasks they reference, those tasks\' groups and roll-off orders.
     * @summary Create events in bulk
     * @param {EventsApiOperationsV1EventsBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EventsBulkPost(requestParameters, options) {
        return EventsApiFp(this.configuration)
            .operationsV1EventsBulkPost(requestParameters.events, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of all events with options to filter, sort, and paginate the results
     * @summary List all events
     * @param {EventsApiOperationsV1EventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EventsGet(requestParameters = {}, options) {
        return EventsApiFp(this.configuration)
            .operationsV1EventsGet(requestParameters.id, requestParameters.haulerID, requestParameters.type, requestParameters.status, requestParameters.subscriptionID, requestParameters.orderID, requestParameters.customerID, requestParameters.taskRefID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove an event from the system using its unique identifier
     * @summary Delete an event
     * @param {EventsApiOperationsV1EventsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EventsIdDelete(requestParameters, options) {
        return EventsApiFp(this.configuration)
            .operationsV1EventsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single event using its unique identifier
     * @summary Get an event by ID
     * @param {EventsApiOperationsV1EventsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EventsIdGet(requestParameters, options) {
        return EventsApiFp(this.configuration)
            .operationsV1EventsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing event with the provided details. The hauler ID is automatically set from the context.
     * @summary Update an event
     * @param {EventsApiOperationsV1EventsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EventsIdPut(requestParameters, options) {
        return EventsApiFp(this.configuration)
            .operationsV1EventsIdPut(requestParameters.id, requestParameters.event, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new event with the provided details
     * @summary Create a new event
     * @param {EventsApiOperationsV1EventsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1EventsPost(requestParameters, options) {
        return EventsApiFp(this.configuration)
            .operationsV1EventsPost(requestParameters.event, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1EventsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * LocationsApi - axios parameter creator
 */
export const LocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {string} [locationId] Filter by location ID
         * @param {string} [locationHaulerId] Filter by hauler ID
         * @param {string} [locationCity] Filter by city
         * @param {string} [locationState] Filter by state
         * @param {string} [locationPostcode] Filter by postcode
         * @param {string} [locationCountry] Filter by country
         * @param {string} [locationLabel] Filter by label
         * @param {string} [sortBy] Sort by field (locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, locationSortOrder, locationCreatedAt, locationLastUpdatedAt)
         * @param {OperationsV1LocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsGet: async (locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options = {}) => {
            const localVarPath = `/operations/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }
            if (locationHaulerId !== undefined) {
                localVarQueryParameter['locationHaulerId'] = locationHaulerId;
            }
            if (locationCity !== undefined) {
                localVarQueryParameter['locationCity'] = locationCity;
            }
            if (locationState !== undefined) {
                localVarQueryParameter['locationState'] = locationState;
            }
            if (locationPostcode !== undefined) {
                localVarQueryParameter['locationPostcode'] = locationPostcode;
            }
            if (locationCountry !== undefined) {
                localVarQueryParameter['locationCountry'] = locationCountry;
            }
            if (locationLabel !== undefined) {
                localVarQueryParameter['locationLabel'] = locationLabel;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1LocationsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1LocationsIdGet', 'id', id);
            const localVarPath = `/operations/v1/locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {string} id Location ID
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdPut: async (id, location, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1LocationsIdPut', 'id', id);
            // verify required parameter 'location' is not null or undefined
            assertParamExists('operationsV1LocationsIdPut', 'location', location);
            const localVarPath = `/operations/v1/locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsPost: async (location, options = {}) => {
            // verify required parameter 'location' is not null or undefined
            assertParamExists('operationsV1LocationsPost', 'location', location);
            const localVarPath = `/operations/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LocationsApi - functional programming interface
 */
export const LocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {string} [locationId] Filter by location ID
         * @param {string} [locationHaulerId] Filter by hauler ID
         * @param {string} [locationCity] Filter by city
         * @param {string} [locationState] Filter by state
         * @param {string} [locationPostcode] Filter by postcode
         * @param {string} [locationCountry] Filter by country
         * @param {string} [locationLabel] Filter by label
         * @param {string} [sortBy] Sort by field (locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, locationSortOrder, locationCreatedAt, locationLastUpdatedAt)
         * @param {OperationsV1LocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsGet(locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsGet(locationId, locationHaulerId, locationCity, locationState, locationPostcode, locationCountry, locationLabel, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {string} id Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {string} id Location ID
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsIdPut(id, location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsIdPut(id, location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {ModelLocation} location Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1LocationsPost(location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1LocationsPost(location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.operationsV1LocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LocationsApi - factory interface
 */
export const LocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LocationsApiFp(configuration);
    return {
        /**
         * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
         * @summary List all locations
         * @param {LocationsApiOperationsV1LocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1LocationsGet(requestParameters.locationId, requestParameters.locationHaulerId, requestParameters.locationCity, requestParameters.locationState, requestParameters.locationPostcode, requestParameters.locationCountry, requestParameters.locationLabel, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an existing location by its ID
         * @summary delete a location
         * @param {LocationsApiOperationsV1LocationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1LocationsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single location by its ID
         * @summary Get a location by ID
         * @param {LocationsApiOperationsV1LocationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdGet(requestParameters, options) {
            return localVarFp.operationsV1LocationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing location with the provided data
         * @summary update a location
         * @param {LocationsApiOperationsV1LocationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1LocationsIdPut(requestParameters.id, requestParameters.location, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new location with the provided data
         * @summary create a new location
         * @param {LocationsApiOperationsV1LocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1LocationsPost(requestParameters, options) {
            return localVarFp.operationsV1LocationsPost(requestParameters.location, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LocationsApi - object-oriented interface
 */
export class LocationsApi extends BaseAPI {
    /**
     * Get all locations with optional filtering and sorting. Supports pagination and field filtering.
     * @summary List all locations
     * @param {LocationsApiOperationsV1LocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1LocationsGet(requestParameters = {}, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsGet(requestParameters.locationId, requestParameters.locationHaulerId, requestParameters.locationCity, requestParameters.locationState, requestParameters.locationPostcode, requestParameters.locationCountry, requestParameters.locationLabel, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an existing location by its ID
     * @summary delete a location
     * @param {LocationsApiOperationsV1LocationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1LocationsIdDelete(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single location by its ID
     * @summary Get a location by ID
     * @param {LocationsApiOperationsV1LocationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1LocationsIdGet(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing location with the provided data
     * @summary update a location
     * @param {LocationsApiOperationsV1LocationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1LocationsIdPut(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsIdPut(requestParameters.id, requestParameters.location, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new location with the provided data
     * @summary create a new location
     * @param {LocationsApiOperationsV1LocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1LocationsPost(requestParameters, options) {
        return LocationsApiFp(this.configuration)
            .operationsV1LocationsPost(requestParameters.location, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1LocationsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrderCommercialsApi - axios parameter creator
 */
export const OrderCommercialsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all order commercials with optional filtering and sorting
         * @summary List all order commercials
         * @param {string} [orderCommercialId] Filter by order commercial ID
         * @param {string} [orderCommercialOrderId] Filter by order ID
         * @param {string} [orderCommercialSubscriptionId] Filter by subscription ID
         * @param {string} [orderCommercialSubscriptionLocationId] Filter by subscription location ID
         * @param {string} [orderCommercialStatus] Filter by status
         * @param {string} [orderCommercialEquipmentTypeId] Filter by equipment type ID
         * @param {string} [sortBy] Sort by field (orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialStartTimestamp, orderCommercialEndTimestamp, orderCommercialSortOrder, orderCommercialCreatedAt, orderCommercialLastUpdatedAt)
         * @param {OperationsV1OrderCommercialsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsGet: async (orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialEquipmentTypeId, sortBy, sortDir, options = {}) => {
            const localVarPath = `/operations/v1/order-commercials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (orderCommercialId !== undefined) {
                localVarQueryParameter['orderCommercialId'] = orderCommercialId;
            }
            if (orderCommercialOrderId !== undefined) {
                localVarQueryParameter['orderCommercialOrderId'] = orderCommercialOrderId;
            }
            if (orderCommercialSubscriptionId !== undefined) {
                localVarQueryParameter['orderCommercialSubscriptionId'] = orderCommercialSubscriptionId;
            }
            if (orderCommercialSubscriptionLocationId !== undefined) {
                localVarQueryParameter['orderCommercialSubscriptionLocationId'] = orderCommercialSubscriptionLocationId;
            }
            if (orderCommercialStatus !== undefined) {
                localVarQueryParameter['orderCommercialStatus'] = orderCommercialStatus;
            }
            if (orderCommercialEquipmentTypeId !== undefined) {
                localVarQueryParameter['orderCommercialEquipmentTypeId'] = orderCommercialEquipmentTypeId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an order commercial by its ID
         * @summary delete an order commercial
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/order-commercials/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single order commercial by its ID
         * @summary Get an order commercial by ID
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdGet', 'id', id);
            const localVarPath = `/operations/v1/order-commercials/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order commercial with the provided data
         * @summary update an order commercial
         * @param {string} id Order Commercial ID
         * @param {ModelOrderCommercial} orderCommercial Order Commercial object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdPut: async (id, orderCommercial, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdPut', 'id', id);
            // verify required parameter 'orderCommercial' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsIdPut', 'orderCommercial', orderCommercial);
            const localVarPath = `/operations/v1/order-commercials/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderCommercial, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order commercial
         * @summary create order commercial
         * @param {ModelOrderCommercial} orderCommercial Order Commercial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsPost: async (orderCommercial, options = {}) => {
            // verify required parameter 'orderCommercial' is not null or undefined
            assertParamExists('operationsV1OrderCommercialsPost', 'orderCommercial', orderCommercial);
            const localVarPath = `/operations/v1/order-commercials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderCommercial, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderCommercialsApi - functional programming interface
 */
export const OrderCommercialsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderCommercialsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all order commercials with optional filtering and sorting
         * @summary List all order commercials
         * @param {string} [orderCommercialId] Filter by order commercial ID
         * @param {string} [orderCommercialOrderId] Filter by order ID
         * @param {string} [orderCommercialSubscriptionId] Filter by subscription ID
         * @param {string} [orderCommercialSubscriptionLocationId] Filter by subscription location ID
         * @param {string} [orderCommercialStatus] Filter by status
         * @param {string} [orderCommercialEquipmentTypeId] Filter by equipment type ID
         * @param {string} [sortBy] Sort by field (orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialStartTimestamp, orderCommercialEndTimestamp, orderCommercialSortOrder, orderCommercialCreatedAt, orderCommercialLastUpdatedAt)
         * @param {OperationsV1OrderCommercialsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsGet(orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialEquipmentTypeId, sortBy, sortDir, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsGet(orderCommercialId, orderCommercialOrderId, orderCommercialSubscriptionId, orderCommercialSubscriptionLocationId, orderCommercialStatus, orderCommercialEquipmentTypeId, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an order commercial by its ID
         * @summary delete an order commercial
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single order commercial by its ID
         * @summary Get an order commercial by ID
         * @param {string} id Order Commercial ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order commercial with the provided data
         * @summary update an order commercial
         * @param {string} id Order Commercial ID
         * @param {ModelOrderCommercial} orderCommercial Order Commercial object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsIdPut(id, orderCommercial, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsIdPut(id, orderCommercial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order commercial
         * @summary create order commercial
         * @param {ModelOrderCommercial} orderCommercial Order Commercial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderCommercialsPost(orderCommercial, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderCommercialsPost(orderCommercial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCommercialsApi.operationsV1OrderCommercialsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderCommercialsApi - factory interface
 */
export const OrderCommercialsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderCommercialsApiFp(configuration);
    return {
        /**
         * Get all order commercials with optional filtering and sorting
         * @summary List all order commercials
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1OrderCommercialsGet(requestParameters.orderCommercialId, requestParameters.orderCommercialOrderId, requestParameters.orderCommercialSubscriptionId, requestParameters.orderCommercialSubscriptionLocationId, requestParameters.orderCommercialStatus, requestParameters.orderCommercialEquipmentTypeId, requestParameters.sortBy, requestParameters.sortDir, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an order commercial by its ID
         * @summary delete an order commercial
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1OrderCommercialsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single order commercial by its ID
         * @summary Get an order commercial by ID
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdGet(requestParameters, options) {
            return localVarFp.operationsV1OrderCommercialsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order commercial with the provided data
         * @summary update an order commercial
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrderCommercialsIdPut(requestParameters.id, requestParameters.orderCommercial, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order commercial
         * @summary create order commercial
         * @param {OrderCommercialsApiOperationsV1OrderCommercialsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderCommercialsPost(requestParameters, options) {
            return localVarFp
                .operationsV1OrderCommercialsPost(requestParameters.orderCommercial, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderCommercialsApi - object-oriented interface
 */
export class OrderCommercialsApi extends BaseAPI {
    /**
     * Get all order commercials with optional filtering and sorting
     * @summary List all order commercials
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderCommercialsGet(requestParameters = {}, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsGet(requestParameters.orderCommercialId, requestParameters.orderCommercialOrderId, requestParameters.orderCommercialSubscriptionId, requestParameters.orderCommercialSubscriptionLocationId, requestParameters.orderCommercialStatus, requestParameters.orderCommercialEquipmentTypeId, requestParameters.sortBy, requestParameters.sortDir, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an order commercial by its ID
     * @summary delete an order commercial
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderCommercialsIdDelete(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single order commercial by its ID
     * @summary Get an order commercial by ID
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderCommercialsIdGet(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order commercial with the provided data
     * @summary update an order commercial
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderCommercialsIdPut(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsIdPut(requestParameters.id, requestParameters.orderCommercial, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order commercial
     * @summary create order commercial
     * @param {OrderCommercialsApiOperationsV1OrderCommercialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderCommercialsPost(requestParameters, options) {
        return OrderCommercialsApiFp(this.configuration)
            .operationsV1OrderCommercialsPost(requestParameters.orderCommercial, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1OrderCommercialsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrderItemsApi - axios parameter creator
 */
export const OrderItemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {string} id Order Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderItemsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/order-items/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {string} id Order Item ID
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdPut: async (id, orderItem, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderItemsIdPut', 'id', id);
            // verify required parameter 'orderItem' is not null or undefined
            assertParamExists('operationsV1OrderItemsIdPut', 'orderItem', orderItem);
            const localVarPath = `/operations/v1/order-items/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsPost: async (orderItem, options = {}) => {
            // verify required parameter 'orderItem' is not null or undefined
            assertParamExists('operationsV1OrderItemsPost', 'orderItem', orderItem);
            const localVarPath = `/operations/v1/order-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderItemsApi - functional programming interface
 */
export const OrderItemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderItemsApiAxiosParamCreator(configuration);
    return {
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {string} id Order Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderItemsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderItemsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.operationsV1OrderItemsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {string} id Order Item ID
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderItemsIdPut(id, orderItem, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderItemsIdPut(id, orderItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.operationsV1OrderItemsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {ModelOrderItem} orderItem Order Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderItemsPost(orderItem, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderItemsPost(orderItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.operationsV1OrderItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderItemsApi - factory interface
 */
export const OrderItemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderItemsApiFp(configuration);
    return {
        /**
         * delete an order item by its ID
         * @summary delete order item
         * @param {OrderItemsApiOperationsV1OrderItemsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1OrderItemsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order item
         * @summary update order item
         * @param {OrderItemsApiOperationsV1OrderItemsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrderItemsIdPut(requestParameters.id, requestParameters.orderItem, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order item
         * @summary create order item
         * @param {OrderItemsApiOperationsV1OrderItemsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderItemsPost(requestParameters, options) {
            return localVarFp.operationsV1OrderItemsPost(requestParameters.orderItem, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderItemsApi - object-oriented interface
 */
export class OrderItemsApi extends BaseAPI {
    /**
     * delete an order item by its ID
     * @summary delete order item
     * @param {OrderItemsApiOperationsV1OrderItemsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderItemsIdDelete(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .operationsV1OrderItemsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order item
     * @summary update order item
     * @param {OrderItemsApiOperationsV1OrderItemsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderItemsIdPut(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .operationsV1OrderItemsIdPut(requestParameters.id, requestParameters.orderItem, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order item
     * @summary create order item
     * @param {OrderItemsApiOperationsV1OrderItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderItemsPost(requestParameters, options) {
        return OrderItemsApiFp(this.configuration)
            .operationsV1OrderItemsPost(requestParameters.orderItem, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrderPortaloosApi - axios parameter creator
 */
export const OrderPortaloosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all order portaloo with options to filter, sort, and paginate the results
         * @summary List all order portaloo
         * @param {string} [id] Filter by ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [orderID] Filter by order ID
         * @param {string} [status] Filter by status
         * @param {string} [fromDate] Filter for order portaloos that end on or after this date and time (RFC3339 format, including time and timezone). Order portaloos that don\&#39;t have a set end time will be included.
         * @param {string} [toDate] Filter for order portaloos that start on or before this date and time (RFC3339 format, including time and timezone)
         * @param {string} [sortBy] Sort by field (id, haulerID, orderID, status, createdAt, lastUpdatedAt)
         * @param {OperationsV1OrderPortaloosGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosGet: async (id, haulerID, orderID, status, fromDate, toDate, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/order-portaloos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (orderID !== undefined) {
                localVarQueryParameter['orderID'] = orderID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an order portaloo record from the system using its unique identifier
         * @summary Delete an order portaloo record
         * @param {string} id OrderPortaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderPortaloosIdDelete', 'id', id);
            const localVarPath = `/operations/v1/order-portaloos/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single order portaloo record using its unique identifier
         * @summary Get an order portaloo record by ID
         * @param {string} id OrderPortaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderPortaloosIdGet', 'id', id);
            const localVarPath = `/operations/v1/order-portaloos/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing order portaloo record with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an order portaloo record
         * @param {string} id OrderPortaloo ID
         * @param {ModelOrderPtloo} orderportaloo OrderPortaloo object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosIdPut: async (id, orderportaloo, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderPortaloosIdPut', 'id', id);
            // verify required parameter 'orderportaloo' is not null or undefined
            assertParamExists('operationsV1OrderPortaloosIdPut', 'orderportaloo', orderportaloo);
            const localVarPath = `/operations/v1/order-portaloos/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderportaloo, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new order portaloo record with the provided details
         * @summary Create a new order portaloo record
         * @param {ModelOrderPtloo} orderportaloo OrderPortaloo object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosPost: async (orderportaloo, options = {}) => {
            // verify required parameter 'orderportaloo' is not null or undefined
            assertParamExists('operationsV1OrderPortaloosPost', 'orderportaloo', orderportaloo);
            const localVarPath = `/operations/v1/order-portaloos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderportaloo, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderPortaloosApi - functional programming interface
 */
export const OrderPortaloosApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderPortaloosApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all order portaloo with options to filter, sort, and paginate the results
         * @summary List all order portaloo
         * @param {string} [id] Filter by ID
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [orderID] Filter by order ID
         * @param {string} [status] Filter by status
         * @param {string} [fromDate] Filter for order portaloos that end on or after this date and time (RFC3339 format, including time and timezone). Order portaloos that don\&#39;t have a set end time will be included.
         * @param {string} [toDate] Filter for order portaloos that start on or before this date and time (RFC3339 format, including time and timezone)
         * @param {string} [sortBy] Sort by field (id, haulerID, orderID, status, createdAt, lastUpdatedAt)
         * @param {OperationsV1OrderPortaloosGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderPortaloosGet(id, haulerID, orderID, status, fromDate, toDate, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderPortaloosGet(id, haulerID, orderID, status, fromDate, toDate, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.operationsV1OrderPortaloosGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove an order portaloo record from the system using its unique identifier
         * @summary Delete an order portaloo record
         * @param {string} id OrderPortaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderPortaloosIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderPortaloosIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.operationsV1OrderPortaloosIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single order portaloo record using its unique identifier
         * @summary Get an order portaloo record by ID
         * @param {string} id OrderPortaloo ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderPortaloosIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderPortaloosIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.operationsV1OrderPortaloosIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing order portaloo record with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an order portaloo record
         * @param {string} id OrderPortaloo ID
         * @param {ModelOrderPtloo} orderportaloo OrderPortaloo object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderPortaloosIdPut(id, orderportaloo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderPortaloosIdPut(id, orderportaloo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.operationsV1OrderPortaloosIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new order portaloo record with the provided details
         * @summary Create a new order portaloo record
         * @param {ModelOrderPtloo} orderportaloo OrderPortaloo object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderPortaloosPost(orderportaloo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderPortaloosPost(orderportaloo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPortaloosApi.operationsV1OrderPortaloosPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderPortaloosApi - factory interface
 */
export const OrderPortaloosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderPortaloosApiFp(configuration);
    return {
        /**
         * Retrieve a list of all order portaloo with options to filter, sort, and paginate the results
         * @summary List all order portaloo
         * @param {OrderPortaloosApiOperationsV1OrderPortaloosGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1OrderPortaloosGet(requestParameters.id, requestParameters.haulerID, requestParameters.orderID, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove an order portaloo record from the system using its unique identifier
         * @summary Delete an order portaloo record
         * @param {OrderPortaloosApiOperationsV1OrderPortaloosIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosIdDelete(requestParameters, options) {
            return localVarFp.operationsV1OrderPortaloosIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single order portaloo record using its unique identifier
         * @summary Get an order portaloo record by ID
         * @param {OrderPortaloosApiOperationsV1OrderPortaloosIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosIdGet(requestParameters, options) {
            return localVarFp.operationsV1OrderPortaloosIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing order portaloo record with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an order portaloo record
         * @param {OrderPortaloosApiOperationsV1OrderPortaloosIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrderPortaloosIdPut(requestParameters.id, requestParameters.orderportaloo, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new order portaloo record with the provided details
         * @summary Create a new order portaloo record
         * @param {OrderPortaloosApiOperationsV1OrderPortaloosPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderPortaloosPost(requestParameters, options) {
            return localVarFp
                .operationsV1OrderPortaloosPost(requestParameters.orderportaloo, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderPortaloosApi - object-oriented interface
 */
export class OrderPortaloosApi extends BaseAPI {
    /**
     * Retrieve a list of all order portaloo with options to filter, sort, and paginate the results
     * @summary List all order portaloo
     * @param {OrderPortaloosApiOperationsV1OrderPortaloosGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderPortaloosGet(requestParameters = {}, options) {
        return OrderPortaloosApiFp(this.configuration)
            .operationsV1OrderPortaloosGet(requestParameters.id, requestParameters.haulerID, requestParameters.orderID, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove an order portaloo record from the system using its unique identifier
     * @summary Delete an order portaloo record
     * @param {OrderPortaloosApiOperationsV1OrderPortaloosIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderPortaloosIdDelete(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .operationsV1OrderPortaloosIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single order portaloo record using its unique identifier
     * @summary Get an order portaloo record by ID
     * @param {OrderPortaloosApiOperationsV1OrderPortaloosIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderPortaloosIdGet(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .operationsV1OrderPortaloosIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing order portaloo record with the provided details. The hauler ID is automatically set from the context.
     * @summary Update an order portaloo record
     * @param {OrderPortaloosApiOperationsV1OrderPortaloosIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderPortaloosIdPut(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .operationsV1OrderPortaloosIdPut(requestParameters.id, requestParameters.orderportaloo, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new order portaloo record with the provided details
     * @summary Create a new order portaloo record
     * @param {OrderPortaloosApiOperationsV1OrderPortaloosPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderPortaloosPost(requestParameters, options) {
        return OrderPortaloosApiFp(this.configuration)
            .operationsV1OrderPortaloosPost(requestParameters.orderportaloo, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1OrderPortaloosGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrderRolloffsApi - axios parameter creator
 */
export const OrderRolloffsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all order rolloffs with options to filter, sort, and paginate the results
         * @summary List all order rolloffs
         * @param {string} [id] Filter by ID (exact match)
         * @param {string} [ids] Filter by IDs (comma-separated, batch fetching)
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [orderID] Filter by order ID (exact match)
         * @param {string} [orderIDs] Filter by order IDs (comma-separated, batch fetching)
         * @param {string} [status] Filter by statuses (comma-separated)
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [sortBy] Sort by field (id, haulerID, orderID, status, createdAt, lastUpdatedAt)
         * @param {OperationsV1OrderRolloffsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsGet: async (id, ids, haulerID, orderID, orderIDs, status, customerID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/order-rolloffs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (orderID !== undefined) {
                localVarQueryParameter['orderID'] = orderID;
            }
            if (orderIDs !== undefined) {
                localVarQueryParameter['orderIDs'] = orderIDs;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel an order rolloff, optionally notifying specified contacts
         * @summary Cancel an order rolloff
         * @param {string} id OrderRolloff ID
         * @param {OrderrolloffCancelOrderRoRequest} [body] Cancellation options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdCancelPost: async (id, body, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderRolloffsIdCancelPost', 'id', id);
            const localVarPath = `/operations/v1/order-rolloffs/{id}/cancel`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an order rolloff record from the system using its unique identifier
         * @summary Delete an order rolloff record
         * @param {string} id OrderRolloff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderRolloffsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/order-rolloffs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single order rolloff record using its unique identifier
         * @summary Get an order rolloff record by ID
         * @param {string} id OrderRolloff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderRolloffsIdGet', 'id', id);
            const localVarPath = `/operations/v1/order-rolloffs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing order rolloff record with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an order rolloff record
         * @param {string} id OrderRolloff ID
         * @param {OrderrolloffUpdateOrderRoRequest} orderrolloff OrderRolloff object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdPut: async (id, orderrolloff, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderRolloffsIdPut', 'id', id);
            // verify required parameter 'orderrolloff' is not null or undefined
            assertParamExists('operationsV1OrderRolloffsIdPut', 'orderrolloff', orderrolloff);
            const localVarPath = `/operations/v1/order-rolloffs/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderrolloff, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel the boundary SWAP task group, create a fresh PICKUP task group on the predecessor, and move the target plus any downstream subchain to a fresh ord under the same subscription. The legacy \"final pickup\" mode is now handled by the chain-aware Cancel endpoint.
         * @summary Bisect a switch chain at the given switch ord_ro
         * @param {string} id OrderRolloff ID (the switch / delivery ord_ro to split off)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdSplitSwitchPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrderRolloffsIdSplitSwitchPost', 'id', id);
            const localVarPath = `/operations/v1/order-rolloffs/{id}/split-switch`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new order rolloff record. When billing fields (lineItems, etc.) are supplied the new ord_ro is invoiced/charged; otherwise it is created without billing.
         * @summary Create a new order rolloff record
         * @param {OrderrolloffCreateOrderRoRequest} orderrolloff OrderRolloff object with optional billing fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsPost: async (orderrolloff, options = {}) => {
            // verify required parameter 'orderrolloff' is not null or undefined
            assertParamExists('operationsV1OrderRolloffsPost', 'orderrolloff', orderrolloff);
            const localVarPath = `/operations/v1/order-rolloffs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderrolloff, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrderRolloffsApi - functional programming interface
 */
export const OrderRolloffsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderRolloffsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all order rolloffs with options to filter, sort, and paginate the results
         * @summary List all order rolloffs
         * @param {string} [id] Filter by ID (exact match)
         * @param {string} [ids] Filter by IDs (comma-separated, batch fetching)
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [orderID] Filter by order ID (exact match)
         * @param {string} [orderIDs] Filter by order IDs (comma-separated, batch fetching)
         * @param {string} [status] Filter by statuses (comma-separated)
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [sortBy] Sort by field (id, haulerID, orderID, status, createdAt, lastUpdatedAt)
         * @param {OperationsV1OrderRolloffsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderRolloffsGet(id, ids, haulerID, orderID, orderIDs, status, customerID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderRolloffsGet(id, ids, haulerID, orderID, orderIDs, status, customerID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderRolloffsApi.operationsV1OrderRolloffsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel an order rolloff, optionally notifying specified contacts
         * @summary Cancel an order rolloff
         * @param {string} id OrderRolloff ID
         * @param {OrderrolloffCancelOrderRoRequest} [body] Cancellation options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderRolloffsIdCancelPost(id, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderRolloffsIdCancelPost(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderRolloffsApi.operationsV1OrderRolloffsIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove an order rolloff record from the system using its unique identifier
         * @summary Delete an order rolloff record
         * @param {string} id OrderRolloff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderRolloffsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderRolloffsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderRolloffsApi.operationsV1OrderRolloffsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single order rolloff record using its unique identifier
         * @summary Get an order rolloff record by ID
         * @param {string} id OrderRolloff ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderRolloffsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderRolloffsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderRolloffsApi.operationsV1OrderRolloffsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing order rolloff record with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an order rolloff record
         * @param {string} id OrderRolloff ID
         * @param {OrderrolloffUpdateOrderRoRequest} orderrolloff OrderRolloff object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderRolloffsIdPut(id, orderrolloff, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderRolloffsIdPut(id, orderrolloff, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderRolloffsApi.operationsV1OrderRolloffsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel the boundary SWAP task group, create a fresh PICKUP task group on the predecessor, and move the target plus any downstream subchain to a fresh ord under the same subscription. The legacy \"final pickup\" mode is now handled by the chain-aware Cancel endpoint.
         * @summary Bisect a switch chain at the given switch ord_ro
         * @param {string} id OrderRolloff ID (the switch / delivery ord_ro to split off)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderRolloffsIdSplitSwitchPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderRolloffsIdSplitSwitchPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderRolloffsApi.operationsV1OrderRolloffsIdSplitSwitchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new order rolloff record. When billing fields (lineItems, etc.) are supplied the new ord_ro is invoiced/charged; otherwise it is created without billing.
         * @summary Create a new order rolloff record
         * @param {OrderrolloffCreateOrderRoRequest} orderrolloff OrderRolloff object with optional billing fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrderRolloffsPost(orderrolloff, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrderRolloffsPost(orderrolloff, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderRolloffsApi.operationsV1OrderRolloffsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrderRolloffsApi - factory interface
 */
export const OrderRolloffsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderRolloffsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all order rolloffs with options to filter, sort, and paginate the results
         * @summary List all order rolloffs
         * @param {OrderRolloffsApiOperationsV1OrderRolloffsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1OrderRolloffsGet(requestParameters.id, requestParameters.ids, requestParameters.haulerID, requestParameters.orderID, requestParameters.orderIDs, requestParameters.status, requestParameters.customerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Cancel an order rolloff, optionally notifying specified contacts
         * @summary Cancel an order rolloff
         * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdCancelPost(requestParameters, options) {
            return localVarFp
                .operationsV1OrderRolloffsIdCancelPost(requestParameters.id, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove an order rolloff record from the system using its unique identifier
         * @summary Delete an order rolloff record
         * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1OrderRolloffsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single order rolloff record using its unique identifier
         * @summary Get an order rolloff record by ID
         * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdGet(requestParameters, options) {
            return localVarFp.operationsV1OrderRolloffsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing order rolloff record with the provided details. The hauler ID is automatically set from the context.
         * @summary Update an order rolloff record
         * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrderRolloffsIdPut(requestParameters.id, requestParameters.orderrolloff, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Cancel the boundary SWAP task group, create a fresh PICKUP task group on the predecessor, and move the target plus any downstream subchain to a fresh ord under the same subscription. The legacy \"final pickup\" mode is now handled by the chain-aware Cancel endpoint.
         * @summary Bisect a switch chain at the given switch ord_ro
         * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdSplitSwitchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsIdSplitSwitchPost(requestParameters, options) {
            return localVarFp
                .operationsV1OrderRolloffsIdSplitSwitchPost(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new order rolloff record. When billing fields (lineItems, etc.) are supplied the new ord_ro is invoiced/charged; otherwise it is created without billing.
         * @summary Create a new order rolloff record
         * @param {OrderRolloffsApiOperationsV1OrderRolloffsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrderRolloffsPost(requestParameters, options) {
            return localVarFp
                .operationsV1OrderRolloffsPost(requestParameters.orderrolloff, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderRolloffsApi - object-oriented interface
 */
export class OrderRolloffsApi extends BaseAPI {
    /**
     * Retrieve a list of all order rolloffs with options to filter, sort, and paginate the results
     * @summary List all order rolloffs
     * @param {OrderRolloffsApiOperationsV1OrderRolloffsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderRolloffsGet(requestParameters = {}, options) {
        return OrderRolloffsApiFp(this.configuration)
            .operationsV1OrderRolloffsGet(requestParameters.id, requestParameters.ids, requestParameters.haulerID, requestParameters.orderID, requestParameters.orderIDs, requestParameters.status, requestParameters.customerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cancel an order rolloff, optionally notifying specified contacts
     * @summary Cancel an order rolloff
     * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderRolloffsIdCancelPost(requestParameters, options) {
        return OrderRolloffsApiFp(this.configuration)
            .operationsV1OrderRolloffsIdCancelPost(requestParameters.id, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove an order rolloff record from the system using its unique identifier
     * @summary Delete an order rolloff record
     * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderRolloffsIdDelete(requestParameters, options) {
        return OrderRolloffsApiFp(this.configuration)
            .operationsV1OrderRolloffsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single order rolloff record using its unique identifier
     * @summary Get an order rolloff record by ID
     * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderRolloffsIdGet(requestParameters, options) {
        return OrderRolloffsApiFp(this.configuration)
            .operationsV1OrderRolloffsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing order rolloff record with the provided details. The hauler ID is automatically set from the context.
     * @summary Update an order rolloff record
     * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderRolloffsIdPut(requestParameters, options) {
        return OrderRolloffsApiFp(this.configuration)
            .operationsV1OrderRolloffsIdPut(requestParameters.id, requestParameters.orderrolloff, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cancel the boundary SWAP task group, create a fresh PICKUP task group on the predecessor, and move the target plus any downstream subchain to a fresh ord under the same subscription. The legacy \"final pickup\" mode is now handled by the chain-aware Cancel endpoint.
     * @summary Bisect a switch chain at the given switch ord_ro
     * @param {OrderRolloffsApiOperationsV1OrderRolloffsIdSplitSwitchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderRolloffsIdSplitSwitchPost(requestParameters, options) {
        return OrderRolloffsApiFp(this.configuration)
            .operationsV1OrderRolloffsIdSplitSwitchPost(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new order rolloff record. When billing fields (lineItems, etc.) are supplied the new ord_ro is invoiced/charged; otherwise it is created without billing.
     * @summary Create a new order rolloff record
     * @param {OrderRolloffsApiOperationsV1OrderRolloffsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrderRolloffsPost(requestParameters, options) {
        return OrderRolloffsApiFp(this.configuration)
            .operationsV1OrderRolloffsPost(requestParameters.orderrolloff, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1OrderRolloffsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * OrdersApi - axios parameter creator
 */
export const OrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all orders with optional filtering and sorting. Returns orders enriched with service location, charges, commercial, portaloo, and rolloff details.
         * @summary List all orders
         * @param {string} [id] Filter by ID (exact match)
         * @param {string} [ids] Filter by IDs (comma-separated, batch fetching)
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [serviceLocationID] Filter by service location ID
         * @param {string} [status] Filter by status
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [sortBy] Sort by field
         * @param {OperationsV1OrdersGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersGet: async (id, ids, customerID, serviceLocationID, status, subscriptionID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            if (serviceLocationID !== undefined) {
                localVarQueryParameter['serviceLocationID'] = serviceLocationID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (subscriptionID !== undefined) {
                localVarQueryParameter['subscriptionID'] = subscriptionID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete an existing order by its ID
         * @summary delete an order
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrdersIdDelete', 'id', id);
            const localVarPath = `/operations/v1/orders/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single order by its ID
         * @summary Get an order by ID
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrdersIdGet', 'id', id);
            const localVarPath = `/operations/v1/orders/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing order with the provided data
         * @summary update an order
         * @param {string} id Order ID
         * @param {ModelOrder} order Order object
         * @param {boolean} [updateAllLocations] update all subscription orders locations, this only works if an order is part of a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdPut: async (id, order, updateAllLocations, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1OrdersIdPut', 'id', id);
            // verify required parameter 'order' is not null or undefined
            assertParamExists('operationsV1OrdersIdPut', 'order', order);
            const localVarPath = `/operations/v1/orders/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (updateAllLocations !== undefined) {
                localVarQueryParameter['updateAllLocations'] = updateAllLocations;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new order with the provided data
         * @summary create a new order
         * @param {ModelOrder} order Order object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersPost: async (order, options = {}) => {
            // verify required parameter 'order' is not null or undefined
            assertParamExists('operationsV1OrdersPost', 'order', order);
            const localVarPath = `/operations/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrdersApi - functional programming interface
 */
export const OrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all orders with optional filtering and sorting. Returns orders enriched with service location, charges, commercial, portaloo, and rolloff details.
         * @summary List all orders
         * @param {string} [id] Filter by ID (exact match)
         * @param {string} [ids] Filter by IDs (comma-separated, batch fetching)
         * @param {string} [customerID] Filter by customer ID
         * @param {string} [serviceLocationID] Filter by service location ID
         * @param {string} [status] Filter by status
         * @param {string} [subscriptionID] Filter by subscription ID
         * @param {string} [sortBy] Sort by field
         * @param {OperationsV1OrdersGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersGet(id, ids, customerID, serviceLocationID, status, subscriptionID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersGet(id, ids, customerID, serviceLocationID, status, subscriptionID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete an existing order by its ID
         * @summary delete an order
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single order by its ID
         * @summary Get an order by ID
         * @param {string} id Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing order with the provided data
         * @summary update an order
         * @param {string} id Order ID
         * @param {ModelOrder} order Order object
         * @param {boolean} [updateAllLocations] update all subscription orders locations, this only works if an order is part of a subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersIdPut(id, order, updateAllLocations, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersIdPut(id, order, updateAllLocations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new order with the provided data
         * @summary create a new order
         * @param {ModelOrder} order Order object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1OrdersPost(order, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1OrdersPost(order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.operationsV1OrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrdersApi - factory interface
 */
export const OrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrdersApiFp(configuration);
    return {
        /**
         * Get all orders with optional filtering and sorting. Returns orders enriched with service location, charges, commercial, portaloo, and rolloff details.
         * @summary List all orders
         * @param {OrdersApiOperationsV1OrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1OrdersGet(requestParameters.id, requestParameters.ids, requestParameters.customerID, requestParameters.serviceLocationID, requestParameters.status, requestParameters.subscriptionID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * delete an existing order by its ID
         * @summary delete an order
         * @param {OrdersApiOperationsV1OrdersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdDelete(requestParameters, options) {
            return localVarFp.operationsV1OrdersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single order by its ID
         * @summary Get an order by ID
         * @param {OrdersApiOperationsV1OrdersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdGet(requestParameters, options) {
            return localVarFp.operationsV1OrdersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing order with the provided data
         * @summary update an order
         * @param {OrdersApiOperationsV1OrdersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1OrdersIdPut(requestParameters.id, requestParameters.order, requestParameters.updateAllLocations, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * create a new order with the provided data
         * @summary create a new order
         * @param {OrdersApiOperationsV1OrdersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1OrdersPost(requestParameters, options) {
            return localVarFp.operationsV1OrdersPost(requestParameters.order, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrdersApi - object-oriented interface
 */
export class OrdersApi extends BaseAPI {
    /**
     * Get all orders with optional filtering and sorting. Returns orders enriched with service location, charges, commercial, portaloo, and rolloff details.
     * @summary List all orders
     * @param {OrdersApiOperationsV1OrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrdersGet(requestParameters = {}, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersGet(requestParameters.id, requestParameters.ids, requestParameters.customerID, requestParameters.serviceLocationID, requestParameters.status, requestParameters.subscriptionID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an existing order by its ID
     * @summary delete an order
     * @param {OrdersApiOperationsV1OrdersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrdersIdDelete(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single order by its ID
     * @summary Get an order by ID
     * @param {OrdersApiOperationsV1OrdersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrdersIdGet(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * update an existing order with the provided data
     * @summary update an order
     * @param {OrdersApiOperationsV1OrdersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrdersIdPut(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersIdPut(requestParameters.id, requestParameters.order, requestParameters.updateAllLocations, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new order with the provided data
     * @summary create a new order
     * @param {OrdersApiOperationsV1OrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1OrdersPost(requestParameters, options) {
        return OrdersApiFp(this.configuration)
            .operationsV1OrdersPost(requestParameters.order, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1OrdersGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * PublicCheckoutApi - axios parameter creator
 */
export const PublicCheckoutApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new subscription from a public checkout request with signed quote validation
         * @summary Create subscription from online checkout
         * @param {PubliccheckoutSubscriptionCreateRequest} request Checkout request with signed quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1PublicCheckoutPost: async (request, options = {}) => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('operationsV1PublicCheckoutPost', 'request', request);
            const localVarPath = `/operations/v1/public/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PublicCheckoutApi - functional programming interface
 */
export const PublicCheckoutApiFp = function (configuration) {
    const localVarAxiosParamCreator = PublicCheckoutApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a new subscription from a public checkout request with signed quote validation
         * @summary Create subscription from online checkout
         * @param {PubliccheckoutSubscriptionCreateRequest} request Checkout request with signed quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1PublicCheckoutPost(request, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1PublicCheckoutPost(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicCheckoutApi.operationsV1PublicCheckoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PublicCheckoutApi - factory interface
 */
export const PublicCheckoutApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PublicCheckoutApiFp(configuration);
    return {
        /**
         * Create a new subscription from a public checkout request with signed quote validation
         * @summary Create subscription from online checkout
         * @param {PublicCheckoutApiOperationsV1PublicCheckoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1PublicCheckoutPost(requestParameters, options) {
            return localVarFp
                .operationsV1PublicCheckoutPost(requestParameters.request, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PublicCheckoutApi - object-oriented interface
 */
export class PublicCheckoutApi extends BaseAPI {
    /**
     * Create a new subscription from a public checkout request with signed quote validation
     * @summary Create subscription from online checkout
     * @param {PublicCheckoutApiOperationsV1PublicCheckoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1PublicCheckoutPost(requestParameters, options) {
        return PublicCheckoutApiFp(this.configuration)
            .operationsV1PublicCheckoutPost(requestParameters.request, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ServiceLineListOptionsApi - axios parameter creator
 */
export const ServiceLineListOptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Delete an existing service line list option by its ID. Returns 404 if not found.
         * @summary Delete a service line list option
         * @param {string} id Service Line List Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-line-list-options/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
         * @summary Update a service line list option
         * @param {string} id Service Line List Option ID
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdPut: async (id, serviceLineListOption, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsIdPut', 'id', id);
            // verify required parameter 'serviceLineListOption' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsIdPut', 'serviceLineListOption', serviceLineListOption);
            const localVarPath = `/operations/v1/service-line-list-options/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineListOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
         * @summary Create a new service line list option
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsPost: async (serviceLineListOption, options = {}) => {
            // verify required parameter 'serviceLineListOption' is not null or undefined
            assertParamExists('operationsV1ServiceLineListOptionsPost', 'serviceLineListOption', serviceLineListOption);
            const localVarPath = `/operations/v1/service-line-list-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineListOption, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLineListOptionsApi - functional programming interface
 */
export const ServiceLineListOptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLineListOptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Delete an existing service line list option by its ID. Returns 404 if not found.
         * @summary Delete a service line list option
         * @param {string} id Service Line List Option ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListOptionsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListOptionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListOptionsApi.operationsV1ServiceLineListOptionsIdDelete']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
         * @summary Update a service line list option
         * @param {string} id Service Line List Option ID
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListOptionsIdPut(id, serviceLineListOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListOptionsIdPut(id, serviceLineListOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListOptionsApi.operationsV1ServiceLineListOptionsIdPut']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
         * @summary Create a new service line list option
         * @param {ModelServiceLineListOption} serviceLineListOption Service Line List Option object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListOptionsPost(serviceLineListOption, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListOptionsPost(serviceLineListOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListOptionsApi.operationsV1ServiceLineListOptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLineListOptionsApi - factory interface
 */
export const ServiceLineListOptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLineListOptionsApiFp(configuration);
    return {
        /**
         * Delete an existing service line list option by its ID. Returns 404 if not found.
         * @summary Delete a service line list option
         * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListOptionsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
         * @summary Update a service line list option
         * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListOptionsIdPut(requestParameters.id, requestParameters.serviceLineListOption, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
         * @summary Create a new service line list option
         * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListOptionsPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListOptionsPost(requestParameters.serviceLineListOption, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLineListOptionsApi - object-oriented interface
 */
export class ServiceLineListOptionsApi extends BaseAPI {
    /**
     * Delete an existing service line list option by its ID. Returns 404 if not found.
     * @summary Delete a service line list option
     * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListOptionsIdDelete(requestParameters, options) {
        return ServiceLineListOptionsApiFp(this.configuration)
            .operationsV1ServiceLineListOptionsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing service line list option with the provided data. Returns 404 if not found, 409 if an option with the same value already exists for the service line.
     * @summary Update a service line list option
     * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListOptionsIdPut(requestParameters, options) {
        return ServiceLineListOptionsApiFp(this.configuration)
            .operationsV1ServiceLineListOptionsIdPut(requestParameters.id, requestParameters.serviceLineListOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service line list option with the provided data. Returns 409 if an option with the same value already exists for the service line.
     * @summary Create a new service line list option
     * @param {ServiceLineListOptionsApiOperationsV1ServiceLineListOptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListOptionsPost(requestParameters, options) {
        return ServiceLineListOptionsApiFp(this.configuration)
            .operationsV1ServiceLineListOptionsPost(requestParameters.serviceLineListOption, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ServiceLineListsApi - axios parameter creator
 */
export const ServiceLineListsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
         * @summary List all service line lists
         * @param {string} [id] Filter by service line list ID
         * @param {string} [name] Filter by service line list name
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLineListsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsGet: async (id, name, haulerID, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/service-line-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a service line list from the system using its unique identifier
         * @summary Delete a service line list
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-line-lists/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single service line list using its unique identifier
         * @summary Get a service line list by ID
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdGet', 'id', id);
            const localVarPath = `/operations/v1/service-line-lists/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line list
         * @param {string} id Service Line List ID
         * @param {ModelServiceLineList} serviceLineList Service Line List object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdPut: async (id, serviceLineList, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdPut', 'id', id);
            // verify required parameter 'serviceLineList' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsIdPut', 'serviceLineList', serviceLineList);
            const localVarPath = `/operations/v1/service-line-lists/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service line list with the provided details
         * @summary Create a new service line list
         * @param {ModelServiceLineList} serviceLineList Service Line List object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsPost: async (serviceLineList, options = {}) => {
            // verify required parameter 'serviceLineList' is not null or undefined
            assertParamExists('operationsV1ServiceLineListsPost', 'serviceLineList', serviceLineList);
            const localVarPath = `/operations/v1/service-line-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLineList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLineListsApi - functional programming interface
 */
export const ServiceLineListsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLineListsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
         * @summary List all service line lists
         * @param {string} [id] Filter by service line list ID
         * @param {string} [name] Filter by service line list name
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, name, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLineListsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsGet(id, name, haulerID, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsGet(id, name, haulerID, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a service line list from the system using its unique identifier
         * @summary Delete a service line list
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single service line list using its unique identifier
         * @summary Get a service line list by ID
         * @param {string} id Service Line List ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line list
         * @param {string} id Service Line List ID
         * @param {ModelServiceLineList} serviceLineList Service Line List object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsIdPut(id, serviceLineList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsIdPut(id, serviceLineList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service line list with the provided details
         * @summary Create a new service line list
         * @param {ModelServiceLineList} serviceLineList Service Line List object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLineListsPost(serviceLineList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLineListsPost(serviceLineList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLineListsApi.operationsV1ServiceLineListsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLineListsApi - factory interface
 */
export const ServiceLineListsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLineListsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
         * @summary List all service line lists
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1ServiceLineListsGet(requestParameters.id, requestParameters.name, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a service line list from the system using its unique identifier
         * @summary Delete a service line list
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single service line list using its unique identifier
         * @summary Get a service line list by ID
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdGet(requestParameters, options) {
            return localVarFp.operationsV1ServiceLineListsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line list
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListsIdPut(requestParameters.id, requestParameters.serviceLineList, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service line list with the provided details
         * @summary Create a new service line list
         * @param {ServiceLineListsApiOperationsV1ServiceLineListsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLineListsPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLineListsPost(requestParameters.serviceLineList, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLineListsApi - object-oriented interface
 */
export class ServiceLineListsApi extends BaseAPI {
    /**
     * Retrieve a list of all service line lists with options to filter, sort, and paginate the results
     * @summary List all service line lists
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListsGet(requestParameters = {}, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsGet(requestParameters.id, requestParameters.name, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a service line list from the system using its unique identifier
     * @summary Delete a service line list
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListsIdDelete(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single service line list using its unique identifier
     * @summary Get a service line list by ID
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListsIdGet(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing service line list with the provided details. The hauler ID is automatically set from the context.
     * @summary Update a service line list
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListsIdPut(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsIdPut(requestParameters.id, requestParameters.serviceLineList, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service line list with the provided details
     * @summary Create a new service line list
     * @param {ServiceLineListsApiOperationsV1ServiceLineListsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLineListsPost(requestParameters, options) {
        return ServiceLineListsApiFp(this.configuration)
            .operationsV1ServiceLineListsPost(requestParameters.serviceLineList, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1ServiceLineListsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * ServiceLinesApi - axios parameter creator
 */
export const ServiceLinesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all service lines with options to filter, sort, and paginate the results
         * @summary List all service lines
         * @param {string} [id] Filter by service line ID
         * @param {string} [key] Filter by service line key
         * @param {string} [label] Filter by service line label
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, key, label, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLinesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {boolean} [shouldIncludeDefault] Include default-hauler service lines alongside the requesting hauler\&#39;s
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesGet: async (id, key, label, haulerID, sortBy, sortDir, offset, limit, shouldIncludeDefault, options = {}) => {
            const localVarPath = `/operations/v1/service-lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (shouldIncludeDefault !== undefined) {
                localVarQueryParameter['shouldIncludeDefault'] = shouldIncludeDefault;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a service line from the system using its unique identifier
         * @summary Delete a service line
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-lines/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single service line using its unique identifier
         * @summary Get a service line by ID
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdGet', 'id', id);
            const localVarPath = `/operations/v1/service-lines/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line
         * @param {string} id Service Line ID
         * @param {ModelServiceLine} serviceLine Service Line object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdPut: async (id, serviceLine, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdPut', 'id', id);
            // verify required parameter 'serviceLine' is not null or undefined
            assertParamExists('operationsV1ServiceLinesIdPut', 'serviceLine', serviceLine);
            const localVarPath = `/operations/v1/service-lines/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service line with the provided details
         * @summary Create a new service line
         * @param {ModelServiceLine} serviceLine Service Line object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesPost: async (serviceLine, options = {}) => {
            // verify required parameter 'serviceLine' is not null or undefined
            assertParamExists('operationsV1ServiceLinesPost', 'serviceLine', serviceLine);
            const localVarPath = `/operations/v1/service-lines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLinesApi - functional programming interface
 */
export const ServiceLinesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLinesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all service lines with options to filter, sort, and paginate the results
         * @summary List all service lines
         * @param {string} [id] Filter by service line ID
         * @param {string} [key] Filter by service line key
         * @param {string} [label] Filter by service line label
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [sortBy] Sort by field (id, key, label, haulerID, sortOrder, createdAt, lastUpdatedAt)
         * @param {OperationsV1ServiceLinesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {boolean} [shouldIncludeDefault] Include default-hauler service lines alongside the requesting hauler\&#39;s
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesGet(id, key, label, haulerID, sortBy, sortDir, offset, limit, shouldIncludeDefault, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesGet(id, key, label, haulerID, sortBy, sortDir, offset, limit, shouldIncludeDefault, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a service line from the system using its unique identifier
         * @summary Delete a service line
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single service line using its unique identifier
         * @summary Get a service line by ID
         * @param {string} id Service Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line
         * @param {string} id Service Line ID
         * @param {ModelServiceLine} serviceLine Service Line object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesIdPut(id, serviceLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesIdPut(id, serviceLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service line with the provided details
         * @summary Create a new service line
         * @param {ModelServiceLine} serviceLine Service Line object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLinesPost(serviceLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLinesPost(serviceLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.operationsV1ServiceLinesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLinesApi - factory interface
 */
export const ServiceLinesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLinesApiFp(configuration);
    return {
        /**
         * Retrieve a list of all service lines with options to filter, sort, and paginate the results
         * @summary List all service lines
         * @param {ServiceLinesApiOperationsV1ServiceLinesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1ServiceLinesGet(requestParameters.id, requestParameters.key, requestParameters.label, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, requestParameters.shouldIncludeDefault, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a service line from the system using its unique identifier
         * @summary Delete a service line
         * @param {ServiceLinesApiOperationsV1ServiceLinesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdDelete(requestParameters, options) {
            return localVarFp.operationsV1ServiceLinesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single service line using its unique identifier
         * @summary Get a service line by ID
         * @param {ServiceLinesApiOperationsV1ServiceLinesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdGet(requestParameters, options) {
            return localVarFp.operationsV1ServiceLinesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
         * @summary Update a service line
         * @param {ServiceLinesApiOperationsV1ServiceLinesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLinesIdPut(requestParameters.id, requestParameters.serviceLine, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service line with the provided details
         * @summary Create a new service line
         * @param {ServiceLinesApiOperationsV1ServiceLinesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLinesPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLinesPost(requestParameters.serviceLine, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLinesApi - object-oriented interface
 */
export class ServiceLinesApi extends BaseAPI {
    /**
     * Retrieve a list of all service lines with options to filter, sort, and paginate the results
     * @summary List all service lines
     * @param {ServiceLinesApiOperationsV1ServiceLinesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLinesGet(requestParameters = {}, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesGet(requestParameters.id, requestParameters.key, requestParameters.label, requestParameters.haulerID, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, requestParameters.shouldIncludeDefault, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a service line from the system using its unique identifier
     * @summary Delete a service line
     * @param {ServiceLinesApiOperationsV1ServiceLinesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLinesIdDelete(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single service line using its unique identifier
     * @summary Get a service line by ID
     * @param {ServiceLinesApiOperationsV1ServiceLinesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLinesIdGet(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing service line with the provided details. The hauler ID is automatically set from the context.
     * @summary Update a service line
     * @param {ServiceLinesApiOperationsV1ServiceLinesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLinesIdPut(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesIdPut(requestParameters.id, requestParameters.serviceLine, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service line with the provided details
     * @summary Create a new service line
     * @param {ServiceLinesApiOperationsV1ServiceLinesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLinesPost(requestParameters, options) {
        return ServiceLinesApiFp(this.configuration)
            .operationsV1ServiceLinesPost(requestParameters.serviceLine, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1ServiceLinesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * ServiceLocationsApi - axios parameter creator
 */
export const ServiceLocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering. If customerId is provided as a query parameter, it will be used for filtering. The legacy customerID query parameter is also supported. If not provided, the customerID from the JWT token will be used as a default. If no customerID is available in the JWT token, no customerID filter will be applied.
         * @summary List all service locations
         * @param {OperationsV1ServiceLocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {string} [customerId] Filter by customer ID (UUID format). If not provided, defaults to the customer ID from the JWT token. If no customer ID is available in the JWT token, this filter is not applied.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsGet: async (sortDir, customerId, options = {}) => {
            const localVarPath = `/operations/v1/service-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/service-locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdGet', 'id', id);
            const localVarPath = `/operations/v1/service-locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {string} id Service Location ID
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdPut: async (id, serviceLocation, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdPut', 'id', id);
            // verify required parameter 'serviceLocation' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsIdPut', 'serviceLocation', serviceLocation);
            const localVarPath = `/operations/v1/service-locations/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsPost: async (serviceLocation, options = {}) => {
            // verify required parameter 'serviceLocation' is not null or undefined
            assertParamExists('operationsV1ServiceLocationsPost', 'serviceLocation', serviceLocation);
            const localVarPath = `/operations/v1/service-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ServiceLocationsApi - functional programming interface
 */
export const ServiceLocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ServiceLocationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering. If customerId is provided as a query parameter, it will be used for filtering. The legacy customerID query parameter is also supported. If not provided, the customerID from the JWT token will be used as a default. If no customerID is available in the JWT token, no customerID filter will be applied.
         * @summary List all service locations
         * @param {OperationsV1ServiceLocationsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {string} [customerId] Filter by customer ID (UUID format). If not provided, defaults to the customer ID from the JWT token. If no customer ID is available in the JWT token, this filter is not applied.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsGet(sortDir, customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsGet(sortDir, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {string} id Service Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {string} id Service Location ID
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsIdPut(id, serviceLocation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsIdPut(id, serviceLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ModelServiceLocation} serviceLocation Service Location object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1ServiceLocationsPost(serviceLocation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1ServiceLocationsPost(serviceLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationsApi.operationsV1ServiceLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ServiceLocationsApi - factory interface
 */
export const ServiceLocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ServiceLocationsApiFp(configuration);
    return {
        /**
         * Get all service locations with optional filtering and sorting. Supports pagination and field filtering. If customerId is provided as a query parameter, it will be used for filtering. The legacy customerID query parameter is also supported. If not provided, the customerID from the JWT token will be used as a default. If no customerID is available in the JWT token, no customerID filter will be applied.
         * @summary List all service locations
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1ServiceLocationsGet(requestParameters.sortDir, requestParameters.customerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing service location by its ID
         * @summary Delete a service location
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdDelete(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLocationsIdDelete(requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single service location by its ID
         * @summary Get a service location by ID
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdGet(requestParameters, options) {
            return localVarFp.operationsV1ServiceLocationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing service location with the provided data
         * @summary Update a service location
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLocationsIdPut(requestParameters.id, requestParameters.serviceLocation, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new service location with the provided data
         * @summary Create a new service location
         * @param {ServiceLocationsApiOperationsV1ServiceLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1ServiceLocationsPost(requestParameters, options) {
            return localVarFp
                .operationsV1ServiceLocationsPost(requestParameters.serviceLocation, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ServiceLocationsApi - object-oriented interface
 */
export class ServiceLocationsApi extends BaseAPI {
    /**
     * Get all service locations with optional filtering and sorting. Supports pagination and field filtering. If customerId is provided as a query parameter, it will be used for filtering. The legacy customerID query parameter is also supported. If not provided, the customerID from the JWT token will be used as a default. If no customerID is available in the JWT token, no customerID filter will be applied.
     * @summary List all service locations
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLocationsGet(requestParameters = {}, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsGet(requestParameters.sortDir, requestParameters.customerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an existing service location by its ID
     * @summary Delete a service location
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLocationsIdDelete(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single service location by its ID
     * @summary Get a service location by ID
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLocationsIdGet(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing service location with the provided data
     * @summary Update a service location
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLocationsIdPut(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsIdPut(requestParameters.id, requestParameters.serviceLocation, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new service location with the provided data
     * @summary Create a new service location
     * @param {ServiceLocationsApiOperationsV1ServiceLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1ServiceLocationsPost(requestParameters, options) {
        return ServiceLocationsApiFp(this.configuration)
            .operationsV1ServiceLocationsPost(requestParameters.serviceLocation, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1ServiceLocationsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * SubscriptionsApi - axios parameter creator
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve the fully-enriched subscription that contains the given entity. The
         * @summary Get the subscription that owns an entity
         * @param {OperationsV1SubscriptionsByEntityGetTypeEnum} type Entity type
         * @param {string} id Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsByEntityGet: async (type, id, options = {}) => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('operationsV1SubscriptionsByEntityGet', 'type', type);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1SubscriptionsByEntityGet', 'id', id);
            const localVarPath = `/operations/v1/subscriptions/by-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count of subscriptions for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by subscription start). serviceLine selects the order-type the subscription must contain (COMMERCIAL today). Powers SourScore\'s commercial setup-success denominator (serviceLine=COMMERCIAL, a vendorID).
         * @summary Count subscriptions for a service line
         * @param {string} serviceLine Service line (COMMERCIAL)
         * @param {string} [vendorID] Servicing vendor ID (uuid) to scope to
         * @param {string} [status] Subscription status filter (e.g. ACTIVE)
         * @param {string} [fromDate] Window start (RFC3339 or yyyy-MM-dd); filters subscriptions where StartTimestamp &gt;&#x3D; fromDate
         * @param {string} [toDate] Window end (RFC3339 or yyyy-MM-dd); filters subscriptions where StartTimestamp &lt;&#x3D; toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsCountGet: async (serviceLine, vendorID, status, fromDate, toDate, options = {}) => {
            // verify required parameter 'serviceLine' is not null or undefined
            assertParamExists('operationsV1SubscriptionsCountGet', 'serviceLine', serviceLine);
            const localVarPath = `/operations/v1/subscriptions/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (serviceLine !== undefined) {
                localVarQueryParameter['serviceLine'] = serviceLine;
            }
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
         * @summary List all subscriptions
         * @param {string} [subscriptionID] Filter by subscription IDs
         * @param {string} [customerID] Filter by customer ID (admin/hauler only)
         * @param {string} [vendorID] Filter by vendor ID (subscriptions with at least one ord_comm assigned to this vendor)
         * @param {string} [status] Filter by subscription status
         * @param {string} [startDate] Filter by start date (RFC3339 format)
         * @param {string} [endDate] Filter by end date (RFC3339 format)
         * @param {string} [fromDate] Filter by from date (RFC3339 format). Filters subscriptions where StartTimestamp &gt;&#x3D; fromDate
         * @param {string} [toDate] Filter by to date (RFC3339 format). Filters subscriptions where EndTimestamp &lt;&#x3D; toDate
         * @param {string} [subscriptionType] Filter by subscription order type (ORDER_PT_LOO, ORDER_RO, ORDER_COMMERCIAL)
         * @param {boolean} [includeCustomer] Set false to skip customer enrichment — subscriptions come back without their nested customer
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1SubscriptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsGet: async (subscriptionID, customerID, vendorID, status, startDate, endDate, fromDate, toDate, subscriptionType, includeCustomer, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (subscriptionID !== undefined) {
                localVarQueryParameter['subscriptionID'] = subscriptionID;
            }
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (subscriptionType !== undefined) {
                localVarQueryParameter['subscriptionType'] = subscriptionType;
            }
            if (includeCustomer !== undefined) {
                localVarQueryParameter['includeCustomer'] = includeCustomer;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a subscription from the system using its unique identifier
         * @summary Delete a subscription
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/subscriptions/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single subscription using its unique identifier
         * @summary Get a subscription by ID
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdGet', 'id', id);
            const localVarPath = `/operations/v1/subscriptions/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing subscription with the provided details
         * @summary update a subscription
         * @param {string} id Subscription ID
         * @param {ModelSubscription} subscription Subscription object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdPut: async (id, subscription, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdPut', 'id', id);
            // verify required parameter 'subscription' is not null or undefined
            assertParamExists('operationsV1SubscriptionsIdPut', 'subscription', subscription);
            const localVarPath = `/operations/v1/subscriptions/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(subscription, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of roll-off orders for one customer, returned as subscription stubs — one stub per ord_ro row, sorted by created_at DESC.
         * @summary List a customer\'s roll-off orders (paginated)
         * @param {string} customerID Customer ID (required)
         * @param {number} [limit] Page size (default 25)
         * @param {number} [offset] Page offset (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsOperationRollOffOrdersGet: async (customerID, limit, offset, options = {}) => {
            // verify required parameter 'customerID' is not null or undefined
            assertParamExists('operationsV1SubscriptionsOperationRollOffOrdersGet', 'customerID', customerID);
            const localVarPath = `/operations/v1/subscriptions/operation-roll-off-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new subscription with the provided details. When the body includes
         * @summary Create a new subscription
         * @param {SubscriptionAdminSubscriptionCreateRequest} subscription Subscription object (with optional billing fields)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsPost: async (subscription, options = {}) => {
            // verify required parameter 'subscription' is not null or undefined
            assertParamExists('operationsV1SubscriptionsPost', 'subscription', subscription);
            const localVarPath = `/operations/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(subscription, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search the rolloff order Elasticsearch index and return the unique parent subscriptions matching the given query
         * @summary Search subscriptions by rolloff order criteria
         * @param {object} query Elasticsearch query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsRolloffSearchPost: async (query, options = {}) => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('operationsV1SubscriptionsRolloffSearchPost', 'query', query);
            const localVarPath = `/operations/v1/subscriptions/rolloff-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(query, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for subscriptions based on provided search criteria
         * @summary Search subscriptions
         * @param {object} query Search query parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsSearchPost: async (query, options = {}) => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('operationsV1SubscriptionsSearchPost', 'query', query);
            const localVarPath = `/operations/v1/subscriptions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(query, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SubscriptionsApi - functional programming interface
 */
export const SubscriptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve the fully-enriched subscription that contains the given entity. The
         * @summary Get the subscription that owns an entity
         * @param {OperationsV1SubscriptionsByEntityGetTypeEnum} type Entity type
         * @param {string} id Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsByEntityGet(type, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsByEntityGet(type, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsByEntityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count of subscriptions for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by subscription start). serviceLine selects the order-type the subscription must contain (COMMERCIAL today). Powers SourScore\'s commercial setup-success denominator (serviceLine=COMMERCIAL, a vendorID).
         * @summary Count subscriptions for a service line
         * @param {string} serviceLine Service line (COMMERCIAL)
         * @param {string} [vendorID] Servicing vendor ID (uuid) to scope to
         * @param {string} [status] Subscription status filter (e.g. ACTIVE)
         * @param {string} [fromDate] Window start (RFC3339 or yyyy-MM-dd); filters subscriptions where StartTimestamp &gt;&#x3D; fromDate
         * @param {string} [toDate] Window end (RFC3339 or yyyy-MM-dd); filters subscriptions where StartTimestamp &lt;&#x3D; toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsCountGet(serviceLine, vendorID, status, fromDate, toDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsCountGet(serviceLine, vendorID, status, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
         * @summary List all subscriptions
         * @param {string} [subscriptionID] Filter by subscription IDs
         * @param {string} [customerID] Filter by customer ID (admin/hauler only)
         * @param {string} [vendorID] Filter by vendor ID (subscriptions with at least one ord_comm assigned to this vendor)
         * @param {string} [status] Filter by subscription status
         * @param {string} [startDate] Filter by start date (RFC3339 format)
         * @param {string} [endDate] Filter by end date (RFC3339 format)
         * @param {string} [fromDate] Filter by from date (RFC3339 format). Filters subscriptions where StartTimestamp &gt;&#x3D; fromDate
         * @param {string} [toDate] Filter by to date (RFC3339 format). Filters subscriptions where EndTimestamp &lt;&#x3D; toDate
         * @param {string} [subscriptionType] Filter by subscription order type (ORDER_PT_LOO, ORDER_RO, ORDER_COMMERCIAL)
         * @param {boolean} [includeCustomer] Set false to skip customer enrichment — subscriptions come back without their nested customer
         * @param {string} [sortBy] Sort by field (status, startTimestamp, endTimestamp, createdAt)
         * @param {OperationsV1SubscriptionsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsGet(subscriptionID, customerID, vendorID, status, startDate, endDate, fromDate, toDate, subscriptionType, includeCustomer, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsGet(subscriptionID, customerID, vendorID, status, startDate, endDate, fromDate, toDate, subscriptionType, includeCustomer, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a subscription from the system using its unique identifier
         * @summary Delete a subscription
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single subscription using its unique identifier
         * @summary Get a subscription by ID
         * @param {string} id Subscription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing subscription with the provided details
         * @summary update a subscription
         * @param {string} id Subscription ID
         * @param {ModelSubscription} subscription Subscription object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsIdPut(id, subscription, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsIdPut(id, subscription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of roll-off orders for one customer, returned as subscription stubs — one stub per ord_ro row, sorted by created_at DESC.
         * @summary List a customer\'s roll-off orders (paginated)
         * @param {string} customerID Customer ID (required)
         * @param {number} [limit] Page size (default 25)
         * @param {number} [offset] Page offset (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsOperationRollOffOrdersGet(customerID, limit, offset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsOperationRollOffOrdersGet(customerID, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsOperationRollOffOrdersGet']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new subscription with the provided details. When the body includes
         * @summary Create a new subscription
         * @param {SubscriptionAdminSubscriptionCreateRequest} subscription Subscription object (with optional billing fields)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsPost(subscription, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsPost(subscription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search the rolloff order Elasticsearch index and return the unique parent subscriptions matching the given query
         * @summary Search subscriptions by rolloff order criteria
         * @param {object} query Elasticsearch query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsRolloffSearchPost(query, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsRolloffSearchPost(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsRolloffSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for subscriptions based on provided search criteria
         * @summary Search subscriptions
         * @param {object} query Search query parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1SubscriptionsSearchPost(query, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1SubscriptionsSearchPost(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.operationsV1SubscriptionsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SubscriptionsApi - factory interface
 */
export const SubscriptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SubscriptionsApiFp(configuration);
    return {
        /**
         * Retrieve the fully-enriched subscription that contains the given entity. The
         * @summary Get the subscription that owns an entity
         * @param {SubscriptionsApiOperationsV1SubscriptionsByEntityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsByEntityGet(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsByEntityGet(requestParameters.type, requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Count of subscriptions for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by subscription start). serviceLine selects the order-type the subscription must contain (COMMERCIAL today). Powers SourScore\'s commercial setup-success denominator (serviceLine=COMMERCIAL, a vendorID).
         * @summary Count subscriptions for a service line
         * @param {SubscriptionsApiOperationsV1SubscriptionsCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsCountGet(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsCountGet(requestParameters.serviceLine, requestParameters.vendorID, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
         * @summary List all subscriptions
         * @param {SubscriptionsApiOperationsV1SubscriptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1SubscriptionsGet(requestParameters.subscriptionID, requestParameters.customerID, requestParameters.vendorID, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.fromDate, requestParameters.toDate, requestParameters.subscriptionType, requestParameters.includeCustomer, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove a subscription from the system using its unique identifier
         * @summary Delete a subscription
         * @param {SubscriptionsApiOperationsV1SubscriptionsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1SubscriptionsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single subscription using its unique identifier
         * @summary Get a subscription by ID
         * @param {SubscriptionsApiOperationsV1SubscriptionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdGet(requestParameters, options) {
            return localVarFp.operationsV1SubscriptionsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing subscription with the provided details
         * @summary update a subscription
         * @param {SubscriptionsApiOperationsV1SubscriptionsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsIdPut(requestParameters.id, requestParameters.subscription, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of roll-off orders for one customer, returned as subscription stubs — one stub per ord_ro row, sorted by created_at DESC.
         * @summary List a customer\'s roll-off orders (paginated)
         * @param {SubscriptionsApiOperationsV1SubscriptionsOperationRollOffOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsOperationRollOffOrdersGet(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsOperationRollOffOrdersGet(requestParameters.customerID, requestParameters.limit, requestParameters.offset, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new subscription with the provided details. When the body includes
         * @summary Create a new subscription
         * @param {SubscriptionsApiOperationsV1SubscriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsPost(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsPost(requestParameters.subscription, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Search the rolloff order Elasticsearch index and return the unique parent subscriptions matching the given query
         * @summary Search subscriptions by rolloff order criteria
         * @param {SubscriptionsApiOperationsV1SubscriptionsRolloffSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsRolloffSearchPost(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsRolloffSearchPost(requestParameters.query, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Search for subscriptions based on provided search criteria
         * @summary Search subscriptions
         * @param {SubscriptionsApiOperationsV1SubscriptionsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1SubscriptionsSearchPost(requestParameters, options) {
            return localVarFp
                .operationsV1SubscriptionsSearchPost(requestParameters.query, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * SubscriptionsApi - object-oriented interface
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     * Retrieve the fully-enriched subscription that contains the given entity. The
     * @summary Get the subscription that owns an entity
     * @param {SubscriptionsApiOperationsV1SubscriptionsByEntityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsByEntityGet(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsByEntityGet(requestParameters.type, requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Count of subscriptions for a service line, optionally scoped to a servicing vendor and/or status, over an optional [fromDate, toDate] window (by subscription start). serviceLine selects the order-type the subscription must contain (COMMERCIAL today). Powers SourScore\'s commercial setup-success denominator (serviceLine=COMMERCIAL, a vendorID).
     * @summary Count subscriptions for a service line
     * @param {SubscriptionsApiOperationsV1SubscriptionsCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsCountGet(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsCountGet(requestParameters.serviceLine, requestParameters.vendorID, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of all subscriptions with options to filter, sort, and paginate the results
     * @summary List all subscriptions
     * @param {SubscriptionsApiOperationsV1SubscriptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsGet(requestParameters = {}, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsGet(requestParameters.subscriptionID, requestParameters.customerID, requestParameters.vendorID, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.fromDate, requestParameters.toDate, requestParameters.subscriptionType, requestParameters.includeCustomer, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a subscription from the system using its unique identifier
     * @summary Delete a subscription
     * @param {SubscriptionsApiOperationsV1SubscriptionsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsIdDelete(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single subscription using its unique identifier
     * @summary Get a subscription by ID
     * @param {SubscriptionsApiOperationsV1SubscriptionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsIdGet(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Modify an existing subscription with the provided details
     * @summary update a subscription
     * @param {SubscriptionsApiOperationsV1SubscriptionsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsIdPut(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsIdPut(requestParameters.id, requestParameters.subscription, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Paginated list of roll-off orders for one customer, returned as subscription stubs — one stub per ord_ro row, sorted by created_at DESC.
     * @summary List a customer\'s roll-off orders (paginated)
     * @param {SubscriptionsApiOperationsV1SubscriptionsOperationRollOffOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsOperationRollOffOrdersGet(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsOperationRollOffOrdersGet(requestParameters.customerID, requestParameters.limit, requestParameters.offset, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new subscription with the provided details. When the body includes
     * @summary Create a new subscription
     * @param {SubscriptionsApiOperationsV1SubscriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsPost(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsPost(requestParameters.subscription, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search the rolloff order Elasticsearch index and return the unique parent subscriptions matching the given query
     * @summary Search subscriptions by rolloff order criteria
     * @param {SubscriptionsApiOperationsV1SubscriptionsRolloffSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsRolloffSearchPost(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsRolloffSearchPost(requestParameters.query, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for subscriptions based on provided search criteria
     * @summary Search subscriptions
     * @param {SubscriptionsApiOperationsV1SubscriptionsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1SubscriptionsSearchPost(requestParameters, options) {
        return SubscriptionsApiFp(this.configuration)
            .operationsV1SubscriptionsSearchPost(requestParameters.query, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1SubscriptionsByEntityGetTypeEnum = {
    Order: 'order',
    OrderRo: 'order-ro',
};
export const OperationsV1SubscriptionsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * TaskGroupsApi - axios parameter creator
 */
export const TaskGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all task groups, including their associated tasks and references, with filtering, sorting, and pagination options
         * @summary List all task groups
         * @param {string} [id] Filter by task group ID
         * @param {string} [status] Filter by status
         * @param {OperationsV1TaskGroupsGetSortByEnum} [sortBy] Sort by field. Valid values: sortOrder, createdAt/timestamp, taskStartDateTime. When sorting by taskStartDateTime, task groups are sorted by the minimum (earliest) StartDateTime of their tasks using GROUP BY. Task groups with tasks having NULL StartDateTime will appear first (NULLS_FIRST), followed by task groups sorted by their earliest StartDateTime in the specified sort direction. This sorting is applied before pagination to ensure correct ordering across pages. Does not impact the order of listed tasks within each task group, which is always descending by those tasks\&#39; sortOrder.
         * @param {OperationsV1TaskGroupsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC). Does not impact the order of listed tasks within each task group, which is always descending by those tasks\&#39; sortOrder.
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {string} [taskFromDate] Include tasks in associated task groups that start on or after this date and time (RFC3339 format, including time and timezone). Task groups without any tasks matching this filter will not appear in the response.
         * @param {string} [taskToDate] Include tasks in associated task groups that end before or on this date and time (RFC3339 format, including time and timezone). Task groups without any tasks matching this filter will not appear in the response.
         * @param {string} [taskDriverID] Filter by driver ID. Task groups without any tasks matching this filter will not appear in the response.
         * @param {string} [taskSubscriptionID] Filter by subscription ID. Task groups without any tasks matching this filter will not appear in the response. Set to an empty string to filter for tasks without subscriptions.
         * @param {OperationsV1TaskGroupsGetTaskAssignmentTypeEnum} [taskAssignmentType] (Only applied if the taskDriverID filter is not also set.) If set to \&#39;unassigned\&#39;, only list tasks that are not assigned to a driver. If set to \&#39;assigned\&#39;, only list tasks that are assigned. If set to \&#39;dedup-prioritize-current\&#39;, prioritize task groups that are assigned within the week encompassing &#x60;startDateTime&#x60; and &#x60;endDateTime&#x60; but don\&#39;t necessarily exclude unassigned task groups. Otherwise, no filtering by assignment status will be applied.
         * @param {OperationsV1TaskGroupsGetTaskRefTypeEnum} [taskRefType] Filter by task reference type. Only task groups containing tasks with a matching task_ref.type will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsGet: async (id, status, sortBy, sortDir, offset, limit, taskFromDate, taskToDate, taskDriverID, taskSubscriptionID, taskAssignmentType, taskRefType, options = {}) => {
            const localVarPath = `/operations/v1/task-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (taskFromDate !== undefined) {
                localVarQueryParameter['taskFromDate'] =
                    taskFromDate instanceof Date ? taskFromDate.toISOString() : taskFromDate;
            }
            if (taskToDate !== undefined) {
                localVarQueryParameter['taskToDate'] = taskToDate instanceof Date ? taskToDate.toISOString() : taskToDate;
            }
            if (taskDriverID !== undefined) {
                localVarQueryParameter['taskDriverID'] = taskDriverID;
            }
            if (taskSubscriptionID !== undefined) {
                localVarQueryParameter['taskSubscriptionID'] = taskSubscriptionID;
            }
            if (taskAssignmentType !== undefined) {
                localVarQueryParameter['taskAssignmentType'] = taskAssignmentType;
            }
            if (taskRefType !== undefined) {
                localVarQueryParameter['taskRefType'] = taskRefType;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one or more task groups by their ID(s). Multiple IDs can be provided as a comma-separated string (e.g., \"id1,id2,id3\")
         * @summary Delete task group(s)
         * @param {string} id Task Group ID(s) - comma-separated for multiple deletions (e.g., \&#39;id1,id2,id3\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdDelete', 'id', id);
            const localVarPath = `/operations/v1/task-groups/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates every task and the task group based on the reported event type/status and records one event on each task\'s Roll Off, Portable Toilets, or Commercial order reference
         * @summary Record a structured driver event for a task group
         * @param {string} id Task Group ID
         * @param {ModelTaskGroupEventRequest} taskGroupEvent Task group event
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdEventsPost: async (id, taskGroupEvent, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdEventsPost', 'id', id);
            // verify required parameter 'taskGroupEvent' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdEventsPost', 'taskGroupEvent', taskGroupEvent);
            const localVarPath = `/operations/v1/task-groups/{id}/events`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(taskGroupEvent, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single task group by its unique identifier
         * @summary Get a task group, including its associated tasks and references, by ID
         * @param {string} id Task Group ID
         * @param {string} [taskFromDate] Include tasks in associated task groups that start after this date (YYYY-MM-DD format). Task groups without any tasks matching this filter will still appear in the response without any associated tasks.
         * @param {string} [taskToDate] Include tasks in associated task groups that end before this date (YYYY-MM-DD format). Task groups without any tasks matching this filter will still appear in the response without any associated tasks.
         * @param {string} [taskDriverID] Filter by driver ID. Task groups without any tasks matching this filter will still appear in the response without any associated tasks.
         * @param {string} [taskSubscriptionID] Filter by subscription ID. Task groups without any tasks matching this filter will still appear in the response without any associated tasks. Set to an empty string to filter for tasks without subscriptions.
         * @param {OperationsV1TaskGroupsIdGetTaskAssignmentTypeEnum} [taskAssignmentType] (Only applied if \&#39;taskDriverID\&#39; is not also set.) If set to \&#39;unassigned\&#39;, only list tasks that are not assigned to a driver. If set to \&#39;assigned\&#39;, only list tasks that are assigned. Otherwise, no filtering by assignment status will be applied.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdGet: async (id, taskFromDate, taskToDate, taskDriverID, taskSubscriptionID, taskAssignmentType, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdGet', 'id', id);
            const localVarPath = `/operations/v1/task-groups/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (taskFromDate !== undefined) {
                localVarQueryParameter['taskFromDate'] = taskFromDate;
            }
            if (taskToDate !== undefined) {
                localVarQueryParameter['taskToDate'] = taskToDate;
            }
            if (taskDriverID !== undefined) {
                localVarQueryParameter['taskDriverID'] = taskDriverID;
            }
            if (taskSubscriptionID !== undefined) {
                localVarQueryParameter['taskSubscriptionID'] = taskSubscriptionID;
            }
            if (taskAssignmentType !== undefined) {
                localVarQueryParameter['taskAssignmentType'] = taskAssignmentType;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates every task and the task group to the selected status and records one event on each task\'s Roll Off reference
         * @summary Record a structured outcome for a Roll Off task group
         * @param {string} id Task Group ID
         * @param {ModelTaskGroupIssueRequest} taskGroupIssue Task group issue outcome
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdIssuesPost: async (id, taskGroupIssue, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdIssuesPost', 'id', id);
            // verify required parameter 'taskGroupIssue' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdIssuesPost', 'taskGroupIssue', taskGroupIssue);
            const localVarPath = `/operations/v1/task-groups/{id}/issues`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(taskGroupIssue, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing task group by ID
         * @summary Update a task group
         * @param {string} id Task Group ID
         * @param {OperationsServiceDomainModelTskGrp} taskGroup Task Group object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdPut: async (id, taskGroup, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdPut', 'id', id);
            // verify required parameter 'taskGroup' is not null or undefined
            assertParamExists('operationsV1TaskGroupsIdPut', 'taskGroup', taskGroup);
            const localVarPath = `/operations/v1/task-groups/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(taskGroup, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new task group with the provided details
         * @summary Create a new task group
         * @param {OperationsServiceDomainModelTskGrp} taskGroup Task Group object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsPost: async (taskGroup, options = {}) => {
            // verify required parameter 'taskGroup' is not null or undefined
            assertParamExists('operationsV1TaskGroupsPost', 'taskGroup', taskGroup);
            const localVarPath = `/operations/v1/task-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(taskGroup, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TaskGroupsApi - functional programming interface
 */
export const TaskGroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TaskGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all task groups, including their associated tasks and references, with filtering, sorting, and pagination options
         * @summary List all task groups
         * @param {string} [id] Filter by task group ID
         * @param {string} [status] Filter by status
         * @param {OperationsV1TaskGroupsGetSortByEnum} [sortBy] Sort by field. Valid values: sortOrder, createdAt/timestamp, taskStartDateTime. When sorting by taskStartDateTime, task groups are sorted by the minimum (earliest) StartDateTime of their tasks using GROUP BY. Task groups with tasks having NULL StartDateTime will appear first (NULLS_FIRST), followed by task groups sorted by their earliest StartDateTime in the specified sort direction. This sorting is applied before pagination to ensure correct ordering across pages. Does not impact the order of listed tasks within each task group, which is always descending by those tasks\&#39; sortOrder.
         * @param {OperationsV1TaskGroupsGetSortDirEnum} [sortDir] Sort direction (ASC or DESC). Does not impact the order of listed tasks within each task group, which is always descending by those tasks\&#39; sortOrder.
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {string} [taskFromDate] Include tasks in associated task groups that start on or after this date and time (RFC3339 format, including time and timezone). Task groups without any tasks matching this filter will not appear in the response.
         * @param {string} [taskToDate] Include tasks in associated task groups that end before or on this date and time (RFC3339 format, including time and timezone). Task groups without any tasks matching this filter will not appear in the response.
         * @param {string} [taskDriverID] Filter by driver ID. Task groups without any tasks matching this filter will not appear in the response.
         * @param {string} [taskSubscriptionID] Filter by subscription ID. Task groups without any tasks matching this filter will not appear in the response. Set to an empty string to filter for tasks without subscriptions.
         * @param {OperationsV1TaskGroupsGetTaskAssignmentTypeEnum} [taskAssignmentType] (Only applied if the taskDriverID filter is not also set.) If set to \&#39;unassigned\&#39;, only list tasks that are not assigned to a driver. If set to \&#39;assigned\&#39;, only list tasks that are assigned. If set to \&#39;dedup-prioritize-current\&#39;, prioritize task groups that are assigned within the week encompassing &#x60;startDateTime&#x60; and &#x60;endDateTime&#x60; but don\&#39;t necessarily exclude unassigned task groups. Otherwise, no filtering by assignment status will be applied.
         * @param {OperationsV1TaskGroupsGetTaskRefTypeEnum} [taskRefType] Filter by task reference type. Only task groups containing tasks with a matching task_ref.type will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsGet(id, status, sortBy, sortDir, offset, limit, taskFromDate, taskToDate, taskDriverID, taskSubscriptionID, taskAssignmentType, taskRefType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsGet(id, status, sortBy, sortDir, offset, limit, taskFromDate, taskToDate, taskDriverID, taskSubscriptionID, taskAssignmentType, taskRefType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskGroupsApi.operationsV1TaskGroupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one or more task groups by their ID(s). Multiple IDs can be provided as a comma-separated string (e.g., \"id1,id2,id3\")
         * @summary Delete task group(s)
         * @param {string} id Task Group ID(s) - comma-separated for multiple deletions (e.g., \&#39;id1,id2,id3\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskGroupsApi.operationsV1TaskGroupsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates every task and the task group based on the reported event type/status and records one event on each task\'s Roll Off, Portable Toilets, or Commercial order reference
         * @summary Record a structured driver event for a task group
         * @param {string} id Task Group ID
         * @param {ModelTaskGroupEventRequest} taskGroupEvent Task group event
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsIdEventsPost(id, taskGroupEvent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsIdEventsPost(id, taskGroupEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskGroupsApi.operationsV1TaskGroupsIdEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single task group by its unique identifier
         * @summary Get a task group, including its associated tasks and references, by ID
         * @param {string} id Task Group ID
         * @param {string} [taskFromDate] Include tasks in associated task groups that start after this date (YYYY-MM-DD format). Task groups without any tasks matching this filter will still appear in the response without any associated tasks.
         * @param {string} [taskToDate] Include tasks in associated task groups that end before this date (YYYY-MM-DD format). Task groups without any tasks matching this filter will still appear in the response without any associated tasks.
         * @param {string} [taskDriverID] Filter by driver ID. Task groups without any tasks matching this filter will still appear in the response without any associated tasks.
         * @param {string} [taskSubscriptionID] Filter by subscription ID. Task groups without any tasks matching this filter will still appear in the response without any associated tasks. Set to an empty string to filter for tasks without subscriptions.
         * @param {OperationsV1TaskGroupsIdGetTaskAssignmentTypeEnum} [taskAssignmentType] (Only applied if \&#39;taskDriverID\&#39; is not also set.) If set to \&#39;unassigned\&#39;, only list tasks that are not assigned to a driver. If set to \&#39;assigned\&#39;, only list tasks that are assigned. Otherwise, no filtering by assignment status will be applied.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsIdGet(id, taskFromDate, taskToDate, taskDriverID, taskSubscriptionID, taskAssignmentType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsIdGet(id, taskFromDate, taskToDate, taskDriverID, taskSubscriptionID, taskAssignmentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskGroupsApi.operationsV1TaskGroupsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates every task and the task group to the selected status and records one event on each task\'s Roll Off reference
         * @summary Record a structured outcome for a Roll Off task group
         * @param {string} id Task Group ID
         * @param {ModelTaskGroupIssueRequest} taskGroupIssue Task group issue outcome
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsIdIssuesPost(id, taskGroupIssue, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsIdIssuesPost(id, taskGroupIssue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskGroupsApi.operationsV1TaskGroupsIdIssuesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing task group by ID
         * @summary Update a task group
         * @param {string} id Task Group ID
         * @param {OperationsServiceDomainModelTskGrp} taskGroup Task Group object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsIdPut(id, taskGroup, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsIdPut(id, taskGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskGroupsApi.operationsV1TaskGroupsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new task group with the provided details
         * @summary Create a new task group
         * @param {OperationsServiceDomainModelTskGrp} taskGroup Task Group object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsPost(taskGroup, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsPost(taskGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskGroupsApi.operationsV1TaskGroupsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TaskGroupsApi - factory interface
 */
export const TaskGroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TaskGroupsApiFp(configuration);
    return {
        /**
         * Retrieve a list of all task groups, including their associated tasks and references, with filtering, sorting, and pagination options
         * @summary List all task groups
         * @param {TaskGroupsApiOperationsV1TaskGroupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1TaskGroupsGet(requestParameters.id, requestParameters.status, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, requestParameters.taskFromDate, requestParameters.taskToDate, requestParameters.taskDriverID, requestParameters.taskSubscriptionID, requestParameters.taskAssignmentType, requestParameters.taskRefType, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete one or more task groups by their ID(s). Multiple IDs can be provided as a comma-separated string (e.g., \"id1,id2,id3\")
         * @summary Delete task group(s)
         * @param {TaskGroupsApiOperationsV1TaskGroupsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdDelete(requestParameters, options) {
            return localVarFp.operationsV1TaskGroupsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates every task and the task group based on the reported event type/status and records one event on each task\'s Roll Off, Portable Toilets, or Commercial order reference
         * @summary Record a structured driver event for a task group
         * @param {TaskGroupsApiOperationsV1TaskGroupsIdEventsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdEventsPost(requestParameters, options) {
            return localVarFp
                .operationsV1TaskGroupsIdEventsPost(requestParameters.id, requestParameters.taskGroupEvent, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single task group by its unique identifier
         * @summary Get a task group, including its associated tasks and references, by ID
         * @param {TaskGroupsApiOperationsV1TaskGroupsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdGet(requestParameters, options) {
            return localVarFp
                .operationsV1TaskGroupsIdGet(requestParameters.id, requestParameters.taskFromDate, requestParameters.taskToDate, requestParameters.taskDriverID, requestParameters.taskSubscriptionID, requestParameters.taskAssignmentType, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates every task and the task group to the selected status and records one event on each task\'s Roll Off reference
         * @summary Record a structured outcome for a Roll Off task group
         * @param {TaskGroupsApiOperationsV1TaskGroupsIdIssuesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdIssuesPost(requestParameters, options) {
            return localVarFp
                .operationsV1TaskGroupsIdIssuesPost(requestParameters.id, requestParameters.taskGroupIssue, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing task group by ID
         * @summary Update a task group
         * @param {TaskGroupsApiOperationsV1TaskGroupsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1TaskGroupsIdPut(requestParameters.id, requestParameters.taskGroup, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new task group with the provided details
         * @summary Create a new task group
         * @param {TaskGroupsApiOperationsV1TaskGroupsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsPost(requestParameters, options) {
            return localVarFp.operationsV1TaskGroupsPost(requestParameters.taskGroup, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaskGroupsApi - object-oriented interface
 */
export class TaskGroupsApi extends BaseAPI {
    /**
     * Retrieve a list of all task groups, including their associated tasks and references, with filtering, sorting, and pagination options
     * @summary List all task groups
     * @param {TaskGroupsApiOperationsV1TaskGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsGet(requestParameters = {}, options) {
        return TaskGroupsApiFp(this.configuration)
            .operationsV1TaskGroupsGet(requestParameters.id, requestParameters.status, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, requestParameters.taskFromDate, requestParameters.taskToDate, requestParameters.taskDriverID, requestParameters.taskSubscriptionID, requestParameters.taskAssignmentType, requestParameters.taskRefType, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete one or more task groups by their ID(s). Multiple IDs can be provided as a comma-separated string (e.g., \"id1,id2,id3\")
     * @summary Delete task group(s)
     * @param {TaskGroupsApiOperationsV1TaskGroupsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsIdDelete(requestParameters, options) {
        return TaskGroupsApiFp(this.configuration)
            .operationsV1TaskGroupsIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates every task and the task group based on the reported event type/status and records one event on each task\'s Roll Off, Portable Toilets, or Commercial order reference
     * @summary Record a structured driver event for a task group
     * @param {TaskGroupsApiOperationsV1TaskGroupsIdEventsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsIdEventsPost(requestParameters, options) {
        return TaskGroupsApiFp(this.configuration)
            .operationsV1TaskGroupsIdEventsPost(requestParameters.id, requestParameters.taskGroupEvent, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single task group by its unique identifier
     * @summary Get a task group, including its associated tasks and references, by ID
     * @param {TaskGroupsApiOperationsV1TaskGroupsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsIdGet(requestParameters, options) {
        return TaskGroupsApiFp(this.configuration)
            .operationsV1TaskGroupsIdGet(requestParameters.id, requestParameters.taskFromDate, requestParameters.taskToDate, requestParameters.taskDriverID, requestParameters.taskSubscriptionID, requestParameters.taskAssignmentType, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates every task and the task group to the selected status and records one event on each task\'s Roll Off reference
     * @summary Record a structured outcome for a Roll Off task group
     * @param {TaskGroupsApiOperationsV1TaskGroupsIdIssuesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsIdIssuesPost(requestParameters, options) {
        return TaskGroupsApiFp(this.configuration)
            .operationsV1TaskGroupsIdIssuesPost(requestParameters.id, requestParameters.taskGroupIssue, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing task group by ID
     * @summary Update a task group
     * @param {TaskGroupsApiOperationsV1TaskGroupsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsIdPut(requestParameters, options) {
        return TaskGroupsApiFp(this.configuration)
            .operationsV1TaskGroupsIdPut(requestParameters.id, requestParameters.taskGroup, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new task group with the provided details
     * @summary Create a new task group
     * @param {TaskGroupsApiOperationsV1TaskGroupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsPost(requestParameters, options) {
        return TaskGroupsApiFp(this.configuration)
            .operationsV1TaskGroupsPost(requestParameters.taskGroup, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1TaskGroupsGetSortByEnum = {
    SortOrder: 'sortOrder',
    CreatedAt: 'createdAt',
    Timestamp: 'timestamp',
    TaskStartDateTime: 'taskStartDateTime',
};
export const OperationsV1TaskGroupsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
export const OperationsV1TaskGroupsGetTaskAssignmentTypeEnum = {
    Assigned: 'assigned',
    Unassigned: 'unassigned',
    DedupPrioritizeCurrent: 'dedup-prioritize-current',
};
export const OperationsV1TaskGroupsGetTaskRefTypeEnum = {
    OrderPtLoo: 'ORDER_PT_LOO',
    OrderRo: 'ORDER_RO',
    OrderCommercial: 'ORDER_COMMERCIAL',
};
export const OperationsV1TaskGroupsIdGetTaskAssignmentTypeEnum = {
    Assigned: 'assigned',
    Unassigned: 'unassigned',
};
/**
 * TaskReferencesApi - axios parameter creator
 */
export const TaskReferencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all task references with filtering, sorting, and pagination options
         * @summary List all task references
         * @param {string} [id] Filter by reference ID
         * @param {string} [taskID] Filter by task ID
         * @param {string} [type] Filter by type
         * @param {string} [sortBy] Sort by field (createdAt)
         * @param {OperationsV1TaskReferencesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesGet: async (id, taskID, type, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/task-references`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (taskID !== undefined) {
                localVarQueryParameter['taskID'] = taskID;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a task reference by its ID
         * @summary Delete a task reference
         * @param {string} id Task Reference ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskReferencesIdDelete', 'id', id);
            const localVarPath = `/operations/v1/task-references/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single task reference by its unique identifier
         * @summary Get a task reference by ID
         * @param {string} id Task Reference ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskReferencesIdGet', 'id', id);
            const localVarPath = `/operations/v1/task-references/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing task reference by ID
         * @summary Update a task reference
         * @param {string} id Task Reference ID
         * @param {OperationsServiceDomainModelTaskRef} taskRef Task Reference object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesIdPut: async (id, taskRef, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TaskReferencesIdPut', 'id', id);
            // verify required parameter 'taskRef' is not null or undefined
            assertParamExists('operationsV1TaskReferencesIdPut', 'taskRef', taskRef);
            const localVarPath = `/operations/v1/task-references/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(taskRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new task reference with the provided details
         * @summary Create a new task reference
         * @param {OperationsServiceDomainModelTaskRef} taskRef Task Reference object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesPost: async (taskRef, options = {}) => {
            // verify required parameter 'taskRef' is not null or undefined
            assertParamExists('operationsV1TaskReferencesPost', 'taskRef', taskRef);
            const localVarPath = `/operations/v1/task-references`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(taskRef, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TaskReferencesApi - functional programming interface
 */
export const TaskReferencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = TaskReferencesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all task references with filtering, sorting, and pagination options
         * @summary List all task references
         * @param {string} [id] Filter by reference ID
         * @param {string} [taskID] Filter by task ID
         * @param {string} [type] Filter by type
         * @param {string} [sortBy] Sort by field (createdAt)
         * @param {OperationsV1TaskReferencesGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskReferencesGet(id, taskID, type, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskReferencesGet(id, taskID, type, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskReferencesApi.operationsV1TaskReferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a task reference by its ID
         * @summary Delete a task reference
         * @param {string} id Task Reference ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskReferencesIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskReferencesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskReferencesApi.operationsV1TaskReferencesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single task reference by its unique identifier
         * @summary Get a task reference by ID
         * @param {string} id Task Reference ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskReferencesIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskReferencesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskReferencesApi.operationsV1TaskReferencesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing task reference by ID
         * @summary Update a task reference
         * @param {string} id Task Reference ID
         * @param {OperationsServiceDomainModelTaskRef} taskRef Task Reference object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskReferencesIdPut(id, taskRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskReferencesIdPut(id, taskRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskReferencesApi.operationsV1TaskReferencesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new task reference with the provided details
         * @summary Create a new task reference
         * @param {OperationsServiceDomainModelTaskRef} taskRef Task Reference object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskReferencesPost(taskRef, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskReferencesPost(taskRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskReferencesApi.operationsV1TaskReferencesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TaskReferencesApi - factory interface
 */
export const TaskReferencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TaskReferencesApiFp(configuration);
    return {
        /**
         * Retrieve a list of all task references with filtering, sorting, and pagination options
         * @summary List all task references
         * @param {TaskReferencesApiOperationsV1TaskReferencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1TaskReferencesGet(requestParameters.id, requestParameters.taskID, requestParameters.type, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a task reference by its ID
         * @summary Delete a task reference
         * @param {TaskReferencesApiOperationsV1TaskReferencesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesIdDelete(requestParameters, options) {
            return localVarFp.operationsV1TaskReferencesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single task reference by its unique identifier
         * @summary Get a task reference by ID
         * @param {TaskReferencesApiOperationsV1TaskReferencesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesIdGet(requestParameters, options) {
            return localVarFp.operationsV1TaskReferencesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing task reference by ID
         * @summary Update a task reference
         * @param {TaskReferencesApiOperationsV1TaskReferencesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1TaskReferencesIdPut(requestParameters.id, requestParameters.taskRef, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new task reference with the provided details
         * @summary Create a new task reference
         * @param {TaskReferencesApiOperationsV1TaskReferencesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskReferencesPost(requestParameters, options) {
            return localVarFp
                .operationsV1TaskReferencesPost(requestParameters.taskRef, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaskReferencesApi - object-oriented interface
 */
export class TaskReferencesApi extends BaseAPI {
    /**
     * Retrieve a list of all task references with filtering, sorting, and pagination options
     * @summary List all task references
     * @param {TaskReferencesApiOperationsV1TaskReferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskReferencesGet(requestParameters = {}, options) {
        return TaskReferencesApiFp(this.configuration)
            .operationsV1TaskReferencesGet(requestParameters.id, requestParameters.taskID, requestParameters.type, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a task reference by its ID
     * @summary Delete a task reference
     * @param {TaskReferencesApiOperationsV1TaskReferencesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskReferencesIdDelete(requestParameters, options) {
        return TaskReferencesApiFp(this.configuration)
            .operationsV1TaskReferencesIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single task reference by its unique identifier
     * @summary Get a task reference by ID
     * @param {TaskReferencesApiOperationsV1TaskReferencesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskReferencesIdGet(requestParameters, options) {
        return TaskReferencesApiFp(this.configuration)
            .operationsV1TaskReferencesIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing task reference by ID
     * @summary Update a task reference
     * @param {TaskReferencesApiOperationsV1TaskReferencesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskReferencesIdPut(requestParameters, options) {
        return TaskReferencesApiFp(this.configuration)
            .operationsV1TaskReferencesIdPut(requestParameters.id, requestParameters.taskRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new task reference with the provided details
     * @summary Create a new task reference
     * @param {TaskReferencesApiOperationsV1TaskReferencesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskReferencesPost(requestParameters, options) {
        return TaskReferencesApiFp(this.configuration)
            .operationsV1TaskReferencesPost(requestParameters.taskRef, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1TaskReferencesGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * TasksApi - axios parameter creator
 */
export const TasksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create task groups with tasks for an active subscription. Supports three modes:  **(1) Task type mode** — specify one or more `types` query params. For SERVICE tasks: if `oneTimeServiceEquipmentParamOptionId` and `oneTimeServiceQuantity` are provided, a one-time service task is created for that equipment; otherwise, ONE_TIME billing subscriptions use the subscription timestamps, and recurring subscriptions generate a recurring service schedule.  **(2) Edit Service Details mode** — omit `types` and pass `createdOrderEntities`/`deletedOrderEntities` in the request body. Entries in `createdOrderEntities` with a `switchedFromOrderEntityID` indicate an order type switch (task refs updated, no new delivery/pickup tasks created). Entries without `switchedFromOrderEntityID` trigger DELIVERY task creation. Entries in `deletedOrderEntities` not matched by a `switchedFromOrderEntityID` trigger PICKUP task creation.  **(3) Retry mode** — omit `types` and supply `retryTaskID` to create a pending copy of the failed task\'s group in this subscription.
         * @summary Create tasks from a subscription
         * @param {string} subID Subscription ID
         * @param {Array<OperationsV1TaskGroupsTaskCreationSubIDPostTypesEnum>} [types] Task types to generate (task type mode only)
         * @param {boolean} [shouldSkipExistingPickupTasks] Skip PICKUP task creation if pickup tasks already exist for this subscription
         * @param {string} [oneTimeServiceEquipmentParamOptionId] Equipment parameter option ID for an explicit one-time SERVICE task
         * @param {number} [oneTimeServiceQuantity] Equipment quantity for an explicit one-time SERVICE task
         * @param {string} [oneTimeServiceServiceDate] Service date for an explicit one-time SERVICE task (RFC3339). Defaults to the subscription end date if omitted.
         * @param {string} [pickupOrderRoId] Existing ord-RO being picked up (required for SWAP/DUMP_AND_RETURN)
         * @param {string} [deliveryOrderRoId] New ord-RO being delivered (required for SWAP/DUMP_AND_RETURN)
         * @param {string} [orderID] Parent order ID (required for SWAP/DUMP_AND_RETURN — shared by both ord-ROs; required for RELOCATE — parent of the targeted ord-RO)
         * @param {string} [relocateOrderRoId] Target ord-RO for a RELOCATE task group (required for RELOCATE)
         * @param {string} [dumpOrderRoId] Target ord-RO for a standalone DUMP task group (required for DUMP)
         * @param {string} [taskStartDateTime] RFC3339 StartDateTime applied to every task in SWAP/DUMP_AND_RETURN/RELOCATE/DUMP groups
         * @param {string} [retryTaskID] Failed task ID whose group should be retried (retry mode only; cannot be combined with types or Edit Service Details payload)
         * @param {TskgrpTaskCreationRequestBody} [body] Edit Service Details payload (omit for task type mode)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsTaskCreationSubIDPost: async (subID, types, shouldSkipExistingPickupTasks, oneTimeServiceEquipmentParamOptionId, oneTimeServiceQuantity, oneTimeServiceServiceDate, pickupOrderRoId, deliveryOrderRoId, orderID, relocateOrderRoId, dumpOrderRoId, taskStartDateTime, retryTaskID, body, options = {}) => {
            // verify required parameter 'subID' is not null or undefined
            assertParamExists('operationsV1TaskGroupsTaskCreationSubIDPost', 'subID', subID);
            const localVarPath = `/operations/v1/task-groups/task-creation/{subID}`.replace('{subID}', encodeURIComponent(String(subID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (shouldSkipExistingPickupTasks !== undefined) {
                localVarQueryParameter['shouldSkipExistingPickupTasks'] = shouldSkipExistingPickupTasks;
            }
            if (oneTimeServiceEquipmentParamOptionId !== undefined) {
                localVarQueryParameter['oneTimeServiceEquipmentParamOptionId'] = oneTimeServiceEquipmentParamOptionId;
            }
            if (oneTimeServiceQuantity !== undefined) {
                localVarQueryParameter['oneTimeServiceQuantity'] = oneTimeServiceQuantity;
            }
            if (oneTimeServiceServiceDate !== undefined) {
                localVarQueryParameter['oneTimeServiceServiceDate'] = oneTimeServiceServiceDate;
            }
            if (pickupOrderRoId !== undefined) {
                localVarQueryParameter['pickupOrderRoId'] = pickupOrderRoId;
            }
            if (deliveryOrderRoId !== undefined) {
                localVarQueryParameter['deliveryOrderRoId'] = deliveryOrderRoId;
            }
            if (orderID !== undefined) {
                localVarQueryParameter['orderID'] = orderID;
            }
            if (relocateOrderRoId !== undefined) {
                localVarQueryParameter['relocateOrderRoId'] = relocateOrderRoId;
            }
            if (dumpOrderRoId !== undefined) {
                localVarQueryParameter['dumpOrderRoId'] = dumpOrderRoId;
            }
            if (taskStartDateTime !== undefined) {
                localVarQueryParameter['taskStartDateTime'] = taskStartDateTime;
            }
            if (retryTaskID !== undefined) {
                localVarQueryParameter['retryTaskID'] = retryTaskID;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all tasks with filtering, sorting, and pagination options
         * @summary List all tasks
         * @param {string} [id] Filter by task IDs (one or more, comma-separated)
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [status] Filter by task status
         * @param {string} [orderID] Filter by order ID (set to an empty string for tasks without orders)
         * @param {string} [subscriptionID] Filter by subscription ID (set to an empty string for tasks without subscriptions)
         * @param {string} [customerID] Filter by customer ID (set to an empty string for tasks without customers)
         * @param {string} [taskGroupID] Filter by task group ID (one or more, comma-separated)
         * @param {OperationsV1TasksGetTaskAssignmentTypeEnum} [taskAssignmentType] If set to \&#39;unassigned\&#39;, only list tasks that are not assigned to a driver. If set to \&#39;assigned\&#39;, only list tasks that are assigned. Otherwise, no filtering by assignment status will be applied.
         * @param {string} [type] Filter by task type (e.g. DELIVERY, PICKUP, SERVICE, DUMP, RELOCATE)
         * @param {string} [sortBy] Sort by field (id, haulerID, type, status, createdAt, lastUpdatedAt)
         * @param {OperationsV1TasksGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksGet: async (id, haulerID, status, orderID, subscriptionID, customerID, taskGroupID, taskAssignmentType, type, sortBy, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (haulerID !== undefined) {
                localVarQueryParameter['haulerID'] = haulerID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (orderID !== undefined) {
                localVarQueryParameter['orderID'] = orderID;
            }
            if (subscriptionID !== undefined) {
                localVarQueryParameter['subscriptionID'] = subscriptionID;
            }
            if (customerID !== undefined) {
                localVarQueryParameter['customerID'] = customerID;
            }
            if (taskGroupID !== undefined) {
                localVarQueryParameter['taskGroupID'] = taskGroupID;
            }
            if (taskAssignmentType !== undefined) {
                localVarQueryParameter['taskAssignmentType'] = taskAssignmentType;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a task by its ID
         * @summary Delete a task
         * @param {string} id Task IDs (one or more, comma-separated)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksIdDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TasksIdDelete', 'id', id);
            const localVarPath = `/operations/v1/tasks/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single task by its unique identifier
         * @summary Get a task by ID
         * @param {string} id Task ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksIdGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TasksIdGet', 'id', id);
            const localVarPath = `/operations/v1/tasks/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing task by ID
         * @summary Update a task
         * @param {string} id Task ID
         * @param {OperationsServiceDomainModelTask} task Task object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksIdPut: async (id, task, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1TasksIdPut', 'id', id);
            // verify required parameter 'task' is not null or undefined
            assertParamExists('operationsV1TasksIdPut', 'task', task);
            const localVarPath = `/operations/v1/tasks/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(task, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new task with the provided details
         * @summary Create a new task
         * @param {OperationsServiceDomainModelTask} task Task object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksPost: async (task, options = {}) => {
            // verify required parameter 'task' is not null or undefined
            assertParamExists('operationsV1TasksPost', 'task', task);
            const localVarPath = `/operations/v1/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(task, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TasksApi - functional programming interface
 */
export const TasksApiFp = function (configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration);
    return {
        /**
         * Create task groups with tasks for an active subscription. Supports three modes:  **(1) Task type mode** — specify one or more `types` query params. For SERVICE tasks: if `oneTimeServiceEquipmentParamOptionId` and `oneTimeServiceQuantity` are provided, a one-time service task is created for that equipment; otherwise, ONE_TIME billing subscriptions use the subscription timestamps, and recurring subscriptions generate a recurring service schedule.  **(2) Edit Service Details mode** — omit `types` and pass `createdOrderEntities`/`deletedOrderEntities` in the request body. Entries in `createdOrderEntities` with a `switchedFromOrderEntityID` indicate an order type switch (task refs updated, no new delivery/pickup tasks created). Entries without `switchedFromOrderEntityID` trigger DELIVERY task creation. Entries in `deletedOrderEntities` not matched by a `switchedFromOrderEntityID` trigger PICKUP task creation.  **(3) Retry mode** — omit `types` and supply `retryTaskID` to create a pending copy of the failed task\'s group in this subscription.
         * @summary Create tasks from a subscription
         * @param {string} subID Subscription ID
         * @param {Array<OperationsV1TaskGroupsTaskCreationSubIDPostTypesEnum>} [types] Task types to generate (task type mode only)
         * @param {boolean} [shouldSkipExistingPickupTasks] Skip PICKUP task creation if pickup tasks already exist for this subscription
         * @param {string} [oneTimeServiceEquipmentParamOptionId] Equipment parameter option ID for an explicit one-time SERVICE task
         * @param {number} [oneTimeServiceQuantity] Equipment quantity for an explicit one-time SERVICE task
         * @param {string} [oneTimeServiceServiceDate] Service date for an explicit one-time SERVICE task (RFC3339). Defaults to the subscription end date if omitted.
         * @param {string} [pickupOrderRoId] Existing ord-RO being picked up (required for SWAP/DUMP_AND_RETURN)
         * @param {string} [deliveryOrderRoId] New ord-RO being delivered (required for SWAP/DUMP_AND_RETURN)
         * @param {string} [orderID] Parent order ID (required for SWAP/DUMP_AND_RETURN — shared by both ord-ROs; required for RELOCATE — parent of the targeted ord-RO)
         * @param {string} [relocateOrderRoId] Target ord-RO for a RELOCATE task group (required for RELOCATE)
         * @param {string} [dumpOrderRoId] Target ord-RO for a standalone DUMP task group (required for DUMP)
         * @param {string} [taskStartDateTime] RFC3339 StartDateTime applied to every task in SWAP/DUMP_AND_RETURN/RELOCATE/DUMP groups
         * @param {string} [retryTaskID] Failed task ID whose group should be retried (retry mode only; cannot be combined with types or Edit Service Details payload)
         * @param {TskgrpTaskCreationRequestBody} [body] Edit Service Details payload (omit for task type mode)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TaskGroupsTaskCreationSubIDPost(subID, types, shouldSkipExistingPickupTasks, oneTimeServiceEquipmentParamOptionId, oneTimeServiceQuantity, oneTimeServiceServiceDate, pickupOrderRoId, deliveryOrderRoId, orderID, relocateOrderRoId, dumpOrderRoId, taskStartDateTime, retryTaskID, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TaskGroupsTaskCreationSubIDPost(subID, types, shouldSkipExistingPickupTasks, oneTimeServiceEquipmentParamOptionId, oneTimeServiceQuantity, oneTimeServiceServiceDate, pickupOrderRoId, deliveryOrderRoId, orderID, relocateOrderRoId, dumpOrderRoId, taskStartDateTime, retryTaskID, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.operationsV1TaskGroupsTaskCreationSubIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all tasks with filtering, sorting, and pagination options
         * @summary List all tasks
         * @param {string} [id] Filter by task IDs (one or more, comma-separated)
         * @param {string} [haulerID] Filter by hauler ID
         * @param {string} [status] Filter by task status
         * @param {string} [orderID] Filter by order ID (set to an empty string for tasks without orders)
         * @param {string} [subscriptionID] Filter by subscription ID (set to an empty string for tasks without subscriptions)
         * @param {string} [customerID] Filter by customer ID (set to an empty string for tasks without customers)
         * @param {string} [taskGroupID] Filter by task group ID (one or more, comma-separated)
         * @param {OperationsV1TasksGetTaskAssignmentTypeEnum} [taskAssignmentType] If set to \&#39;unassigned\&#39;, only list tasks that are not assigned to a driver. If set to \&#39;assigned\&#39;, only list tasks that are assigned. Otherwise, no filtering by assignment status will be applied.
         * @param {string} [type] Filter by task type (e.g. DELIVERY, PICKUP, SERVICE, DUMP, RELOCATE)
         * @param {string} [sortBy] Sort by field (id, haulerID, type, status, createdAt, lastUpdatedAt)
         * @param {OperationsV1TasksGetSortDirEnum} [sortDir] Sort direction (ASC or DESC)
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TasksGet(id, haulerID, status, orderID, subscriptionID, customerID, taskGroupID, taskAssignmentType, type, sortBy, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TasksGet(id, haulerID, status, orderID, subscriptionID, customerID, taskGroupID, taskAssignmentType, type, sortBy, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.operationsV1TasksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a task by its ID
         * @summary Delete a task
         * @param {string} id Task IDs (one or more, comma-separated)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TasksIdDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TasksIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.operationsV1TasksIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single task by its unique identifier
         * @summary Get a task by ID
         * @param {string} id Task ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TasksIdGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TasksIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.operationsV1TasksIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing task by ID
         * @summary Update a task
         * @param {string} id Task ID
         * @param {OperationsServiceDomainModelTask} task Task object (haulerID will be overridden with the context value)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TasksIdPut(id, task, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TasksIdPut(id, task, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.operationsV1TasksIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new task with the provided details
         * @summary Create a new task
         * @param {OperationsServiceDomainModelTask} task Task object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1TasksPost(task, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1TasksPost(task, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.operationsV1TasksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TasksApi - factory interface
 */
export const TasksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TasksApiFp(configuration);
    return {
        /**
         * Create task groups with tasks for an active subscription. Supports three modes:  **(1) Task type mode** — specify one or more `types` query params. For SERVICE tasks: if `oneTimeServiceEquipmentParamOptionId` and `oneTimeServiceQuantity` are provided, a one-time service task is created for that equipment; otherwise, ONE_TIME billing subscriptions use the subscription timestamps, and recurring subscriptions generate a recurring service schedule.  **(2) Edit Service Details mode** — omit `types` and pass `createdOrderEntities`/`deletedOrderEntities` in the request body. Entries in `createdOrderEntities` with a `switchedFromOrderEntityID` indicate an order type switch (task refs updated, no new delivery/pickup tasks created). Entries without `switchedFromOrderEntityID` trigger DELIVERY task creation. Entries in `deletedOrderEntities` not matched by a `switchedFromOrderEntityID` trigger PICKUP task creation.  **(3) Retry mode** — omit `types` and supply `retryTaskID` to create a pending copy of the failed task\'s group in this subscription.
         * @summary Create tasks from a subscription
         * @param {TasksApiOperationsV1TaskGroupsTaskCreationSubIDPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TaskGroupsTaskCreationSubIDPost(requestParameters, options) {
            return localVarFp
                .operationsV1TaskGroupsTaskCreationSubIDPost(requestParameters.subID, requestParameters.types, requestParameters.shouldSkipExistingPickupTasks, requestParameters.oneTimeServiceEquipmentParamOptionId, requestParameters.oneTimeServiceQuantity, requestParameters.oneTimeServiceServiceDate, requestParameters.pickupOrderRoId, requestParameters.deliveryOrderRoId, requestParameters.orderID, requestParameters.relocateOrderRoId, requestParameters.dumpOrderRoId, requestParameters.taskStartDateTime, requestParameters.retryTaskID, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all tasks with filtering, sorting, and pagination options
         * @summary List all tasks
         * @param {TasksApiOperationsV1TasksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1TasksGet(requestParameters.id, requestParameters.haulerID, requestParameters.status, requestParameters.orderID, requestParameters.subscriptionID, requestParameters.customerID, requestParameters.taskGroupID, requestParameters.taskAssignmentType, requestParameters.type, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a task by its ID
         * @summary Delete a task
         * @param {TasksApiOperationsV1TasksIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksIdDelete(requestParameters, options) {
            return localVarFp.operationsV1TasksIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single task by its unique identifier
         * @summary Get a task by ID
         * @param {TasksApiOperationsV1TasksIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksIdGet(requestParameters, options) {
            return localVarFp.operationsV1TasksIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing task by ID
         * @summary Update a task
         * @param {TasksApiOperationsV1TasksIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1TasksIdPut(requestParameters.id, requestParameters.task, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new task with the provided details
         * @summary Create a new task
         * @param {TasksApiOperationsV1TasksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1TasksPost(requestParameters, options) {
            return localVarFp.operationsV1TasksPost(requestParameters.task, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TasksApi - object-oriented interface
 */
export class TasksApi extends BaseAPI {
    /**
     * Create task groups with tasks for an active subscription. Supports three modes:  **(1) Task type mode** — specify one or more `types` query params. For SERVICE tasks: if `oneTimeServiceEquipmentParamOptionId` and `oneTimeServiceQuantity` are provided, a one-time service task is created for that equipment; otherwise, ONE_TIME billing subscriptions use the subscription timestamps, and recurring subscriptions generate a recurring service schedule.  **(2) Edit Service Details mode** — omit `types` and pass `createdOrderEntities`/`deletedOrderEntities` in the request body. Entries in `createdOrderEntities` with a `switchedFromOrderEntityID` indicate an order type switch (task refs updated, no new delivery/pickup tasks created). Entries without `switchedFromOrderEntityID` trigger DELIVERY task creation. Entries in `deletedOrderEntities` not matched by a `switchedFromOrderEntityID` trigger PICKUP task creation.  **(3) Retry mode** — omit `types` and supply `retryTaskID` to create a pending copy of the failed task\'s group in this subscription.
     * @summary Create tasks from a subscription
     * @param {TasksApiOperationsV1TaskGroupsTaskCreationSubIDPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TaskGroupsTaskCreationSubIDPost(requestParameters, options) {
        return TasksApiFp(this.configuration)
            .operationsV1TaskGroupsTaskCreationSubIDPost(requestParameters.subID, requestParameters.types, requestParameters.shouldSkipExistingPickupTasks, requestParameters.oneTimeServiceEquipmentParamOptionId, requestParameters.oneTimeServiceQuantity, requestParameters.oneTimeServiceServiceDate, requestParameters.pickupOrderRoId, requestParameters.deliveryOrderRoId, requestParameters.orderID, requestParameters.relocateOrderRoId, requestParameters.dumpOrderRoId, requestParameters.taskStartDateTime, requestParameters.retryTaskID, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of all tasks with filtering, sorting, and pagination options
     * @summary List all tasks
     * @param {TasksApiOperationsV1TasksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TasksGet(requestParameters = {}, options) {
        return TasksApiFp(this.configuration)
            .operationsV1TasksGet(requestParameters.id, requestParameters.haulerID, requestParameters.status, requestParameters.orderID, requestParameters.subscriptionID, requestParameters.customerID, requestParameters.taskGroupID, requestParameters.taskAssignmentType, requestParameters.type, requestParameters.sortBy, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a task by its ID
     * @summary Delete a task
     * @param {TasksApiOperationsV1TasksIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TasksIdDelete(requestParameters, options) {
        return TasksApiFp(this.configuration)
            .operationsV1TasksIdDelete(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single task by its unique identifier
     * @summary Get a task by ID
     * @param {TasksApiOperationsV1TasksIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TasksIdGet(requestParameters, options) {
        return TasksApiFp(this.configuration)
            .operationsV1TasksIdGet(requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing task by ID
     * @summary Update a task
     * @param {TasksApiOperationsV1TasksIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TasksIdPut(requestParameters, options) {
        return TasksApiFp(this.configuration)
            .operationsV1TasksIdPut(requestParameters.id, requestParameters.task, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new task with the provided details
     * @summary Create a new task
     * @param {TasksApiOperationsV1TasksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1TasksPost(requestParameters, options) {
        return TasksApiFp(this.configuration)
            .operationsV1TasksPost(requestParameters.task, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1TaskGroupsTaskCreationSubIDPostTypesEnum = {
    Delivery: 'DELIVERY',
    Pickup: 'PICKUP',
    Service: 'SERVICE',
    Swap: 'SWAP',
    DumpAndReturn: 'DUMP_AND_RETURN',
    Relocate: 'RELOCATE',
    Dump: 'DUMP',
};
export const OperationsV1TasksGetTaskAssignmentTypeEnum = {
    Assigned: 'assigned',
    Unassigned: 'unassigned',
};
export const OperationsV1TasksGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
/**
 * WebsocketApi - axios parameter creator
 */
export const WebsocketApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Establishes a WebSocket connection for receiving real-time updates.  **Connection URL**: `/operations/v1/ws` Single connection for all real-time hauler events (task groups, roll-off orders, etc.).  **Authentication**: Requires JWT token via query parameter or Authorization header - Query parameter: ?authorization=<JWT_TOKEN> (recommended for browser clients, no \"Bearer\" prefix) - Authorization header: \"Bearer <JWT_TOKEN>\" (for standard HTTP clients)  **Connection Flow**: 1. Client initiates WebSocket upgrade request 2. Server validates JWT token and extracts hauler ID 3. Server sends welcome message: {\"type\":\"connected\",\"message\":\"WebSocket connection established\",\"haulerID\":\"<UUID>\"} 4. Connection established - server will push events for the hauler  **Event Types**: - TASK_GROUP_UPDATED: {\"type\":\"TASK_GROUP_UPDATED\",\"taskGroupId\":\"<ID>\",\"data\":{...}} - Sent when a task group status or sort order changes - Sent when a task\'s driver assignment (personID) or sort order changes - ORDER_RO_CREATED: {\"type\":\"ORDER_RO_CREATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is created via subscription create - ORDER_RO_UPDATED: {\"type\":\"ORDER_RO_UPDATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is updated via PUT /order-rolloffs/:id - sourceClientId echoes the X-Client-Id request header for echo suppression - TASK_UPDATED: {\"type\":\"TASK_UPDATED\",\"taskId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a single operations task is updated (PATCH list caches without refetching all pages)  **Keepalive**: Automatic ping every 10 seconds to maintain connection  **Security**: All events are filtered by hauler ID from the JWT token
         * @summary WebSocket connection for real-time updates
         * @param {string} [authorization] JWT token for authentication (no Bearer prefix)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WsGet: async (authorization, options = {}) => {
            const localVarPath = `/operations/v1/ws`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (authorization !== undefined) {
                localVarQueryParameter['authorization'] = authorization;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WebsocketApi - functional programming interface
 */
export const WebsocketApiFp = function (configuration) {
    const localVarAxiosParamCreator = WebsocketApiAxiosParamCreator(configuration);
    return {
        /**
         * Establishes a WebSocket connection for receiving real-time updates.  **Connection URL**: `/operations/v1/ws` Single connection for all real-time hauler events (task groups, roll-off orders, etc.).  **Authentication**: Requires JWT token via query parameter or Authorization header - Query parameter: ?authorization=<JWT_TOKEN> (recommended for browser clients, no \"Bearer\" prefix) - Authorization header: \"Bearer <JWT_TOKEN>\" (for standard HTTP clients)  **Connection Flow**: 1. Client initiates WebSocket upgrade request 2. Server validates JWT token and extracts hauler ID 3. Server sends welcome message: {\"type\":\"connected\",\"message\":\"WebSocket connection established\",\"haulerID\":\"<UUID>\"} 4. Connection established - server will push events for the hauler  **Event Types**: - TASK_GROUP_UPDATED: {\"type\":\"TASK_GROUP_UPDATED\",\"taskGroupId\":\"<ID>\",\"data\":{...}} - Sent when a task group status or sort order changes - Sent when a task\'s driver assignment (personID) or sort order changes - ORDER_RO_CREATED: {\"type\":\"ORDER_RO_CREATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is created via subscription create - ORDER_RO_UPDATED: {\"type\":\"ORDER_RO_UPDATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is updated via PUT /order-rolloffs/:id - sourceClientId echoes the X-Client-Id request header for echo suppression - TASK_UPDATED: {\"type\":\"TASK_UPDATED\",\"taskId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a single operations task is updated (PATCH list caches without refetching all pages)  **Keepalive**: Automatic ping every 10 seconds to maintain connection  **Security**: All events are filtered by hauler ID from the JWT token
         * @summary WebSocket connection for real-time updates
         * @param {string} [authorization] JWT token for authentication (no Bearer prefix)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1WsGet(authorization, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1WsGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebsocketApi.operationsV1WsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WebsocketApi - factory interface
 */
export const WebsocketApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WebsocketApiFp(configuration);
    return {
        /**
         * Establishes a WebSocket connection for receiving real-time updates.  **Connection URL**: `/operations/v1/ws` Single connection for all real-time hauler events (task groups, roll-off orders, etc.).  **Authentication**: Requires JWT token via query parameter or Authorization header - Query parameter: ?authorization=<JWT_TOKEN> (recommended for browser clients, no \"Bearer\" prefix) - Authorization header: \"Bearer <JWT_TOKEN>\" (for standard HTTP clients)  **Connection Flow**: 1. Client initiates WebSocket upgrade request 2. Server validates JWT token and extracts hauler ID 3. Server sends welcome message: {\"type\":\"connected\",\"message\":\"WebSocket connection established\",\"haulerID\":\"<UUID>\"} 4. Connection established - server will push events for the hauler  **Event Types**: - TASK_GROUP_UPDATED: {\"type\":\"TASK_GROUP_UPDATED\",\"taskGroupId\":\"<ID>\",\"data\":{...}} - Sent when a task group status or sort order changes - Sent when a task\'s driver assignment (personID) or sort order changes - ORDER_RO_CREATED: {\"type\":\"ORDER_RO_CREATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is created via subscription create - ORDER_RO_UPDATED: {\"type\":\"ORDER_RO_UPDATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is updated via PUT /order-rolloffs/:id - sourceClientId echoes the X-Client-Id request header for echo suppression - TASK_UPDATED: {\"type\":\"TASK_UPDATED\",\"taskId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a single operations task is updated (PATCH list caches without refetching all pages)  **Keepalive**: Automatic ping every 10 seconds to maintain connection  **Security**: All events are filtered by hauler ID from the JWT token
         * @summary WebSocket connection for real-time updates
         * @param {WebsocketApiOperationsV1WsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WsGet(requestParameters = {}, options) {
            return localVarFp.operationsV1WsGet(requestParameters.authorization, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WebsocketApi - object-oriented interface
 */
export class WebsocketApi extends BaseAPI {
    /**
     * Establishes a WebSocket connection for receiving real-time updates.  **Connection URL**: `/operations/v1/ws` Single connection for all real-time hauler events (task groups, roll-off orders, etc.).  **Authentication**: Requires JWT token via query parameter or Authorization header - Query parameter: ?authorization=<JWT_TOKEN> (recommended for browser clients, no \"Bearer\" prefix) - Authorization header: \"Bearer <JWT_TOKEN>\" (for standard HTTP clients)  **Connection Flow**: 1. Client initiates WebSocket upgrade request 2. Server validates JWT token and extracts hauler ID 3. Server sends welcome message: {\"type\":\"connected\",\"message\":\"WebSocket connection established\",\"haulerID\":\"<UUID>\"} 4. Connection established - server will push events for the hauler  **Event Types**: - TASK_GROUP_UPDATED: {\"type\":\"TASK_GROUP_UPDATED\",\"taskGroupId\":\"<ID>\",\"data\":{...}} - Sent when a task group status or sort order changes - Sent when a task\'s driver assignment (personID) or sort order changes - ORDER_RO_CREATED: {\"type\":\"ORDER_RO_CREATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is created via subscription create - ORDER_RO_UPDATED: {\"type\":\"ORDER_RO_UPDATED\",\"orderRoId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a roll-off order is updated via PUT /order-rolloffs/:id - sourceClientId echoes the X-Client-Id request header for echo suppression - TASK_UPDATED: {\"type\":\"TASK_UPDATED\",\"taskId\":\"<ID>\",\"data\":{...},\"sourceClientId\":\"<ID>\"} - Sent when a single operations task is updated (PATCH list caches without refetching all pages)  **Keepalive**: Automatic ping every 10 seconds to maintain connection  **Security**: All events are filtered by hauler ID from the JWT token
     * @summary WebSocket connection for real-time updates
     * @param {WebsocketApiOperationsV1WsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1WsGet(requestParameters = {}, options) {
        return WebsocketApiFp(this.configuration)
            .operationsV1WsGet(requestParameters.authorization, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkRequestsApi - axios parameter creator
 */
export const WorkRequestsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List work requests. Brokers see the work requests they own. Operators see the ones offered to them by setting vendorID to their own hauler.
         * @summary List work requests
         * @param {string} [subcontractEntityID] Filter by the broker\&#39;s ord_ro ID
         * @param {string} [operatorEntityID] Filter by the operator\&#39;s ord_ro ID
         * @param {string} [vendorID] List the work requests offered to the caller\&#39;s hauler; must be the caller\&#39;s hauler ID
         * @param {string} [status] Filter by statuses (comma-separated)
         * @param {OperationsV1WorkRequestsGetSortDirEnum} [sortDir] Sort direction by creation time
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WorkRequestsGet: async (subcontractEntityID, operatorEntityID, vendorID, status, sortDir, offset, limit, options = {}) => {
            const localVarPath = `/operations/v1/work-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (subcontractEntityID !== undefined) {
                localVarQueryParameter['subcontractEntityID'] = subcontractEntityID;
            }
            if (operatorEntityID !== undefined) {
                localVarQueryParameter['operatorEntityID'] = operatorEntityID;
            }
            if (vendorID !== undefined) {
                localVarQueryParameter['vendorID'] = vendorID;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * APPROVED and REJECTED come from the hauler the work was offered to, or the broker on their behalf; CANCELLED comes from the broker and needs alliance-customer-service. Accepting moves the hauler\'s copy of the order out of NEEDS_REVIEW; rejecting or cancelling cancels it and puts the broker order back to UNASSIGNED_DELIVERY.
         * @summary Accept, reject, or cancel a work request
         * @param {string} id Work request ID
         * @param {OperationsServiceDomainModelWorkReq} workRequest Work request with the new status: APPROVED, REJECTED or CANCELLED
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WorkRequestsIdPut: async (id, workRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationsV1WorkRequestsIdPut', 'id', id);
            // verify required parameter 'workRequest' is not null or undefined
            assertParamExists('operationsV1WorkRequestsIdPut', 'workRequest', workRequest);
            const localVarPath = `/operations/v1/work-requests/{id}`.replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(workRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * alliance-customer-service only. Create a PENDING work request and the hauler\'s copy of the order, in NEEDS_REVIEW until they accept. Cancels any open work request on the order first. A Wayste-lite hauler is accepted straight away.
         * @summary Offer a subcontracted order to a hauler
         * @param {OperationsServiceDomainModelWorkReq} workRequest Work request: subcontractEntityID, vendorID, and optionally reqType (defaults to DELIVERY) and requestedActionDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WorkRequestsPost: async (workRequest, options = {}) => {
            // verify required parameter 'workRequest' is not null or undefined
            assertParamExists('operationsV1WorkRequestsPost', 'workRequest', workRequest);
            const localVarPath = `/operations/v1/work-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(workRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkRequestsApi - functional programming interface
 */
export const WorkRequestsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkRequestsApiAxiosParamCreator(configuration);
    return {
        /**
         * List work requests. Brokers see the work requests they own. Operators see the ones offered to them by setting vendorID to their own hauler.
         * @summary List work requests
         * @param {string} [subcontractEntityID] Filter by the broker\&#39;s ord_ro ID
         * @param {string} [operatorEntityID] Filter by the operator\&#39;s ord_ro ID
         * @param {string} [vendorID] List the work requests offered to the caller\&#39;s hauler; must be the caller\&#39;s hauler ID
         * @param {string} [status] Filter by statuses (comma-separated)
         * @param {OperationsV1WorkRequestsGetSortDirEnum} [sortDir] Sort direction by creation time
         * @param {number} [offset] Pagination offset
         * @param {number} [limit] Pagination limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1WorkRequestsGet(subcontractEntityID, operatorEntityID, vendorID, status, sortDir, offset, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1WorkRequestsGet(subcontractEntityID, operatorEntityID, vendorID, status, sortDir, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkRequestsApi.operationsV1WorkRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * APPROVED and REJECTED come from the hauler the work was offered to, or the broker on their behalf; CANCELLED comes from the broker and needs alliance-customer-service. Accepting moves the hauler\'s copy of the order out of NEEDS_REVIEW; rejecting or cancelling cancels it and puts the broker order back to UNASSIGNED_DELIVERY.
         * @summary Accept, reject, or cancel a work request
         * @param {string} id Work request ID
         * @param {OperationsServiceDomainModelWorkReq} workRequest Work request with the new status: APPROVED, REJECTED or CANCELLED
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1WorkRequestsIdPut(id, workRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1WorkRequestsIdPut(id, workRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkRequestsApi.operationsV1WorkRequestsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * alliance-customer-service only. Create a PENDING work request and the hauler\'s copy of the order, in NEEDS_REVIEW until they accept. Cancels any open work request on the order first. A Wayste-lite hauler is accepted straight away.
         * @summary Offer a subcontracted order to a hauler
         * @param {OperationsServiceDomainModelWorkReq} workRequest Work request: subcontractEntityID, vendorID, and optionally reqType (defaults to DELIVERY) and requestedActionDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationsV1WorkRequestsPost(workRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationsV1WorkRequestsPost(workRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkRequestsApi.operationsV1WorkRequestsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WorkRequestsApi - factory interface
 */
export const WorkRequestsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkRequestsApiFp(configuration);
    return {
        /**
         * List work requests. Brokers see the work requests they own. Operators see the ones offered to them by setting vendorID to their own hauler.
         * @summary List work requests
         * @param {WorkRequestsApiOperationsV1WorkRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WorkRequestsGet(requestParameters = {}, options) {
            return localVarFp
                .operationsV1WorkRequestsGet(requestParameters.subcontractEntityID, requestParameters.operatorEntityID, requestParameters.vendorID, requestParameters.status, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * APPROVED and REJECTED come from the hauler the work was offered to, or the broker on their behalf; CANCELLED comes from the broker and needs alliance-customer-service. Accepting moves the hauler\'s copy of the order out of NEEDS_REVIEW; rejecting or cancelling cancels it and puts the broker order back to UNASSIGNED_DELIVERY.
         * @summary Accept, reject, or cancel a work request
         * @param {WorkRequestsApiOperationsV1WorkRequestsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WorkRequestsIdPut(requestParameters, options) {
            return localVarFp
                .operationsV1WorkRequestsIdPut(requestParameters.id, requestParameters.workRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * alliance-customer-service only. Create a PENDING work request and the hauler\'s copy of the order, in NEEDS_REVIEW until they accept. Cancels any open work request on the order first. A Wayste-lite hauler is accepted straight away.
         * @summary Offer a subcontracted order to a hauler
         * @param {WorkRequestsApiOperationsV1WorkRequestsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationsV1WorkRequestsPost(requestParameters, options) {
            return localVarFp
                .operationsV1WorkRequestsPost(requestParameters.workRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkRequestsApi - object-oriented interface
 */
export class WorkRequestsApi extends BaseAPI {
    /**
     * List work requests. Brokers see the work requests they own. Operators see the ones offered to them by setting vendorID to their own hauler.
     * @summary List work requests
     * @param {WorkRequestsApiOperationsV1WorkRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1WorkRequestsGet(requestParameters = {}, options) {
        return WorkRequestsApiFp(this.configuration)
            .operationsV1WorkRequestsGet(requestParameters.subcontractEntityID, requestParameters.operatorEntityID, requestParameters.vendorID, requestParameters.status, requestParameters.sortDir, requestParameters.offset, requestParameters.limit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * APPROVED and REJECTED come from the hauler the work was offered to, or the broker on their behalf; CANCELLED comes from the broker and needs alliance-customer-service. Accepting moves the hauler\'s copy of the order out of NEEDS_REVIEW; rejecting or cancelling cancels it and puts the broker order back to UNASSIGNED_DELIVERY.
     * @summary Accept, reject, or cancel a work request
     * @param {WorkRequestsApiOperationsV1WorkRequestsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1WorkRequestsIdPut(requestParameters, options) {
        return WorkRequestsApiFp(this.configuration)
            .operationsV1WorkRequestsIdPut(requestParameters.id, requestParameters.workRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * alliance-customer-service only. Create a PENDING work request and the hauler\'s copy of the order, in NEEDS_REVIEW until they accept. Cancels any open work request on the order first. A Wayste-lite hauler is accepted straight away.
     * @summary Offer a subcontracted order to a hauler
     * @param {WorkRequestsApiOperationsV1WorkRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    operationsV1WorkRequestsPost(requestParameters, options) {
        return WorkRequestsApiFp(this.configuration)
            .operationsV1WorkRequestsPost(requestParameters.workRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
export const OperationsV1WorkRequestsGetSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
};
